/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.Auth = (function() {

    /**
     * Namespace Auth.
     * @exports Auth
     * @namespace
     */
    var Auth = {};

    Auth.CMD_Login = (function() {

        /**
         * Properties of a CMD_Login.
         * @memberof Auth
         * @interface ICMD_Login
         * @property {number|Long|null} [UserID] CMD_Login UserID
         * @property {string|null} [Password] CMD_Login Password
         * @property {string|null} [WeiXinCode] CMD_Login WeiXinCode
         * @property {string|null} [Platform] CMD_Login Platform
         * @property {number|null} [ProtoVersion] CMD_Login ProtoVersion
         * @property {string|null} [ClientVersion] CMD_Login ClientVersion
         * @property {string|null} [AppName] CMD_Login AppName
         * @property {boolean|null} [EnterGraySrv] CMD_Login EnterGraySrv
         * @property {string|null} [ExJsonStr] CMD_Login ExJsonStr
         * @property {number|null} [LoginType] CMD_Login LoginType
         * @property {string|null} [GameID] CMD_Login GameID
         * @property {string|null} [OpenID] CMD_Login OpenID
         * @property {string|null} [PlayerToken] CMD_Login PlayerToken
         * @property {string|null} [AccessToken] CMD_Login AccessToken
         * @property {string|null} [OpenKey] CMD_Login OpenKey
         * @property {string|null} [AppPlatrom] CMD_Login AppPlatrom
         * @property {string|null} [Language] CMD_Login Language
         */

        /**
         * Constructs a new CMD_Login.
         * @memberof Auth
         * @classdesc Represents a CMD_Login.
         * @implements ICMD_Login
         * @constructor
         * @param {Auth.ICMD_Login=} [properties] Properties to set
         */
        function CMD_Login(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_Login UserID.
         * @member {number|Long} UserID
         * @memberof Auth.CMD_Login
         * @instance
         */
        CMD_Login.prototype.UserID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CMD_Login Password.
         * @member {string} Password
         * @memberof Auth.CMD_Login
         * @instance
         */
        CMD_Login.prototype.Password = "";

        /**
         * CMD_Login WeiXinCode.
         * @member {string} WeiXinCode
         * @memberof Auth.CMD_Login
         * @instance
         */
        CMD_Login.prototype.WeiXinCode = "";

        /**
         * CMD_Login Platform.
         * @member {string} Platform
         * @memberof Auth.CMD_Login
         * @instance
         */
        CMD_Login.prototype.Platform = "";

        /**
         * CMD_Login ProtoVersion.
         * @member {number} ProtoVersion
         * @memberof Auth.CMD_Login
         * @instance
         */
        CMD_Login.prototype.ProtoVersion = 0;

        /**
         * CMD_Login ClientVersion.
         * @member {string} ClientVersion
         * @memberof Auth.CMD_Login
         * @instance
         */
        CMD_Login.prototype.ClientVersion = "";

        /**
         * CMD_Login AppName.
         * @member {string} AppName
         * @memberof Auth.CMD_Login
         * @instance
         */
        CMD_Login.prototype.AppName = "";

        /**
         * CMD_Login EnterGraySrv.
         * @member {boolean} EnterGraySrv
         * @memberof Auth.CMD_Login
         * @instance
         */
        CMD_Login.prototype.EnterGraySrv = false;

        /**
         * CMD_Login ExJsonStr.
         * @member {string} ExJsonStr
         * @memberof Auth.CMD_Login
         * @instance
         */
        CMD_Login.prototype.ExJsonStr = "";

        /**
         * CMD_Login LoginType.
         * @member {number} LoginType
         * @memberof Auth.CMD_Login
         * @instance
         */
        CMD_Login.prototype.LoginType = 0;

        /**
         * CMD_Login GameID.
         * @member {string} GameID
         * @memberof Auth.CMD_Login
         * @instance
         */
        CMD_Login.prototype.GameID = "";

        /**
         * CMD_Login OpenID.
         * @member {string} OpenID
         * @memberof Auth.CMD_Login
         * @instance
         */
        CMD_Login.prototype.OpenID = "";

        /**
         * CMD_Login PlayerToken.
         * @member {string} PlayerToken
         * @memberof Auth.CMD_Login
         * @instance
         */
        CMD_Login.prototype.PlayerToken = "";

        /**
         * CMD_Login AccessToken.
         * @member {string} AccessToken
         * @memberof Auth.CMD_Login
         * @instance
         */
        CMD_Login.prototype.AccessToken = "";

        /**
         * CMD_Login OpenKey.
         * @member {string} OpenKey
         * @memberof Auth.CMD_Login
         * @instance
         */
        CMD_Login.prototype.OpenKey = "";

        /**
         * CMD_Login AppPlatrom.
         * @member {string} AppPlatrom
         * @memberof Auth.CMD_Login
         * @instance
         */
        CMD_Login.prototype.AppPlatrom = "";

        /**
         * CMD_Login Language.
         * @member {string} Language
         * @memberof Auth.CMD_Login
         * @instance
         */
        CMD_Login.prototype.Language = "";

        /**
         * Creates a new CMD_Login instance using the specified properties.
         * @function create
         * @memberof Auth.CMD_Login
         * @static
         * @param {Auth.ICMD_Login=} [properties] Properties to set
         * @returns {Auth.CMD_Login} CMD_Login instance
         */
        CMD_Login.create = function create(properties) {
            return new CMD_Login(properties);
        };

        /**
         * Encodes the specified CMD_Login message. Does not implicitly {@link Auth.CMD_Login.verify|verify} messages.
         * @function encode
         * @memberof Auth.CMD_Login
         * @static
         * @param {Auth.ICMD_Login} message CMD_Login message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_Login.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.UserID);
            if (message.Password != null && message.hasOwnProperty("Password"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Password);
            if (message.WeiXinCode != null && message.hasOwnProperty("WeiXinCode"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.WeiXinCode);
            if (message.Platform != null && message.hasOwnProperty("Platform"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.Platform);
            if (message.ProtoVersion != null && message.hasOwnProperty("ProtoVersion"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.ProtoVersion);
            if (message.ClientVersion != null && message.hasOwnProperty("ClientVersion"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.ClientVersion);
            if (message.AppName != null && message.hasOwnProperty("AppName"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.AppName);
            if (message.EnterGraySrv != null && message.hasOwnProperty("EnterGraySrv"))
                writer.uint32(/* id 8, wireType 0 =*/64).bool(message.EnterGraySrv);
            if (message.ExJsonStr != null && message.hasOwnProperty("ExJsonStr"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.ExJsonStr);
            if (message.LoginType != null && message.hasOwnProperty("LoginType"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.LoginType);
            if (message.GameID != null && message.hasOwnProperty("GameID"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.GameID);
            if (message.OpenID != null && message.hasOwnProperty("OpenID"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.OpenID);
            if (message.PlayerToken != null && message.hasOwnProperty("PlayerToken"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.PlayerToken);
            if (message.AccessToken != null && message.hasOwnProperty("AccessToken"))
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.AccessToken);
            if (message.OpenKey != null && message.hasOwnProperty("OpenKey"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.OpenKey);
            if (message.AppPlatrom != null && message.hasOwnProperty("AppPlatrom"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.AppPlatrom);
            if (message.Language != null && message.hasOwnProperty("Language"))
                writer.uint32(/* id 18, wireType 2 =*/146).string(message.Language);
            return writer;
        };

        /**
         * Encodes the specified CMD_Login message, length delimited. Does not implicitly {@link Auth.CMD_Login.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.CMD_Login
         * @static
         * @param {Auth.ICMD_Login} message CMD_Login message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_Login.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_Login message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.CMD_Login
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.CMD_Login} CMD_Login
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_Login.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.CMD_Login();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.UserID = reader.uint64();
                    break;
                case 2:
                    message.Password = reader.string();
                    break;
                case 3:
                    message.WeiXinCode = reader.string();
                    break;
                case 4:
                    message.Platform = reader.string();
                    break;
                case 5:
                    message.ProtoVersion = reader.uint32();
                    break;
                case 6:
                    message.ClientVersion = reader.string();
                    break;
                case 7:
                    message.AppName = reader.string();
                    break;
                case 8:
                    message.EnterGraySrv = reader.bool();
                    break;
                case 9:
                    message.ExJsonStr = reader.string();
                    break;
                case 10:
                    message.LoginType = reader.int32();
                    break;
                case 11:
                    message.GameID = reader.string();
                    break;
                case 12:
                    message.OpenID = reader.string();
                    break;
                case 13:
                    message.PlayerToken = reader.string();
                    break;
                case 14:
                    message.AccessToken = reader.string();
                    break;
                case 15:
                    message.OpenKey = reader.string();
                    break;
                case 16:
                    message.AppPlatrom = reader.string();
                    break;
                case 18:
                    message.Language = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_Login message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.CMD_Login
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.CMD_Login} CMD_Login
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_Login.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_Login message.
         * @function verify
         * @memberof Auth.CMD_Login
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_Login.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (!$util.isInteger(message.UserID) && !(message.UserID && $util.isInteger(message.UserID.low) && $util.isInteger(message.UserID.high)))
                    return "UserID: integer|Long expected";
            if (message.Password != null && message.hasOwnProperty("Password"))
                if (!$util.isString(message.Password))
                    return "Password: string expected";
            if (message.WeiXinCode != null && message.hasOwnProperty("WeiXinCode"))
                if (!$util.isString(message.WeiXinCode))
                    return "WeiXinCode: string expected";
            if (message.Platform != null && message.hasOwnProperty("Platform"))
                if (!$util.isString(message.Platform))
                    return "Platform: string expected";
            if (message.ProtoVersion != null && message.hasOwnProperty("ProtoVersion"))
                if (!$util.isInteger(message.ProtoVersion))
                    return "ProtoVersion: integer expected";
            if (message.ClientVersion != null && message.hasOwnProperty("ClientVersion"))
                if (!$util.isString(message.ClientVersion))
                    return "ClientVersion: string expected";
            if (message.AppName != null && message.hasOwnProperty("AppName"))
                if (!$util.isString(message.AppName))
                    return "AppName: string expected";
            if (message.EnterGraySrv != null && message.hasOwnProperty("EnterGraySrv"))
                if (typeof message.EnterGraySrv !== "boolean")
                    return "EnterGraySrv: boolean expected";
            if (message.ExJsonStr != null && message.hasOwnProperty("ExJsonStr"))
                if (!$util.isString(message.ExJsonStr))
                    return "ExJsonStr: string expected";
            if (message.LoginType != null && message.hasOwnProperty("LoginType"))
                if (!$util.isInteger(message.LoginType))
                    return "LoginType: integer expected";
            if (message.GameID != null && message.hasOwnProperty("GameID"))
                if (!$util.isString(message.GameID))
                    return "GameID: string expected";
            if (message.OpenID != null && message.hasOwnProperty("OpenID"))
                if (!$util.isString(message.OpenID))
                    return "OpenID: string expected";
            if (message.PlayerToken != null && message.hasOwnProperty("PlayerToken"))
                if (!$util.isString(message.PlayerToken))
                    return "PlayerToken: string expected";
            if (message.AccessToken != null && message.hasOwnProperty("AccessToken"))
                if (!$util.isString(message.AccessToken))
                    return "AccessToken: string expected";
            if (message.OpenKey != null && message.hasOwnProperty("OpenKey"))
                if (!$util.isString(message.OpenKey))
                    return "OpenKey: string expected";
            if (message.AppPlatrom != null && message.hasOwnProperty("AppPlatrom"))
                if (!$util.isString(message.AppPlatrom))
                    return "AppPlatrom: string expected";
            if (message.Language != null && message.hasOwnProperty("Language"))
                if (!$util.isString(message.Language))
                    return "Language: string expected";
            return null;
        };

        /**
         * Creates a CMD_Login message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.CMD_Login
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.CMD_Login} CMD_Login
         */
        CMD_Login.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.CMD_Login)
                return object;
            var message = new $root.Auth.CMD_Login();
            if (object.UserID != null)
                if ($util.Long)
                    (message.UserID = $util.Long.fromValue(object.UserID)).unsigned = true;
                else if (typeof object.UserID === "string")
                    message.UserID = parseInt(object.UserID, 10);
                else if (typeof object.UserID === "number")
                    message.UserID = object.UserID;
                else if (typeof object.UserID === "object")
                    message.UserID = new $util.LongBits(object.UserID.low >>> 0, object.UserID.high >>> 0).toNumber(true);
            if (object.Password != null)
                message.Password = String(object.Password);
            if (object.WeiXinCode != null)
                message.WeiXinCode = String(object.WeiXinCode);
            if (object.Platform != null)
                message.Platform = String(object.Platform);
            if (object.ProtoVersion != null)
                message.ProtoVersion = object.ProtoVersion >>> 0;
            if (object.ClientVersion != null)
                message.ClientVersion = String(object.ClientVersion);
            if (object.AppName != null)
                message.AppName = String(object.AppName);
            if (object.EnterGraySrv != null)
                message.EnterGraySrv = Boolean(object.EnterGraySrv);
            if (object.ExJsonStr != null)
                message.ExJsonStr = String(object.ExJsonStr);
            if (object.LoginType != null)
                message.LoginType = object.LoginType | 0;
            if (object.GameID != null)
                message.GameID = String(object.GameID);
            if (object.OpenID != null)
                message.OpenID = String(object.OpenID);
            if (object.PlayerToken != null)
                message.PlayerToken = String(object.PlayerToken);
            if (object.AccessToken != null)
                message.AccessToken = String(object.AccessToken);
            if (object.OpenKey != null)
                message.OpenKey = String(object.OpenKey);
            if (object.AppPlatrom != null)
                message.AppPlatrom = String(object.AppPlatrom);
            if (object.Language != null)
                message.Language = String(object.Language);
            return message;
        };

        /**
         * Creates a plain object from a CMD_Login message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.CMD_Login
         * @static
         * @param {Auth.CMD_Login} message CMD_Login
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_Login.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.UserID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.UserID = options.longs === String ? "0" : 0;
                object.Password = "";
                object.WeiXinCode = "";
                object.Platform = "";
                object.ProtoVersion = 0;
                object.ClientVersion = "";
                object.AppName = "";
                object.EnterGraySrv = false;
                object.ExJsonStr = "";
                object.LoginType = 0;
                object.GameID = "";
                object.OpenID = "";
                object.PlayerToken = "";
                object.AccessToken = "";
                object.OpenKey = "";
                object.AppPlatrom = "";
                object.Language = "";
            }
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (typeof message.UserID === "number")
                    object.UserID = options.longs === String ? String(message.UserID) : message.UserID;
                else
                    object.UserID = options.longs === String ? $util.Long.prototype.toString.call(message.UserID) : options.longs === Number ? new $util.LongBits(message.UserID.low >>> 0, message.UserID.high >>> 0).toNumber(true) : message.UserID;
            if (message.Password != null && message.hasOwnProperty("Password"))
                object.Password = message.Password;
            if (message.WeiXinCode != null && message.hasOwnProperty("WeiXinCode"))
                object.WeiXinCode = message.WeiXinCode;
            if (message.Platform != null && message.hasOwnProperty("Platform"))
                object.Platform = message.Platform;
            if (message.ProtoVersion != null && message.hasOwnProperty("ProtoVersion"))
                object.ProtoVersion = message.ProtoVersion;
            if (message.ClientVersion != null && message.hasOwnProperty("ClientVersion"))
                object.ClientVersion = message.ClientVersion;
            if (message.AppName != null && message.hasOwnProperty("AppName"))
                object.AppName = message.AppName;
            if (message.EnterGraySrv != null && message.hasOwnProperty("EnterGraySrv"))
                object.EnterGraySrv = message.EnterGraySrv;
            if (message.ExJsonStr != null && message.hasOwnProperty("ExJsonStr"))
                object.ExJsonStr = message.ExJsonStr;
            if (message.LoginType != null && message.hasOwnProperty("LoginType"))
                object.LoginType = message.LoginType;
            if (message.GameID != null && message.hasOwnProperty("GameID"))
                object.GameID = message.GameID;
            if (message.OpenID != null && message.hasOwnProperty("OpenID"))
                object.OpenID = message.OpenID;
            if (message.PlayerToken != null && message.hasOwnProperty("PlayerToken"))
                object.PlayerToken = message.PlayerToken;
            if (message.AccessToken != null && message.hasOwnProperty("AccessToken"))
                object.AccessToken = message.AccessToken;
            if (message.OpenKey != null && message.hasOwnProperty("OpenKey"))
                object.OpenKey = message.OpenKey;
            if (message.AppPlatrom != null && message.hasOwnProperty("AppPlatrom"))
                object.AppPlatrom = message.AppPlatrom;
            if (message.Language != null && message.hasOwnProperty("Language"))
                object.Language = message.Language;
            return object;
        };

        /**
         * Converts this CMD_Login to JSON.
         * @function toJSON
         * @memberof Auth.CMD_Login
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_Login.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CMD_Login;
    })();

    Auth.RSP_Login = (function() {

        /**
         * Properties of a RSP_Login.
         * @memberof Auth
         * @interface IRSP_Login
         * @property {number|Long|null} [UserID] RSP_Login UserID
         * @property {string|null} [Password] RSP_Login Password
         * @property {number|null} [RoomID] RSP_Login RoomID
         * @property {string|null} [GameName] RSP_Login GameName
         * @property {string|null} [ErrorInfo] RSP_Login ErrorInfo
         * @property {number|null} [ErrorCode] RSP_Login ErrorCode
         * @property {string|null} [LoginEnv] RSP_Login LoginEnv
         * @property {string|null} [LoginArgs] RSP_Login LoginArgs
         * @property {string|null} [version] RSP_Login version
         * @property {string|null} [OMSRet] RSP_Login OMSRet
         */

        /**
         * Constructs a new RSP_Login.
         * @memberof Auth
         * @classdesc Represents a RSP_Login.
         * @implements IRSP_Login
         * @constructor
         * @param {Auth.IRSP_Login=} [properties] Properties to set
         */
        function RSP_Login(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RSP_Login UserID.
         * @member {number|Long} UserID
         * @memberof Auth.RSP_Login
         * @instance
         */
        RSP_Login.prototype.UserID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RSP_Login Password.
         * @member {string} Password
         * @memberof Auth.RSP_Login
         * @instance
         */
        RSP_Login.prototype.Password = "";

        /**
         * RSP_Login RoomID.
         * @member {number} RoomID
         * @memberof Auth.RSP_Login
         * @instance
         */
        RSP_Login.prototype.RoomID = 0;

        /**
         * RSP_Login GameName.
         * @member {string} GameName
         * @memberof Auth.RSP_Login
         * @instance
         */
        RSP_Login.prototype.GameName = "";

        /**
         * RSP_Login ErrorInfo.
         * @member {string} ErrorInfo
         * @memberof Auth.RSP_Login
         * @instance
         */
        RSP_Login.prototype.ErrorInfo = "";

        /**
         * RSP_Login ErrorCode.
         * @member {number} ErrorCode
         * @memberof Auth.RSP_Login
         * @instance
         */
        RSP_Login.prototype.ErrorCode = 0;

        /**
         * RSP_Login LoginEnv.
         * @member {string} LoginEnv
         * @memberof Auth.RSP_Login
         * @instance
         */
        RSP_Login.prototype.LoginEnv = "";

        /**
         * RSP_Login LoginArgs.
         * @member {string} LoginArgs
         * @memberof Auth.RSP_Login
         * @instance
         */
        RSP_Login.prototype.LoginArgs = "";

        /**
         * RSP_Login version.
         * @member {string} version
         * @memberof Auth.RSP_Login
         * @instance
         */
        RSP_Login.prototype.version = "";

        /**
         * RSP_Login OMSRet.
         * @member {string} OMSRet
         * @memberof Auth.RSP_Login
         * @instance
         */
        RSP_Login.prototype.OMSRet = "";

        /**
         * Creates a new RSP_Login instance using the specified properties.
         * @function create
         * @memberof Auth.RSP_Login
         * @static
         * @param {Auth.IRSP_Login=} [properties] Properties to set
         * @returns {Auth.RSP_Login} RSP_Login instance
         */
        RSP_Login.create = function create(properties) {
            return new RSP_Login(properties);
        };

        /**
         * Encodes the specified RSP_Login message. Does not implicitly {@link Auth.RSP_Login.verify|verify} messages.
         * @function encode
         * @memberof Auth.RSP_Login
         * @static
         * @param {Auth.IRSP_Login} message RSP_Login message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_Login.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.UserID);
            if (message.Password != null && message.hasOwnProperty("Password"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Password);
            if (message.RoomID != null && message.hasOwnProperty("RoomID"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.RoomID);
            if (message.GameName != null && message.hasOwnProperty("GameName"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.GameName);
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.ErrorInfo);
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.ErrorCode);
            if (message.LoginEnv != null && message.hasOwnProperty("LoginEnv"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.LoginEnv);
            if (message.LoginArgs != null && message.hasOwnProperty("LoginArgs"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.LoginArgs);
            if (message.version != null && message.hasOwnProperty("version"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.version);
            if (message.OMSRet != null && message.hasOwnProperty("OMSRet"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.OMSRet);
            return writer;
        };

        /**
         * Encodes the specified RSP_Login message, length delimited. Does not implicitly {@link Auth.RSP_Login.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.RSP_Login
         * @static
         * @param {Auth.IRSP_Login} message RSP_Login message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_Login.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RSP_Login message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.RSP_Login
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.RSP_Login} RSP_Login
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_Login.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.RSP_Login();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.UserID = reader.uint64();
                    break;
                case 2:
                    message.Password = reader.string();
                    break;
                case 3:
                    message.RoomID = reader.uint32();
                    break;
                case 4:
                    message.GameName = reader.string();
                    break;
                case 5:
                    message.ErrorInfo = reader.string();
                    break;
                case 6:
                    message.ErrorCode = reader.int32();
                    break;
                case 7:
                    message.LoginEnv = reader.string();
                    break;
                case 8:
                    message.LoginArgs = reader.string();
                    break;
                case 9:
                    message.version = reader.string();
                    break;
                case 10:
                    message.OMSRet = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RSP_Login message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.RSP_Login
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.RSP_Login} RSP_Login
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_Login.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RSP_Login message.
         * @function verify
         * @memberof Auth.RSP_Login
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RSP_Login.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (!$util.isInteger(message.UserID) && !(message.UserID && $util.isInteger(message.UserID.low) && $util.isInteger(message.UserID.high)))
                    return "UserID: integer|Long expected";
            if (message.Password != null && message.hasOwnProperty("Password"))
                if (!$util.isString(message.Password))
                    return "Password: string expected";
            if (message.RoomID != null && message.hasOwnProperty("RoomID"))
                if (!$util.isInteger(message.RoomID))
                    return "RoomID: integer expected";
            if (message.GameName != null && message.hasOwnProperty("GameName"))
                if (!$util.isString(message.GameName))
                    return "GameName: string expected";
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                if (!$util.isString(message.ErrorInfo))
                    return "ErrorInfo: string expected";
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                if (!$util.isInteger(message.ErrorCode))
                    return "ErrorCode: integer expected";
            if (message.LoginEnv != null && message.hasOwnProperty("LoginEnv"))
                if (!$util.isString(message.LoginEnv))
                    return "LoginEnv: string expected";
            if (message.LoginArgs != null && message.hasOwnProperty("LoginArgs"))
                if (!$util.isString(message.LoginArgs))
                    return "LoginArgs: string expected";
            if (message.version != null && message.hasOwnProperty("version"))
                if (!$util.isString(message.version))
                    return "version: string expected";
            if (message.OMSRet != null && message.hasOwnProperty("OMSRet"))
                if (!$util.isString(message.OMSRet))
                    return "OMSRet: string expected";
            return null;
        };

        /**
         * Creates a RSP_Login message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.RSP_Login
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.RSP_Login} RSP_Login
         */
        RSP_Login.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.RSP_Login)
                return object;
            var message = new $root.Auth.RSP_Login();
            if (object.UserID != null)
                if ($util.Long)
                    (message.UserID = $util.Long.fromValue(object.UserID)).unsigned = true;
                else if (typeof object.UserID === "string")
                    message.UserID = parseInt(object.UserID, 10);
                else if (typeof object.UserID === "number")
                    message.UserID = object.UserID;
                else if (typeof object.UserID === "object")
                    message.UserID = new $util.LongBits(object.UserID.low >>> 0, object.UserID.high >>> 0).toNumber(true);
            if (object.Password != null)
                message.Password = String(object.Password);
            if (object.RoomID != null)
                message.RoomID = object.RoomID >>> 0;
            if (object.GameName != null)
                message.GameName = String(object.GameName);
            if (object.ErrorInfo != null)
                message.ErrorInfo = String(object.ErrorInfo);
            if (object.ErrorCode != null)
                message.ErrorCode = object.ErrorCode | 0;
            if (object.LoginEnv != null)
                message.LoginEnv = String(object.LoginEnv);
            if (object.LoginArgs != null)
                message.LoginArgs = String(object.LoginArgs);
            if (object.version != null)
                message.version = String(object.version);
            if (object.OMSRet != null)
                message.OMSRet = String(object.OMSRet);
            return message;
        };

        /**
         * Creates a plain object from a RSP_Login message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.RSP_Login
         * @static
         * @param {Auth.RSP_Login} message RSP_Login
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RSP_Login.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.UserID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.UserID = options.longs === String ? "0" : 0;
                object.Password = "";
                object.RoomID = 0;
                object.GameName = "";
                object.ErrorInfo = "";
                object.ErrorCode = 0;
                object.LoginEnv = "";
                object.LoginArgs = "";
                object.version = "";
                object.OMSRet = "";
            }
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (typeof message.UserID === "number")
                    object.UserID = options.longs === String ? String(message.UserID) : message.UserID;
                else
                    object.UserID = options.longs === String ? $util.Long.prototype.toString.call(message.UserID) : options.longs === Number ? new $util.LongBits(message.UserID.low >>> 0, message.UserID.high >>> 0).toNumber(true) : message.UserID;
            if (message.Password != null && message.hasOwnProperty("Password"))
                object.Password = message.Password;
            if (message.RoomID != null && message.hasOwnProperty("RoomID"))
                object.RoomID = message.RoomID;
            if (message.GameName != null && message.hasOwnProperty("GameName"))
                object.GameName = message.GameName;
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                object.ErrorInfo = message.ErrorInfo;
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                object.ErrorCode = message.ErrorCode;
            if (message.LoginEnv != null && message.hasOwnProperty("LoginEnv"))
                object.LoginEnv = message.LoginEnv;
            if (message.LoginArgs != null && message.hasOwnProperty("LoginArgs"))
                object.LoginArgs = message.LoginArgs;
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            if (message.OMSRet != null && message.hasOwnProperty("OMSRet"))
                object.OMSRet = message.OMSRet;
            return object;
        };

        /**
         * Converts this RSP_Login to JSON.
         * @function toJSON
         * @memberof Auth.RSP_Login
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RSP_Login.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RSP_Login;
    })();

    Auth.CMD_CreateRoom = (function() {

        /**
         * Properties of a CMD_CreateRoom.
         * @memberof Auth
         * @interface ICMD_CreateRoom
         * @property {string|null} [GameName] CMD_CreateRoom GameName
         * @property {number|null} [RoundCount] CMD_CreateRoom RoundCount
         * @property {string|null} [Rule] CMD_CreateRoom Rule
         * @property {number|null} [HallID] CMD_CreateRoom HallID
         * @property {string|null} [ExJsonStr] CMD_CreateRoom ExJsonStr
         * @property {boolean|null} [IsGoldFieldRoom] CMD_CreateRoom IsGoldFieldRoom
         * @property {number|null} [BoxID] CMD_CreateRoom BoxID
         */

        /**
         * Constructs a new CMD_CreateRoom.
         * @memberof Auth
         * @classdesc Represents a CMD_CreateRoom.
         * @implements ICMD_CreateRoom
         * @constructor
         * @param {Auth.ICMD_CreateRoom=} [properties] Properties to set
         */
        function CMD_CreateRoom(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_CreateRoom GameName.
         * @member {string} GameName
         * @memberof Auth.CMD_CreateRoom
         * @instance
         */
        CMD_CreateRoom.prototype.GameName = "";

        /**
         * CMD_CreateRoom RoundCount.
         * @member {number} RoundCount
         * @memberof Auth.CMD_CreateRoom
         * @instance
         */
        CMD_CreateRoom.prototype.RoundCount = 0;

        /**
         * CMD_CreateRoom Rule.
         * @member {string} Rule
         * @memberof Auth.CMD_CreateRoom
         * @instance
         */
        CMD_CreateRoom.prototype.Rule = "";

        /**
         * CMD_CreateRoom HallID.
         * @member {number} HallID
         * @memberof Auth.CMD_CreateRoom
         * @instance
         */
        CMD_CreateRoom.prototype.HallID = 0;

        /**
         * CMD_CreateRoom ExJsonStr.
         * @member {string} ExJsonStr
         * @memberof Auth.CMD_CreateRoom
         * @instance
         */
        CMD_CreateRoom.prototype.ExJsonStr = "";

        /**
         * CMD_CreateRoom IsGoldFieldRoom.
         * @member {boolean} IsGoldFieldRoom
         * @memberof Auth.CMD_CreateRoom
         * @instance
         */
        CMD_CreateRoom.prototype.IsGoldFieldRoom = false;

        /**
         * CMD_CreateRoom BoxID.
         * @member {number} BoxID
         * @memberof Auth.CMD_CreateRoom
         * @instance
         */
        CMD_CreateRoom.prototype.BoxID = 0;

        /**
         * Creates a new CMD_CreateRoom instance using the specified properties.
         * @function create
         * @memberof Auth.CMD_CreateRoom
         * @static
         * @param {Auth.ICMD_CreateRoom=} [properties] Properties to set
         * @returns {Auth.CMD_CreateRoom} CMD_CreateRoom instance
         */
        CMD_CreateRoom.create = function create(properties) {
            return new CMD_CreateRoom(properties);
        };

        /**
         * Encodes the specified CMD_CreateRoom message. Does not implicitly {@link Auth.CMD_CreateRoom.verify|verify} messages.
         * @function encode
         * @memberof Auth.CMD_CreateRoom
         * @static
         * @param {Auth.ICMD_CreateRoom} message CMD_CreateRoom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CreateRoom.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.GameName != null && message.hasOwnProperty("GameName"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.GameName);
            if (message.RoundCount != null && message.hasOwnProperty("RoundCount"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.RoundCount);
            if (message.Rule != null && message.hasOwnProperty("Rule"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Rule);
            if (message.HallID != null && message.hasOwnProperty("HallID"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.HallID);
            if (message.ExJsonStr != null && message.hasOwnProperty("ExJsonStr"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.ExJsonStr);
            if (message.IsGoldFieldRoom != null && message.hasOwnProperty("IsGoldFieldRoom"))
                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.IsGoldFieldRoom);
            if (message.BoxID != null && message.hasOwnProperty("BoxID"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.BoxID);
            return writer;
        };

        /**
         * Encodes the specified CMD_CreateRoom message, length delimited. Does not implicitly {@link Auth.CMD_CreateRoom.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.CMD_CreateRoom
         * @static
         * @param {Auth.ICMD_CreateRoom} message CMD_CreateRoom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_CreateRoom.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_CreateRoom message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.CMD_CreateRoom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.CMD_CreateRoom} CMD_CreateRoom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CreateRoom.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.CMD_CreateRoom();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.GameName = reader.string();
                    break;
                case 2:
                    message.RoundCount = reader.uint32();
                    break;
                case 3:
                    message.Rule = reader.string();
                    break;
                case 4:
                    message.HallID = reader.uint32();
                    break;
                case 5:
                    message.ExJsonStr = reader.string();
                    break;
                case 6:
                    message.IsGoldFieldRoom = reader.bool();
                    break;
                case 7:
                    message.BoxID = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_CreateRoom message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.CMD_CreateRoom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.CMD_CreateRoom} CMD_CreateRoom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_CreateRoom.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_CreateRoom message.
         * @function verify
         * @memberof Auth.CMD_CreateRoom
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_CreateRoom.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.GameName != null && message.hasOwnProperty("GameName"))
                if (!$util.isString(message.GameName))
                    return "GameName: string expected";
            if (message.RoundCount != null && message.hasOwnProperty("RoundCount"))
                if (!$util.isInteger(message.RoundCount))
                    return "RoundCount: integer expected";
            if (message.Rule != null && message.hasOwnProperty("Rule"))
                if (!$util.isString(message.Rule))
                    return "Rule: string expected";
            if (message.HallID != null && message.hasOwnProperty("HallID"))
                if (!$util.isInteger(message.HallID))
                    return "HallID: integer expected";
            if (message.ExJsonStr != null && message.hasOwnProperty("ExJsonStr"))
                if (!$util.isString(message.ExJsonStr))
                    return "ExJsonStr: string expected";
            if (message.IsGoldFieldRoom != null && message.hasOwnProperty("IsGoldFieldRoom"))
                if (typeof message.IsGoldFieldRoom !== "boolean")
                    return "IsGoldFieldRoom: boolean expected";
            if (message.BoxID != null && message.hasOwnProperty("BoxID"))
                if (!$util.isInteger(message.BoxID))
                    return "BoxID: integer expected";
            return null;
        };

        /**
         * Creates a CMD_CreateRoom message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.CMD_CreateRoom
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.CMD_CreateRoom} CMD_CreateRoom
         */
        CMD_CreateRoom.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.CMD_CreateRoom)
                return object;
            var message = new $root.Auth.CMD_CreateRoom();
            if (object.GameName != null)
                message.GameName = String(object.GameName);
            if (object.RoundCount != null)
                message.RoundCount = object.RoundCount >>> 0;
            if (object.Rule != null)
                message.Rule = String(object.Rule);
            if (object.HallID != null)
                message.HallID = object.HallID >>> 0;
            if (object.ExJsonStr != null)
                message.ExJsonStr = String(object.ExJsonStr);
            if (object.IsGoldFieldRoom != null)
                message.IsGoldFieldRoom = Boolean(object.IsGoldFieldRoom);
            if (object.BoxID != null)
                message.BoxID = object.BoxID >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a CMD_CreateRoom message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.CMD_CreateRoom
         * @static
         * @param {Auth.CMD_CreateRoom} message CMD_CreateRoom
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_CreateRoom.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.GameName = "";
                object.RoundCount = 0;
                object.Rule = "";
                object.HallID = 0;
                object.ExJsonStr = "";
                object.IsGoldFieldRoom = false;
                object.BoxID = 0;
            }
            if (message.GameName != null && message.hasOwnProperty("GameName"))
                object.GameName = message.GameName;
            if (message.RoundCount != null && message.hasOwnProperty("RoundCount"))
                object.RoundCount = message.RoundCount;
            if (message.Rule != null && message.hasOwnProperty("Rule"))
                object.Rule = message.Rule;
            if (message.HallID != null && message.hasOwnProperty("HallID"))
                object.HallID = message.HallID;
            if (message.ExJsonStr != null && message.hasOwnProperty("ExJsonStr"))
                object.ExJsonStr = message.ExJsonStr;
            if (message.IsGoldFieldRoom != null && message.hasOwnProperty("IsGoldFieldRoom"))
                object.IsGoldFieldRoom = message.IsGoldFieldRoom;
            if (message.BoxID != null && message.hasOwnProperty("BoxID"))
                object.BoxID = message.BoxID;
            return object;
        };

        /**
         * Converts this CMD_CreateRoom to JSON.
         * @function toJSON
         * @memberof Auth.CMD_CreateRoom
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_CreateRoom.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CMD_CreateRoom;
    })();

    Auth.RSP_CreateRoom = (function() {

        /**
         * Properties of a RSP_CreateRoom.
         * @memberof Auth
         * @interface IRSP_CreateRoom
         * @property {number|null} [RoomID] RSP_CreateRoom RoomID
         * @property {string|null} [ServerHost] RSP_CreateRoom ServerHost
         * @property {number|null} [ServerPort] RSP_CreateRoom ServerPort
         * @property {number|null} [SeatID] RSP_CreateRoom SeatID
         * @property {string|null} [Password] RSP_CreateRoom Password
         * @property {string|null} [ErrorInfo] RSP_CreateRoom ErrorInfo
         * @property {number|Long|null} [Token] RSP_CreateRoom Token
         * @property {number|null} [HallID] RSP_CreateRoom HallID
         * @property {number|null} [RoomType] RSP_CreateRoom RoomType
         * @property {number|null} [wsport] RSP_CreateRoom wsport
         * @property {number|null} [ErrorCode] RSP_CreateRoom ErrorCode
         * @property {number|null} [BoxID] RSP_CreateRoom BoxID
         * @property {number|null} [RoomHisID] RSP_CreateRoom RoomHisID
         */

        /**
         * Constructs a new RSP_CreateRoom.
         * @memberof Auth
         * @classdesc Represents a RSP_CreateRoom.
         * @implements IRSP_CreateRoom
         * @constructor
         * @param {Auth.IRSP_CreateRoom=} [properties] Properties to set
         */
        function RSP_CreateRoom(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RSP_CreateRoom RoomID.
         * @member {number} RoomID
         * @memberof Auth.RSP_CreateRoom
         * @instance
         */
        RSP_CreateRoom.prototype.RoomID = 0;

        /**
         * RSP_CreateRoom ServerHost.
         * @member {string} ServerHost
         * @memberof Auth.RSP_CreateRoom
         * @instance
         */
        RSP_CreateRoom.prototype.ServerHost = "";

        /**
         * RSP_CreateRoom ServerPort.
         * @member {number} ServerPort
         * @memberof Auth.RSP_CreateRoom
         * @instance
         */
        RSP_CreateRoom.prototype.ServerPort = 0;

        /**
         * RSP_CreateRoom SeatID.
         * @member {number} SeatID
         * @memberof Auth.RSP_CreateRoom
         * @instance
         */
        RSP_CreateRoom.prototype.SeatID = 0;

        /**
         * RSP_CreateRoom Password.
         * @member {string} Password
         * @memberof Auth.RSP_CreateRoom
         * @instance
         */
        RSP_CreateRoom.prototype.Password = "";

        /**
         * RSP_CreateRoom ErrorInfo.
         * @member {string} ErrorInfo
         * @memberof Auth.RSP_CreateRoom
         * @instance
         */
        RSP_CreateRoom.prototype.ErrorInfo = "";

        /**
         * RSP_CreateRoom Token.
         * @member {number|Long} Token
         * @memberof Auth.RSP_CreateRoom
         * @instance
         */
        RSP_CreateRoom.prototype.Token = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RSP_CreateRoom HallID.
         * @member {number} HallID
         * @memberof Auth.RSP_CreateRoom
         * @instance
         */
        RSP_CreateRoom.prototype.HallID = 0;

        /**
         * RSP_CreateRoom RoomType.
         * @member {number} RoomType
         * @memberof Auth.RSP_CreateRoom
         * @instance
         */
        RSP_CreateRoom.prototype.RoomType = 0;

        /**
         * RSP_CreateRoom wsport.
         * @member {number} wsport
         * @memberof Auth.RSP_CreateRoom
         * @instance
         */
        RSP_CreateRoom.prototype.wsport = 0;

        /**
         * RSP_CreateRoom ErrorCode.
         * @member {number} ErrorCode
         * @memberof Auth.RSP_CreateRoom
         * @instance
         */
        RSP_CreateRoom.prototype.ErrorCode = 0;

        /**
         * RSP_CreateRoom BoxID.
         * @member {number} BoxID
         * @memberof Auth.RSP_CreateRoom
         * @instance
         */
        RSP_CreateRoom.prototype.BoxID = 0;

        /**
         * RSP_CreateRoom RoomHisID.
         * @member {number} RoomHisID
         * @memberof Auth.RSP_CreateRoom
         * @instance
         */
        RSP_CreateRoom.prototype.RoomHisID = 0;

        /**
         * Creates a new RSP_CreateRoom instance using the specified properties.
         * @function create
         * @memberof Auth.RSP_CreateRoom
         * @static
         * @param {Auth.IRSP_CreateRoom=} [properties] Properties to set
         * @returns {Auth.RSP_CreateRoom} RSP_CreateRoom instance
         */
        RSP_CreateRoom.create = function create(properties) {
            return new RSP_CreateRoom(properties);
        };

        /**
         * Encodes the specified RSP_CreateRoom message. Does not implicitly {@link Auth.RSP_CreateRoom.verify|verify} messages.
         * @function encode
         * @memberof Auth.RSP_CreateRoom
         * @static
         * @param {Auth.IRSP_CreateRoom} message RSP_CreateRoom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_CreateRoom.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.RoomID != null && message.hasOwnProperty("RoomID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.RoomID);
            if (message.ServerHost != null && message.hasOwnProperty("ServerHost"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.ServerHost);
            if (message.ServerPort != null && message.hasOwnProperty("ServerPort"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.ServerPort);
            if (message.SeatID != null && message.hasOwnProperty("SeatID"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.SeatID);
            if (message.Password != null && message.hasOwnProperty("Password"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.Password);
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.ErrorInfo);
            if (message.Token != null && message.hasOwnProperty("Token"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint64(message.Token);
            if (message.HallID != null && message.hasOwnProperty("HallID"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.HallID);
            if (message.RoomType != null && message.hasOwnProperty("RoomType"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.RoomType);
            if (message.wsport != null && message.hasOwnProperty("wsport"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.wsport);
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.ErrorCode);
            if (message.BoxID != null && message.hasOwnProperty("BoxID"))
                writer.uint32(/* id 12, wireType 0 =*/96).uint32(message.BoxID);
            if (message.RoomHisID != null && message.hasOwnProperty("RoomHisID"))
                writer.uint32(/* id 13, wireType 0 =*/104).uint32(message.RoomHisID);
            return writer;
        };

        /**
         * Encodes the specified RSP_CreateRoom message, length delimited. Does not implicitly {@link Auth.RSP_CreateRoom.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.RSP_CreateRoom
         * @static
         * @param {Auth.IRSP_CreateRoom} message RSP_CreateRoom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_CreateRoom.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RSP_CreateRoom message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.RSP_CreateRoom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.RSP_CreateRoom} RSP_CreateRoom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_CreateRoom.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.RSP_CreateRoom();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.RoomID = reader.uint32();
                    break;
                case 2:
                    message.ServerHost = reader.string();
                    break;
                case 3:
                    message.ServerPort = reader.int32();
                    break;
                case 4:
                    message.SeatID = reader.uint32();
                    break;
                case 5:
                    message.Password = reader.string();
                    break;
                case 6:
                    message.ErrorInfo = reader.string();
                    break;
                case 7:
                    message.Token = reader.uint64();
                    break;
                case 8:
                    message.HallID = reader.uint32();
                    break;
                case 9:
                    message.RoomType = reader.int32();
                    break;
                case 10:
                    message.wsport = reader.int32();
                    break;
                case 11:
                    message.ErrorCode = reader.int32();
                    break;
                case 12:
                    message.BoxID = reader.uint32();
                    break;
                case 13:
                    message.RoomHisID = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RSP_CreateRoom message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.RSP_CreateRoom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.RSP_CreateRoom} RSP_CreateRoom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_CreateRoom.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RSP_CreateRoom message.
         * @function verify
         * @memberof Auth.RSP_CreateRoom
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RSP_CreateRoom.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.RoomID != null && message.hasOwnProperty("RoomID"))
                if (!$util.isInteger(message.RoomID))
                    return "RoomID: integer expected";
            if (message.ServerHost != null && message.hasOwnProperty("ServerHost"))
                if (!$util.isString(message.ServerHost))
                    return "ServerHost: string expected";
            if (message.ServerPort != null && message.hasOwnProperty("ServerPort"))
                if (!$util.isInteger(message.ServerPort))
                    return "ServerPort: integer expected";
            if (message.SeatID != null && message.hasOwnProperty("SeatID"))
                if (!$util.isInteger(message.SeatID))
                    return "SeatID: integer expected";
            if (message.Password != null && message.hasOwnProperty("Password"))
                if (!$util.isString(message.Password))
                    return "Password: string expected";
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                if (!$util.isString(message.ErrorInfo))
                    return "ErrorInfo: string expected";
            if (message.Token != null && message.hasOwnProperty("Token"))
                if (!$util.isInteger(message.Token) && !(message.Token && $util.isInteger(message.Token.low) && $util.isInteger(message.Token.high)))
                    return "Token: integer|Long expected";
            if (message.HallID != null && message.hasOwnProperty("HallID"))
                if (!$util.isInteger(message.HallID))
                    return "HallID: integer expected";
            if (message.RoomType != null && message.hasOwnProperty("RoomType"))
                if (!$util.isInteger(message.RoomType))
                    return "RoomType: integer expected";
            if (message.wsport != null && message.hasOwnProperty("wsport"))
                if (!$util.isInteger(message.wsport))
                    return "wsport: integer expected";
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                if (!$util.isInteger(message.ErrorCode))
                    return "ErrorCode: integer expected";
            if (message.BoxID != null && message.hasOwnProperty("BoxID"))
                if (!$util.isInteger(message.BoxID))
                    return "BoxID: integer expected";
            if (message.RoomHisID != null && message.hasOwnProperty("RoomHisID"))
                if (!$util.isInteger(message.RoomHisID))
                    return "RoomHisID: integer expected";
            return null;
        };

        /**
         * Creates a RSP_CreateRoom message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.RSP_CreateRoom
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.RSP_CreateRoom} RSP_CreateRoom
         */
        RSP_CreateRoom.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.RSP_CreateRoom)
                return object;
            var message = new $root.Auth.RSP_CreateRoom();
            if (object.RoomID != null)
                message.RoomID = object.RoomID >>> 0;
            if (object.ServerHost != null)
                message.ServerHost = String(object.ServerHost);
            if (object.ServerPort != null)
                message.ServerPort = object.ServerPort | 0;
            if (object.SeatID != null)
                message.SeatID = object.SeatID >>> 0;
            if (object.Password != null)
                message.Password = String(object.Password);
            if (object.ErrorInfo != null)
                message.ErrorInfo = String(object.ErrorInfo);
            if (object.Token != null)
                if ($util.Long)
                    (message.Token = $util.Long.fromValue(object.Token)).unsigned = true;
                else if (typeof object.Token === "string")
                    message.Token = parseInt(object.Token, 10);
                else if (typeof object.Token === "number")
                    message.Token = object.Token;
                else if (typeof object.Token === "object")
                    message.Token = new $util.LongBits(object.Token.low >>> 0, object.Token.high >>> 0).toNumber(true);
            if (object.HallID != null)
                message.HallID = object.HallID >>> 0;
            if (object.RoomType != null)
                message.RoomType = object.RoomType | 0;
            if (object.wsport != null)
                message.wsport = object.wsport | 0;
            if (object.ErrorCode != null)
                message.ErrorCode = object.ErrorCode | 0;
            if (object.BoxID != null)
                message.BoxID = object.BoxID >>> 0;
            if (object.RoomHisID != null)
                message.RoomHisID = object.RoomHisID >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a RSP_CreateRoom message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.RSP_CreateRoom
         * @static
         * @param {Auth.RSP_CreateRoom} message RSP_CreateRoom
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RSP_CreateRoom.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.RoomID = 0;
                object.ServerHost = "";
                object.ServerPort = 0;
                object.SeatID = 0;
                object.Password = "";
                object.ErrorInfo = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.Token = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.Token = options.longs === String ? "0" : 0;
                object.HallID = 0;
                object.RoomType = 0;
                object.wsport = 0;
                object.ErrorCode = 0;
                object.BoxID = 0;
                object.RoomHisID = 0;
            }
            if (message.RoomID != null && message.hasOwnProperty("RoomID"))
                object.RoomID = message.RoomID;
            if (message.ServerHost != null && message.hasOwnProperty("ServerHost"))
                object.ServerHost = message.ServerHost;
            if (message.ServerPort != null && message.hasOwnProperty("ServerPort"))
                object.ServerPort = message.ServerPort;
            if (message.SeatID != null && message.hasOwnProperty("SeatID"))
                object.SeatID = message.SeatID;
            if (message.Password != null && message.hasOwnProperty("Password"))
                object.Password = message.Password;
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                object.ErrorInfo = message.ErrorInfo;
            if (message.Token != null && message.hasOwnProperty("Token"))
                if (typeof message.Token === "number")
                    object.Token = options.longs === String ? String(message.Token) : message.Token;
                else
                    object.Token = options.longs === String ? $util.Long.prototype.toString.call(message.Token) : options.longs === Number ? new $util.LongBits(message.Token.low >>> 0, message.Token.high >>> 0).toNumber(true) : message.Token;
            if (message.HallID != null && message.hasOwnProperty("HallID"))
                object.HallID = message.HallID;
            if (message.RoomType != null && message.hasOwnProperty("RoomType"))
                object.RoomType = message.RoomType;
            if (message.wsport != null && message.hasOwnProperty("wsport"))
                object.wsport = message.wsport;
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                object.ErrorCode = message.ErrorCode;
            if (message.BoxID != null && message.hasOwnProperty("BoxID"))
                object.BoxID = message.BoxID;
            if (message.RoomHisID != null && message.hasOwnProperty("RoomHisID"))
                object.RoomHisID = message.RoomHisID;
            return object;
        };

        /**
         * Converts this RSP_CreateRoom to JSON.
         * @function toJSON
         * @memberof Auth.RSP_CreateRoom
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RSP_CreateRoom.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RSP_CreateRoom;
    })();

    Auth.CMD_EnterRoom = (function() {

        /**
         * Properties of a CMD_EnterRoom.
         * @memberof Auth
         * @interface ICMD_EnterRoom
         * @property {number|null} [RoomID] CMD_EnterRoom RoomID
         * @property {string|null} [GameName] CMD_EnterRoom GameName
         * @property {number|null} [MatchID] CMD_EnterRoom MatchID
         * @property {number|null} [MatchAwardRank] CMD_EnterRoom MatchAwardRank
         * @property {number|null} [GoldFieldID] CMD_EnterRoom GoldFieldID
         * @property {string|null} [ExJsonStr] CMD_EnterRoom ExJsonStr
         * @property {number|null} [PrevRoomNum] CMD_EnterRoom PrevRoomNum
         * @property {number|null} [BoxID] CMD_EnterRoom BoxID
         * @property {boolean|null} [EnterNewRoom] CMD_EnterRoom EnterNewRoom
         * @property {number|null} [RoomIx] CMD_EnterRoom RoomIx
         * @property {number|null} [ChannelID] CMD_EnterRoom ChannelID
         */

        /**
         * Constructs a new CMD_EnterRoom.
         * @memberof Auth
         * @classdesc Represents a CMD_EnterRoom.
         * @implements ICMD_EnterRoom
         * @constructor
         * @param {Auth.ICMD_EnterRoom=} [properties] Properties to set
         */
        function CMD_EnterRoom(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_EnterRoom RoomID.
         * @member {number} RoomID
         * @memberof Auth.CMD_EnterRoom
         * @instance
         */
        CMD_EnterRoom.prototype.RoomID = 0;

        /**
         * CMD_EnterRoom GameName.
         * @member {string} GameName
         * @memberof Auth.CMD_EnterRoom
         * @instance
         */
        CMD_EnterRoom.prototype.GameName = "";

        /**
         * CMD_EnterRoom MatchID.
         * @member {number} MatchID
         * @memberof Auth.CMD_EnterRoom
         * @instance
         */
        CMD_EnterRoom.prototype.MatchID = 0;

        /**
         * CMD_EnterRoom MatchAwardRank.
         * @member {number} MatchAwardRank
         * @memberof Auth.CMD_EnterRoom
         * @instance
         */
        CMD_EnterRoom.prototype.MatchAwardRank = 0;

        /**
         * CMD_EnterRoom GoldFieldID.
         * @member {number} GoldFieldID
         * @memberof Auth.CMD_EnterRoom
         * @instance
         */
        CMD_EnterRoom.prototype.GoldFieldID = 0;

        /**
         * CMD_EnterRoom ExJsonStr.
         * @member {string} ExJsonStr
         * @memberof Auth.CMD_EnterRoom
         * @instance
         */
        CMD_EnterRoom.prototype.ExJsonStr = "";

        /**
         * CMD_EnterRoom PrevRoomNum.
         * @member {number} PrevRoomNum
         * @memberof Auth.CMD_EnterRoom
         * @instance
         */
        CMD_EnterRoom.prototype.PrevRoomNum = 0;

        /**
         * CMD_EnterRoom BoxID.
         * @member {number} BoxID
         * @memberof Auth.CMD_EnterRoom
         * @instance
         */
        CMD_EnterRoom.prototype.BoxID = 0;

        /**
         * CMD_EnterRoom EnterNewRoom.
         * @member {boolean} EnterNewRoom
         * @memberof Auth.CMD_EnterRoom
         * @instance
         */
        CMD_EnterRoom.prototype.EnterNewRoom = false;

        /**
         * CMD_EnterRoom RoomIx.
         * @member {number} RoomIx
         * @memberof Auth.CMD_EnterRoom
         * @instance
         */
        CMD_EnterRoom.prototype.RoomIx = 0;

        /**
         * CMD_EnterRoom ChannelID.
         * @member {number} ChannelID
         * @memberof Auth.CMD_EnterRoom
         * @instance
         */
        CMD_EnterRoom.prototype.ChannelID = 0;

        /**
         * Creates a new CMD_EnterRoom instance using the specified properties.
         * @function create
         * @memberof Auth.CMD_EnterRoom
         * @static
         * @param {Auth.ICMD_EnterRoom=} [properties] Properties to set
         * @returns {Auth.CMD_EnterRoom} CMD_EnterRoom instance
         */
        CMD_EnterRoom.create = function create(properties) {
            return new CMD_EnterRoom(properties);
        };

        /**
         * Encodes the specified CMD_EnterRoom message. Does not implicitly {@link Auth.CMD_EnterRoom.verify|verify} messages.
         * @function encode
         * @memberof Auth.CMD_EnterRoom
         * @static
         * @param {Auth.ICMD_EnterRoom} message CMD_EnterRoom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_EnterRoom.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.RoomID != null && message.hasOwnProperty("RoomID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.RoomID);
            if (message.GameName != null && message.hasOwnProperty("GameName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.GameName);
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.MatchID);
            if (message.MatchAwardRank != null && message.hasOwnProperty("MatchAwardRank"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.MatchAwardRank);
            if (message.GoldFieldID != null && message.hasOwnProperty("GoldFieldID"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.GoldFieldID);
            if (message.ExJsonStr != null && message.hasOwnProperty("ExJsonStr"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.ExJsonStr);
            if (message.PrevRoomNum != null && message.hasOwnProperty("PrevRoomNum"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.PrevRoomNum);
            if (message.BoxID != null && message.hasOwnProperty("BoxID"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.BoxID);
            if (message.EnterNewRoom != null && message.hasOwnProperty("EnterNewRoom"))
                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.EnterNewRoom);
            if (message.RoomIx != null && message.hasOwnProperty("RoomIx"))
                writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.RoomIx);
            if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
                writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.ChannelID);
            return writer;
        };

        /**
         * Encodes the specified CMD_EnterRoom message, length delimited. Does not implicitly {@link Auth.CMD_EnterRoom.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.CMD_EnterRoom
         * @static
         * @param {Auth.ICMD_EnterRoom} message CMD_EnterRoom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_EnterRoom.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_EnterRoom message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.CMD_EnterRoom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.CMD_EnterRoom} CMD_EnterRoom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_EnterRoom.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.CMD_EnterRoom();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.RoomID = reader.uint32();
                    break;
                case 2:
                    message.GameName = reader.string();
                    break;
                case 3:
                    message.MatchID = reader.uint32();
                    break;
                case 4:
                    message.MatchAwardRank = reader.int32();
                    break;
                case 5:
                    message.GoldFieldID = reader.uint32();
                    break;
                case 6:
                    message.ExJsonStr = reader.string();
                    break;
                case 7:
                    message.PrevRoomNum = reader.uint32();
                    break;
                case 8:
                    message.BoxID = reader.uint32();
                    break;
                case 9:
                    message.EnterNewRoom = reader.bool();
                    break;
                case 10:
                    message.RoomIx = reader.uint32();
                    break;
                case 11:
                    message.ChannelID = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_EnterRoom message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.CMD_EnterRoom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.CMD_EnterRoom} CMD_EnterRoom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_EnterRoom.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_EnterRoom message.
         * @function verify
         * @memberof Auth.CMD_EnterRoom
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_EnterRoom.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.RoomID != null && message.hasOwnProperty("RoomID"))
                if (!$util.isInteger(message.RoomID))
                    return "RoomID: integer expected";
            if (message.GameName != null && message.hasOwnProperty("GameName"))
                if (!$util.isString(message.GameName))
                    return "GameName: string expected";
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                if (!$util.isInteger(message.MatchID))
                    return "MatchID: integer expected";
            if (message.MatchAwardRank != null && message.hasOwnProperty("MatchAwardRank"))
                if (!$util.isInteger(message.MatchAwardRank))
                    return "MatchAwardRank: integer expected";
            if (message.GoldFieldID != null && message.hasOwnProperty("GoldFieldID"))
                if (!$util.isInteger(message.GoldFieldID))
                    return "GoldFieldID: integer expected";
            if (message.ExJsonStr != null && message.hasOwnProperty("ExJsonStr"))
                if (!$util.isString(message.ExJsonStr))
                    return "ExJsonStr: string expected";
            if (message.PrevRoomNum != null && message.hasOwnProperty("PrevRoomNum"))
                if (!$util.isInteger(message.PrevRoomNum))
                    return "PrevRoomNum: integer expected";
            if (message.BoxID != null && message.hasOwnProperty("BoxID"))
                if (!$util.isInteger(message.BoxID))
                    return "BoxID: integer expected";
            if (message.EnterNewRoom != null && message.hasOwnProperty("EnterNewRoom"))
                if (typeof message.EnterNewRoom !== "boolean")
                    return "EnterNewRoom: boolean expected";
            if (message.RoomIx != null && message.hasOwnProperty("RoomIx"))
                if (!$util.isInteger(message.RoomIx))
                    return "RoomIx: integer expected";
            if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
                if (!$util.isInteger(message.ChannelID))
                    return "ChannelID: integer expected";
            return null;
        };

        /**
         * Creates a CMD_EnterRoom message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.CMD_EnterRoom
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.CMD_EnterRoom} CMD_EnterRoom
         */
        CMD_EnterRoom.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.CMD_EnterRoom)
                return object;
            var message = new $root.Auth.CMD_EnterRoom();
            if (object.RoomID != null)
                message.RoomID = object.RoomID >>> 0;
            if (object.GameName != null)
                message.GameName = String(object.GameName);
            if (object.MatchID != null)
                message.MatchID = object.MatchID >>> 0;
            if (object.MatchAwardRank != null)
                message.MatchAwardRank = object.MatchAwardRank | 0;
            if (object.GoldFieldID != null)
                message.GoldFieldID = object.GoldFieldID >>> 0;
            if (object.ExJsonStr != null)
                message.ExJsonStr = String(object.ExJsonStr);
            if (object.PrevRoomNum != null)
                message.PrevRoomNum = object.PrevRoomNum >>> 0;
            if (object.BoxID != null)
                message.BoxID = object.BoxID >>> 0;
            if (object.EnterNewRoom != null)
                message.EnterNewRoom = Boolean(object.EnterNewRoom);
            if (object.RoomIx != null)
                message.RoomIx = object.RoomIx >>> 0;
            if (object.ChannelID != null)
                message.ChannelID = object.ChannelID >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a CMD_EnterRoom message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.CMD_EnterRoom
         * @static
         * @param {Auth.CMD_EnterRoom} message CMD_EnterRoom
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_EnterRoom.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.RoomID = 0;
                object.GameName = "";
                object.MatchID = 0;
                object.MatchAwardRank = 0;
                object.GoldFieldID = 0;
                object.ExJsonStr = "";
                object.PrevRoomNum = 0;
                object.BoxID = 0;
                object.EnterNewRoom = false;
                object.RoomIx = 0;
                object.ChannelID = 0;
            }
            if (message.RoomID != null && message.hasOwnProperty("RoomID"))
                object.RoomID = message.RoomID;
            if (message.GameName != null && message.hasOwnProperty("GameName"))
                object.GameName = message.GameName;
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                object.MatchID = message.MatchID;
            if (message.MatchAwardRank != null && message.hasOwnProperty("MatchAwardRank"))
                object.MatchAwardRank = message.MatchAwardRank;
            if (message.GoldFieldID != null && message.hasOwnProperty("GoldFieldID"))
                object.GoldFieldID = message.GoldFieldID;
            if (message.ExJsonStr != null && message.hasOwnProperty("ExJsonStr"))
                object.ExJsonStr = message.ExJsonStr;
            if (message.PrevRoomNum != null && message.hasOwnProperty("PrevRoomNum"))
                object.PrevRoomNum = message.PrevRoomNum;
            if (message.BoxID != null && message.hasOwnProperty("BoxID"))
                object.BoxID = message.BoxID;
            if (message.EnterNewRoom != null && message.hasOwnProperty("EnterNewRoom"))
                object.EnterNewRoom = message.EnterNewRoom;
            if (message.RoomIx != null && message.hasOwnProperty("RoomIx"))
                object.RoomIx = message.RoomIx;
            if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
                object.ChannelID = message.ChannelID;
            return object;
        };

        /**
         * Converts this CMD_EnterRoom to JSON.
         * @function toJSON
         * @memberof Auth.CMD_EnterRoom
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_EnterRoom.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CMD_EnterRoom;
    })();

    Auth.RSP_EnterRoom = (function() {

        /**
         * Properties of a RSP_EnterRoom.
         * @memberof Auth
         * @interface IRSP_EnterRoom
         * @property {number|null} [ErrorCode] RSP_EnterRoom ErrorCode
         * @property {string|null} [ServerHost] RSP_EnterRoom ServerHost
         * @property {number|null} [ServerPort] RSP_EnterRoom ServerPort
         * @property {number|null} [SeatID] RSP_EnterRoom SeatID
         * @property {string|null} [Password] RSP_EnterRoom Password
         * @property {number|null} [RoundCount] RSP_EnterRoom RoundCount
         * @property {string|null} [Rule] RSP_EnterRoom Rule
         * @property {number|null} [RoomID] RSP_EnterRoom RoomID
         * @property {number|null} [HallID] RSP_EnterRoom HallID
         * @property {string|null} [ErrorInfo] RSP_EnterRoom ErrorInfo
         * @property {number|Long|null} [Token] RSP_EnterRoom Token
         * @property {number|null} [RoomType] RSP_EnterRoom RoomType
         * @property {number|null} [wsport] RSP_EnterRoom wsport
         * @property {number|null} [MatchID] RSP_EnterRoom MatchID
         * @property {number|null} [MatchAwardRank] RSP_EnterRoom MatchAwardRank
         * @property {number|null} [GoldFieldID] RSP_EnterRoom GoldFieldID
         * @property {number|null} [BoxID] RSP_EnterRoom BoxID
         * @property {number|null} [RoomHisID] RSP_EnterRoom RoomHisID
         * @property {number|null} [RoomIx] RSP_EnterRoom RoomIx
         */

        /**
         * Constructs a new RSP_EnterRoom.
         * @memberof Auth
         * @classdesc Represents a RSP_EnterRoom.
         * @implements IRSP_EnterRoom
         * @constructor
         * @param {Auth.IRSP_EnterRoom=} [properties] Properties to set
         */
        function RSP_EnterRoom(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RSP_EnterRoom ErrorCode.
         * @member {number} ErrorCode
         * @memberof Auth.RSP_EnterRoom
         * @instance
         */
        RSP_EnterRoom.prototype.ErrorCode = 0;

        /**
         * RSP_EnterRoom ServerHost.
         * @member {string} ServerHost
         * @memberof Auth.RSP_EnterRoom
         * @instance
         */
        RSP_EnterRoom.prototype.ServerHost = "";

        /**
         * RSP_EnterRoom ServerPort.
         * @member {number} ServerPort
         * @memberof Auth.RSP_EnterRoom
         * @instance
         */
        RSP_EnterRoom.prototype.ServerPort = 0;

        /**
         * RSP_EnterRoom SeatID.
         * @member {number} SeatID
         * @memberof Auth.RSP_EnterRoom
         * @instance
         */
        RSP_EnterRoom.prototype.SeatID = 0;

        /**
         * RSP_EnterRoom Password.
         * @member {string} Password
         * @memberof Auth.RSP_EnterRoom
         * @instance
         */
        RSP_EnterRoom.prototype.Password = "";

        /**
         * RSP_EnterRoom RoundCount.
         * @member {number} RoundCount
         * @memberof Auth.RSP_EnterRoom
         * @instance
         */
        RSP_EnterRoom.prototype.RoundCount = 0;

        /**
         * RSP_EnterRoom Rule.
         * @member {string} Rule
         * @memberof Auth.RSP_EnterRoom
         * @instance
         */
        RSP_EnterRoom.prototype.Rule = "";

        /**
         * RSP_EnterRoom RoomID.
         * @member {number} RoomID
         * @memberof Auth.RSP_EnterRoom
         * @instance
         */
        RSP_EnterRoom.prototype.RoomID = 0;

        /**
         * RSP_EnterRoom HallID.
         * @member {number} HallID
         * @memberof Auth.RSP_EnterRoom
         * @instance
         */
        RSP_EnterRoom.prototype.HallID = 0;

        /**
         * RSP_EnterRoom ErrorInfo.
         * @member {string} ErrorInfo
         * @memberof Auth.RSP_EnterRoom
         * @instance
         */
        RSP_EnterRoom.prototype.ErrorInfo = "";

        /**
         * RSP_EnterRoom Token.
         * @member {number|Long} Token
         * @memberof Auth.RSP_EnterRoom
         * @instance
         */
        RSP_EnterRoom.prototype.Token = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RSP_EnterRoom RoomType.
         * @member {number} RoomType
         * @memberof Auth.RSP_EnterRoom
         * @instance
         */
        RSP_EnterRoom.prototype.RoomType = 0;

        /**
         * RSP_EnterRoom wsport.
         * @member {number} wsport
         * @memberof Auth.RSP_EnterRoom
         * @instance
         */
        RSP_EnterRoom.prototype.wsport = 0;

        /**
         * RSP_EnterRoom MatchID.
         * @member {number} MatchID
         * @memberof Auth.RSP_EnterRoom
         * @instance
         */
        RSP_EnterRoom.prototype.MatchID = 0;

        /**
         * RSP_EnterRoom MatchAwardRank.
         * @member {number} MatchAwardRank
         * @memberof Auth.RSP_EnterRoom
         * @instance
         */
        RSP_EnterRoom.prototype.MatchAwardRank = 0;

        /**
         * RSP_EnterRoom GoldFieldID.
         * @member {number} GoldFieldID
         * @memberof Auth.RSP_EnterRoom
         * @instance
         */
        RSP_EnterRoom.prototype.GoldFieldID = 0;

        /**
         * RSP_EnterRoom BoxID.
         * @member {number} BoxID
         * @memberof Auth.RSP_EnterRoom
         * @instance
         */
        RSP_EnterRoom.prototype.BoxID = 0;

        /**
         * RSP_EnterRoom RoomHisID.
         * @member {number} RoomHisID
         * @memberof Auth.RSP_EnterRoom
         * @instance
         */
        RSP_EnterRoom.prototype.RoomHisID = 0;

        /**
         * RSP_EnterRoom RoomIx.
         * @member {number} RoomIx
         * @memberof Auth.RSP_EnterRoom
         * @instance
         */
        RSP_EnterRoom.prototype.RoomIx = 0;

        /**
         * Creates a new RSP_EnterRoom instance using the specified properties.
         * @function create
         * @memberof Auth.RSP_EnterRoom
         * @static
         * @param {Auth.IRSP_EnterRoom=} [properties] Properties to set
         * @returns {Auth.RSP_EnterRoom} RSP_EnterRoom instance
         */
        RSP_EnterRoom.create = function create(properties) {
            return new RSP_EnterRoom(properties);
        };

        /**
         * Encodes the specified RSP_EnterRoom message. Does not implicitly {@link Auth.RSP_EnterRoom.verify|verify} messages.
         * @function encode
         * @memberof Auth.RSP_EnterRoom
         * @static
         * @param {Auth.IRSP_EnterRoom} message RSP_EnterRoom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_EnterRoom.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ErrorCode);
            if (message.ServerHost != null && message.hasOwnProperty("ServerHost"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.ServerHost);
            if (message.ServerPort != null && message.hasOwnProperty("ServerPort"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.ServerPort);
            if (message.SeatID != null && message.hasOwnProperty("SeatID"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.SeatID);
            if (message.Password != null && message.hasOwnProperty("Password"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.Password);
            if (message.RoundCount != null && message.hasOwnProperty("RoundCount"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.RoundCount);
            if (message.Rule != null && message.hasOwnProperty("Rule"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.Rule);
            if (message.RoomID != null && message.hasOwnProperty("RoomID"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.RoomID);
            if (message.HallID != null && message.hasOwnProperty("HallID"))
                writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.HallID);
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.ErrorInfo);
            if (message.Token != null && message.hasOwnProperty("Token"))
                writer.uint32(/* id 11, wireType 0 =*/88).uint64(message.Token);
            if (message.RoomType != null && message.hasOwnProperty("RoomType"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.RoomType);
            if (message.wsport != null && message.hasOwnProperty("wsport"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.wsport);
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                writer.uint32(/* id 14, wireType 0 =*/112).uint32(message.MatchID);
            if (message.MatchAwardRank != null && message.hasOwnProperty("MatchAwardRank"))
                writer.uint32(/* id 15, wireType 0 =*/120).int32(message.MatchAwardRank);
            if (message.GoldFieldID != null && message.hasOwnProperty("GoldFieldID"))
                writer.uint32(/* id 16, wireType 0 =*/128).uint32(message.GoldFieldID);
            if (message.BoxID != null && message.hasOwnProperty("BoxID"))
                writer.uint32(/* id 17, wireType 0 =*/136).uint32(message.BoxID);
            if (message.RoomHisID != null && message.hasOwnProperty("RoomHisID"))
                writer.uint32(/* id 18, wireType 0 =*/144).uint32(message.RoomHisID);
            if (message.RoomIx != null && message.hasOwnProperty("RoomIx"))
                writer.uint32(/* id 19, wireType 0 =*/152).uint32(message.RoomIx);
            return writer;
        };

        /**
         * Encodes the specified RSP_EnterRoom message, length delimited. Does not implicitly {@link Auth.RSP_EnterRoom.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.RSP_EnterRoom
         * @static
         * @param {Auth.IRSP_EnterRoom} message RSP_EnterRoom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_EnterRoom.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RSP_EnterRoom message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.RSP_EnterRoom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.RSP_EnterRoom} RSP_EnterRoom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_EnterRoom.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.RSP_EnterRoom();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ErrorCode = reader.int32();
                    break;
                case 2:
                    message.ServerHost = reader.string();
                    break;
                case 3:
                    message.ServerPort = reader.int32();
                    break;
                case 4:
                    message.SeatID = reader.uint32();
                    break;
                case 5:
                    message.Password = reader.string();
                    break;
                case 6:
                    message.RoundCount = reader.uint32();
                    break;
                case 7:
                    message.Rule = reader.string();
                    break;
                case 8:
                    message.RoomID = reader.uint32();
                    break;
                case 9:
                    message.HallID = reader.uint32();
                    break;
                case 10:
                    message.ErrorInfo = reader.string();
                    break;
                case 11:
                    message.Token = reader.uint64();
                    break;
                case 12:
                    message.RoomType = reader.int32();
                    break;
                case 13:
                    message.wsport = reader.int32();
                    break;
                case 14:
                    message.MatchID = reader.uint32();
                    break;
                case 15:
                    message.MatchAwardRank = reader.int32();
                    break;
                case 16:
                    message.GoldFieldID = reader.uint32();
                    break;
                case 17:
                    message.BoxID = reader.uint32();
                    break;
                case 18:
                    message.RoomHisID = reader.uint32();
                    break;
                case 19:
                    message.RoomIx = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RSP_EnterRoom message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.RSP_EnterRoom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.RSP_EnterRoom} RSP_EnterRoom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_EnterRoom.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RSP_EnterRoom message.
         * @function verify
         * @memberof Auth.RSP_EnterRoom
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RSP_EnterRoom.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                if (!$util.isInteger(message.ErrorCode))
                    return "ErrorCode: integer expected";
            if (message.ServerHost != null && message.hasOwnProperty("ServerHost"))
                if (!$util.isString(message.ServerHost))
                    return "ServerHost: string expected";
            if (message.ServerPort != null && message.hasOwnProperty("ServerPort"))
                if (!$util.isInteger(message.ServerPort))
                    return "ServerPort: integer expected";
            if (message.SeatID != null && message.hasOwnProperty("SeatID"))
                if (!$util.isInteger(message.SeatID))
                    return "SeatID: integer expected";
            if (message.Password != null && message.hasOwnProperty("Password"))
                if (!$util.isString(message.Password))
                    return "Password: string expected";
            if (message.RoundCount != null && message.hasOwnProperty("RoundCount"))
                if (!$util.isInteger(message.RoundCount))
                    return "RoundCount: integer expected";
            if (message.Rule != null && message.hasOwnProperty("Rule"))
                if (!$util.isString(message.Rule))
                    return "Rule: string expected";
            if (message.RoomID != null && message.hasOwnProperty("RoomID"))
                if (!$util.isInteger(message.RoomID))
                    return "RoomID: integer expected";
            if (message.HallID != null && message.hasOwnProperty("HallID"))
                if (!$util.isInteger(message.HallID))
                    return "HallID: integer expected";
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                if (!$util.isString(message.ErrorInfo))
                    return "ErrorInfo: string expected";
            if (message.Token != null && message.hasOwnProperty("Token"))
                if (!$util.isInteger(message.Token) && !(message.Token && $util.isInteger(message.Token.low) && $util.isInteger(message.Token.high)))
                    return "Token: integer|Long expected";
            if (message.RoomType != null && message.hasOwnProperty("RoomType"))
                if (!$util.isInteger(message.RoomType))
                    return "RoomType: integer expected";
            if (message.wsport != null && message.hasOwnProperty("wsport"))
                if (!$util.isInteger(message.wsport))
                    return "wsport: integer expected";
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                if (!$util.isInteger(message.MatchID))
                    return "MatchID: integer expected";
            if (message.MatchAwardRank != null && message.hasOwnProperty("MatchAwardRank"))
                if (!$util.isInteger(message.MatchAwardRank))
                    return "MatchAwardRank: integer expected";
            if (message.GoldFieldID != null && message.hasOwnProperty("GoldFieldID"))
                if (!$util.isInteger(message.GoldFieldID))
                    return "GoldFieldID: integer expected";
            if (message.BoxID != null && message.hasOwnProperty("BoxID"))
                if (!$util.isInteger(message.BoxID))
                    return "BoxID: integer expected";
            if (message.RoomHisID != null && message.hasOwnProperty("RoomHisID"))
                if (!$util.isInteger(message.RoomHisID))
                    return "RoomHisID: integer expected";
            if (message.RoomIx != null && message.hasOwnProperty("RoomIx"))
                if (!$util.isInteger(message.RoomIx))
                    return "RoomIx: integer expected";
            return null;
        };

        /**
         * Creates a RSP_EnterRoom message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.RSP_EnterRoom
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.RSP_EnterRoom} RSP_EnterRoom
         */
        RSP_EnterRoom.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.RSP_EnterRoom)
                return object;
            var message = new $root.Auth.RSP_EnterRoom();
            if (object.ErrorCode != null)
                message.ErrorCode = object.ErrorCode | 0;
            if (object.ServerHost != null)
                message.ServerHost = String(object.ServerHost);
            if (object.ServerPort != null)
                message.ServerPort = object.ServerPort | 0;
            if (object.SeatID != null)
                message.SeatID = object.SeatID >>> 0;
            if (object.Password != null)
                message.Password = String(object.Password);
            if (object.RoundCount != null)
                message.RoundCount = object.RoundCount >>> 0;
            if (object.Rule != null)
                message.Rule = String(object.Rule);
            if (object.RoomID != null)
                message.RoomID = object.RoomID >>> 0;
            if (object.HallID != null)
                message.HallID = object.HallID >>> 0;
            if (object.ErrorInfo != null)
                message.ErrorInfo = String(object.ErrorInfo);
            if (object.Token != null)
                if ($util.Long)
                    (message.Token = $util.Long.fromValue(object.Token)).unsigned = true;
                else if (typeof object.Token === "string")
                    message.Token = parseInt(object.Token, 10);
                else if (typeof object.Token === "number")
                    message.Token = object.Token;
                else if (typeof object.Token === "object")
                    message.Token = new $util.LongBits(object.Token.low >>> 0, object.Token.high >>> 0).toNumber(true);
            if (object.RoomType != null)
                message.RoomType = object.RoomType | 0;
            if (object.wsport != null)
                message.wsport = object.wsport | 0;
            if (object.MatchID != null)
                message.MatchID = object.MatchID >>> 0;
            if (object.MatchAwardRank != null)
                message.MatchAwardRank = object.MatchAwardRank | 0;
            if (object.GoldFieldID != null)
                message.GoldFieldID = object.GoldFieldID >>> 0;
            if (object.BoxID != null)
                message.BoxID = object.BoxID >>> 0;
            if (object.RoomHisID != null)
                message.RoomHisID = object.RoomHisID >>> 0;
            if (object.RoomIx != null)
                message.RoomIx = object.RoomIx >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a RSP_EnterRoom message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.RSP_EnterRoom
         * @static
         * @param {Auth.RSP_EnterRoom} message RSP_EnterRoom
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RSP_EnterRoom.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.ErrorCode = 0;
                object.ServerHost = "";
                object.ServerPort = 0;
                object.SeatID = 0;
                object.Password = "";
                object.RoundCount = 0;
                object.Rule = "";
                object.RoomID = 0;
                object.HallID = 0;
                object.ErrorInfo = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.Token = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.Token = options.longs === String ? "0" : 0;
                object.RoomType = 0;
                object.wsport = 0;
                object.MatchID = 0;
                object.MatchAwardRank = 0;
                object.GoldFieldID = 0;
                object.BoxID = 0;
                object.RoomHisID = 0;
                object.RoomIx = 0;
            }
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                object.ErrorCode = message.ErrorCode;
            if (message.ServerHost != null && message.hasOwnProperty("ServerHost"))
                object.ServerHost = message.ServerHost;
            if (message.ServerPort != null && message.hasOwnProperty("ServerPort"))
                object.ServerPort = message.ServerPort;
            if (message.SeatID != null && message.hasOwnProperty("SeatID"))
                object.SeatID = message.SeatID;
            if (message.Password != null && message.hasOwnProperty("Password"))
                object.Password = message.Password;
            if (message.RoundCount != null && message.hasOwnProperty("RoundCount"))
                object.RoundCount = message.RoundCount;
            if (message.Rule != null && message.hasOwnProperty("Rule"))
                object.Rule = message.Rule;
            if (message.RoomID != null && message.hasOwnProperty("RoomID"))
                object.RoomID = message.RoomID;
            if (message.HallID != null && message.hasOwnProperty("HallID"))
                object.HallID = message.HallID;
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                object.ErrorInfo = message.ErrorInfo;
            if (message.Token != null && message.hasOwnProperty("Token"))
                if (typeof message.Token === "number")
                    object.Token = options.longs === String ? String(message.Token) : message.Token;
                else
                    object.Token = options.longs === String ? $util.Long.prototype.toString.call(message.Token) : options.longs === Number ? new $util.LongBits(message.Token.low >>> 0, message.Token.high >>> 0).toNumber(true) : message.Token;
            if (message.RoomType != null && message.hasOwnProperty("RoomType"))
                object.RoomType = message.RoomType;
            if (message.wsport != null && message.hasOwnProperty("wsport"))
                object.wsport = message.wsport;
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                object.MatchID = message.MatchID;
            if (message.MatchAwardRank != null && message.hasOwnProperty("MatchAwardRank"))
                object.MatchAwardRank = message.MatchAwardRank;
            if (message.GoldFieldID != null && message.hasOwnProperty("GoldFieldID"))
                object.GoldFieldID = message.GoldFieldID;
            if (message.BoxID != null && message.hasOwnProperty("BoxID"))
                object.BoxID = message.BoxID;
            if (message.RoomHisID != null && message.hasOwnProperty("RoomHisID"))
                object.RoomHisID = message.RoomHisID;
            if (message.RoomIx != null && message.hasOwnProperty("RoomIx"))
                object.RoomIx = message.RoomIx;
            return object;
        };

        /**
         * Converts this RSP_EnterRoom to JSON.
         * @function toJSON
         * @memberof Auth.RSP_EnterRoom
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RSP_EnterRoom.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RSP_EnterRoom;
    })();

    Auth.CMD_EnterHall = (function() {

        /**
         * Properties of a CMD_EnterHall.
         * @memberof Auth
         * @interface ICMD_EnterHall
         * @property {string|null} [GameName] CMD_EnterHall GameName
         * @property {string|null} [Rule] CMD_EnterHall Rule
         */

        /**
         * Constructs a new CMD_EnterHall.
         * @memberof Auth
         * @classdesc Represents a CMD_EnterHall.
         * @implements ICMD_EnterHall
         * @constructor
         * @param {Auth.ICMD_EnterHall=} [properties] Properties to set
         */
        function CMD_EnterHall(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_EnterHall GameName.
         * @member {string} GameName
         * @memberof Auth.CMD_EnterHall
         * @instance
         */
        CMD_EnterHall.prototype.GameName = "";

        /**
         * CMD_EnterHall Rule.
         * @member {string} Rule
         * @memberof Auth.CMD_EnterHall
         * @instance
         */
        CMD_EnterHall.prototype.Rule = "";

        /**
         * Creates a new CMD_EnterHall instance using the specified properties.
         * @function create
         * @memberof Auth.CMD_EnterHall
         * @static
         * @param {Auth.ICMD_EnterHall=} [properties] Properties to set
         * @returns {Auth.CMD_EnterHall} CMD_EnterHall instance
         */
        CMD_EnterHall.create = function create(properties) {
            return new CMD_EnterHall(properties);
        };

        /**
         * Encodes the specified CMD_EnterHall message. Does not implicitly {@link Auth.CMD_EnterHall.verify|verify} messages.
         * @function encode
         * @memberof Auth.CMD_EnterHall
         * @static
         * @param {Auth.ICMD_EnterHall} message CMD_EnterHall message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_EnterHall.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.GameName != null && message.hasOwnProperty("GameName"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.GameName);
            if (message.Rule != null && message.hasOwnProperty("Rule"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Rule);
            return writer;
        };

        /**
         * Encodes the specified CMD_EnterHall message, length delimited. Does not implicitly {@link Auth.CMD_EnterHall.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.CMD_EnterHall
         * @static
         * @param {Auth.ICMD_EnterHall} message CMD_EnterHall message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_EnterHall.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_EnterHall message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.CMD_EnterHall
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.CMD_EnterHall} CMD_EnterHall
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_EnterHall.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.CMD_EnterHall();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.GameName = reader.string();
                    break;
                case 2:
                    message.Rule = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_EnterHall message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.CMD_EnterHall
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.CMD_EnterHall} CMD_EnterHall
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_EnterHall.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_EnterHall message.
         * @function verify
         * @memberof Auth.CMD_EnterHall
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_EnterHall.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.GameName != null && message.hasOwnProperty("GameName"))
                if (!$util.isString(message.GameName))
                    return "GameName: string expected";
            if (message.Rule != null && message.hasOwnProperty("Rule"))
                if (!$util.isString(message.Rule))
                    return "Rule: string expected";
            return null;
        };

        /**
         * Creates a CMD_EnterHall message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.CMD_EnterHall
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.CMD_EnterHall} CMD_EnterHall
         */
        CMD_EnterHall.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.CMD_EnterHall)
                return object;
            var message = new $root.Auth.CMD_EnterHall();
            if (object.GameName != null)
                message.GameName = String(object.GameName);
            if (object.Rule != null)
                message.Rule = String(object.Rule);
            return message;
        };

        /**
         * Creates a plain object from a CMD_EnterHall message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.CMD_EnterHall
         * @static
         * @param {Auth.CMD_EnterHall} message CMD_EnterHall
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_EnterHall.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.GameName = "";
                object.Rule = "";
            }
            if (message.GameName != null && message.hasOwnProperty("GameName"))
                object.GameName = message.GameName;
            if (message.Rule != null && message.hasOwnProperty("Rule"))
                object.Rule = message.Rule;
            return object;
        };

        /**
         * Converts this CMD_EnterHall to JSON.
         * @function toJSON
         * @memberof Auth.CMD_EnterHall
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_EnterHall.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CMD_EnterHall;
    })();

    Auth.RSP_EnterHall = (function() {

        /**
         * Properties of a RSP_EnterHall.
         * @memberof Auth
         * @interface IRSP_EnterHall
         * @property {number|null} [RoomID] RSP_EnterHall RoomID
         * @property {string|null} [ServerHost] RSP_EnterHall ServerHost
         * @property {number|null} [ServerPort] RSP_EnterHall ServerPort
         * @property {number|null} [SeatID] RSP_EnterHall SeatID
         * @property {string|null} [Password] RSP_EnterHall Password
         * @property {string|null} [ErrorInfo] RSP_EnterHall ErrorInfo
         */

        /**
         * Constructs a new RSP_EnterHall.
         * @memberof Auth
         * @classdesc Represents a RSP_EnterHall.
         * @implements IRSP_EnterHall
         * @constructor
         * @param {Auth.IRSP_EnterHall=} [properties] Properties to set
         */
        function RSP_EnterHall(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RSP_EnterHall RoomID.
         * @member {number} RoomID
         * @memberof Auth.RSP_EnterHall
         * @instance
         */
        RSP_EnterHall.prototype.RoomID = 0;

        /**
         * RSP_EnterHall ServerHost.
         * @member {string} ServerHost
         * @memberof Auth.RSP_EnterHall
         * @instance
         */
        RSP_EnterHall.prototype.ServerHost = "";

        /**
         * RSP_EnterHall ServerPort.
         * @member {number} ServerPort
         * @memberof Auth.RSP_EnterHall
         * @instance
         */
        RSP_EnterHall.prototype.ServerPort = 0;

        /**
         * RSP_EnterHall SeatID.
         * @member {number} SeatID
         * @memberof Auth.RSP_EnterHall
         * @instance
         */
        RSP_EnterHall.prototype.SeatID = 0;

        /**
         * RSP_EnterHall Password.
         * @member {string} Password
         * @memberof Auth.RSP_EnterHall
         * @instance
         */
        RSP_EnterHall.prototype.Password = "";

        /**
         * RSP_EnterHall ErrorInfo.
         * @member {string} ErrorInfo
         * @memberof Auth.RSP_EnterHall
         * @instance
         */
        RSP_EnterHall.prototype.ErrorInfo = "";

        /**
         * Creates a new RSP_EnterHall instance using the specified properties.
         * @function create
         * @memberof Auth.RSP_EnterHall
         * @static
         * @param {Auth.IRSP_EnterHall=} [properties] Properties to set
         * @returns {Auth.RSP_EnterHall} RSP_EnterHall instance
         */
        RSP_EnterHall.create = function create(properties) {
            return new RSP_EnterHall(properties);
        };

        /**
         * Encodes the specified RSP_EnterHall message. Does not implicitly {@link Auth.RSP_EnterHall.verify|verify} messages.
         * @function encode
         * @memberof Auth.RSP_EnterHall
         * @static
         * @param {Auth.IRSP_EnterHall} message RSP_EnterHall message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_EnterHall.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.RoomID != null && message.hasOwnProperty("RoomID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.RoomID);
            if (message.ServerHost != null && message.hasOwnProperty("ServerHost"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.ServerHost);
            if (message.ServerPort != null && message.hasOwnProperty("ServerPort"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.ServerPort);
            if (message.SeatID != null && message.hasOwnProperty("SeatID"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.SeatID);
            if (message.Password != null && message.hasOwnProperty("Password"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.Password);
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.ErrorInfo);
            return writer;
        };

        /**
         * Encodes the specified RSP_EnterHall message, length delimited. Does not implicitly {@link Auth.RSP_EnterHall.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.RSP_EnterHall
         * @static
         * @param {Auth.IRSP_EnterHall} message RSP_EnterHall message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_EnterHall.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RSP_EnterHall message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.RSP_EnterHall
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.RSP_EnterHall} RSP_EnterHall
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_EnterHall.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.RSP_EnterHall();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.RoomID = reader.uint32();
                    break;
                case 2:
                    message.ServerHost = reader.string();
                    break;
                case 3:
                    message.ServerPort = reader.int32();
                    break;
                case 4:
                    message.SeatID = reader.uint32();
                    break;
                case 5:
                    message.Password = reader.string();
                    break;
                case 6:
                    message.ErrorInfo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RSP_EnterHall message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.RSP_EnterHall
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.RSP_EnterHall} RSP_EnterHall
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_EnterHall.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RSP_EnterHall message.
         * @function verify
         * @memberof Auth.RSP_EnterHall
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RSP_EnterHall.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.RoomID != null && message.hasOwnProperty("RoomID"))
                if (!$util.isInteger(message.RoomID))
                    return "RoomID: integer expected";
            if (message.ServerHost != null && message.hasOwnProperty("ServerHost"))
                if (!$util.isString(message.ServerHost))
                    return "ServerHost: string expected";
            if (message.ServerPort != null && message.hasOwnProperty("ServerPort"))
                if (!$util.isInteger(message.ServerPort))
                    return "ServerPort: integer expected";
            if (message.SeatID != null && message.hasOwnProperty("SeatID"))
                if (!$util.isInteger(message.SeatID))
                    return "SeatID: integer expected";
            if (message.Password != null && message.hasOwnProperty("Password"))
                if (!$util.isString(message.Password))
                    return "Password: string expected";
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                if (!$util.isString(message.ErrorInfo))
                    return "ErrorInfo: string expected";
            return null;
        };

        /**
         * Creates a RSP_EnterHall message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.RSP_EnterHall
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.RSP_EnterHall} RSP_EnterHall
         */
        RSP_EnterHall.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.RSP_EnterHall)
                return object;
            var message = new $root.Auth.RSP_EnterHall();
            if (object.RoomID != null)
                message.RoomID = object.RoomID >>> 0;
            if (object.ServerHost != null)
                message.ServerHost = String(object.ServerHost);
            if (object.ServerPort != null)
                message.ServerPort = object.ServerPort | 0;
            if (object.SeatID != null)
                message.SeatID = object.SeatID >>> 0;
            if (object.Password != null)
                message.Password = String(object.Password);
            if (object.ErrorInfo != null)
                message.ErrorInfo = String(object.ErrorInfo);
            return message;
        };

        /**
         * Creates a plain object from a RSP_EnterHall message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.RSP_EnterHall
         * @static
         * @param {Auth.RSP_EnterHall} message RSP_EnterHall
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RSP_EnterHall.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.RoomID = 0;
                object.ServerHost = "";
                object.ServerPort = 0;
                object.SeatID = 0;
                object.Password = "";
                object.ErrorInfo = "";
            }
            if (message.RoomID != null && message.hasOwnProperty("RoomID"))
                object.RoomID = message.RoomID;
            if (message.ServerHost != null && message.hasOwnProperty("ServerHost"))
                object.ServerHost = message.ServerHost;
            if (message.ServerPort != null && message.hasOwnProperty("ServerPort"))
                object.ServerPort = message.ServerPort;
            if (message.SeatID != null && message.hasOwnProperty("SeatID"))
                object.SeatID = message.SeatID;
            if (message.Password != null && message.hasOwnProperty("Password"))
                object.Password = message.Password;
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                object.ErrorInfo = message.ErrorInfo;
            return object;
        };

        /**
         * Converts this RSP_EnterHall to JSON.
         * @function toJSON
         * @memberof Auth.RSP_EnterHall
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RSP_EnterHall.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RSP_EnterHall;
    })();

    Auth.CMD_Ping = (function() {

        /**
         * Properties of a CMD_Ping.
         * @memberof Auth
         * @interface ICMD_Ping
         * @property {number|Long|null} [TimeStamp] CMD_Ping TimeStamp
         * @property {number|Long|null} [UserID] CMD_Ping UserID
         */

        /**
         * Constructs a new CMD_Ping.
         * @memberof Auth
         * @classdesc Represents a CMD_Ping.
         * @implements ICMD_Ping
         * @constructor
         * @param {Auth.ICMD_Ping=} [properties] Properties to set
         */
        function CMD_Ping(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_Ping TimeStamp.
         * @member {number|Long} TimeStamp
         * @memberof Auth.CMD_Ping
         * @instance
         */
        CMD_Ping.prototype.TimeStamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CMD_Ping UserID.
         * @member {number|Long} UserID
         * @memberof Auth.CMD_Ping
         * @instance
         */
        CMD_Ping.prototype.UserID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new CMD_Ping instance using the specified properties.
         * @function create
         * @memberof Auth.CMD_Ping
         * @static
         * @param {Auth.ICMD_Ping=} [properties] Properties to set
         * @returns {Auth.CMD_Ping} CMD_Ping instance
         */
        CMD_Ping.create = function create(properties) {
            return new CMD_Ping(properties);
        };

        /**
         * Encodes the specified CMD_Ping message. Does not implicitly {@link Auth.CMD_Ping.verify|verify} messages.
         * @function encode
         * @memberof Auth.CMD_Ping
         * @static
         * @param {Auth.ICMD_Ping} message CMD_Ping message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_Ping.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.TimeStamp != null && message.hasOwnProperty("TimeStamp"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.TimeStamp);
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.UserID);
            return writer;
        };

        /**
         * Encodes the specified CMD_Ping message, length delimited. Does not implicitly {@link Auth.CMD_Ping.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.CMD_Ping
         * @static
         * @param {Auth.ICMD_Ping} message CMD_Ping message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_Ping.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_Ping message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.CMD_Ping
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.CMD_Ping} CMD_Ping
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_Ping.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.CMD_Ping();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.TimeStamp = reader.uint64();
                    break;
                case 2:
                    message.UserID = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_Ping message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.CMD_Ping
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.CMD_Ping} CMD_Ping
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_Ping.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_Ping message.
         * @function verify
         * @memberof Auth.CMD_Ping
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_Ping.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.TimeStamp != null && message.hasOwnProperty("TimeStamp"))
                if (!$util.isInteger(message.TimeStamp) && !(message.TimeStamp && $util.isInteger(message.TimeStamp.low) && $util.isInteger(message.TimeStamp.high)))
                    return "TimeStamp: integer|Long expected";
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (!$util.isInteger(message.UserID) && !(message.UserID && $util.isInteger(message.UserID.low) && $util.isInteger(message.UserID.high)))
                    return "UserID: integer|Long expected";
            return null;
        };

        /**
         * Creates a CMD_Ping message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.CMD_Ping
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.CMD_Ping} CMD_Ping
         */
        CMD_Ping.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.CMD_Ping)
                return object;
            var message = new $root.Auth.CMD_Ping();
            if (object.TimeStamp != null)
                if ($util.Long)
                    (message.TimeStamp = $util.Long.fromValue(object.TimeStamp)).unsigned = true;
                else if (typeof object.TimeStamp === "string")
                    message.TimeStamp = parseInt(object.TimeStamp, 10);
                else if (typeof object.TimeStamp === "number")
                    message.TimeStamp = object.TimeStamp;
                else if (typeof object.TimeStamp === "object")
                    message.TimeStamp = new $util.LongBits(object.TimeStamp.low >>> 0, object.TimeStamp.high >>> 0).toNumber(true);
            if (object.UserID != null)
                if ($util.Long)
                    (message.UserID = $util.Long.fromValue(object.UserID)).unsigned = true;
                else if (typeof object.UserID === "string")
                    message.UserID = parseInt(object.UserID, 10);
                else if (typeof object.UserID === "number")
                    message.UserID = object.UserID;
                else if (typeof object.UserID === "object")
                    message.UserID = new $util.LongBits(object.UserID.low >>> 0, object.UserID.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a CMD_Ping message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.CMD_Ping
         * @static
         * @param {Auth.CMD_Ping} message CMD_Ping
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_Ping.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.TimeStamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.TimeStamp = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.UserID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.UserID = options.longs === String ? "0" : 0;
            }
            if (message.TimeStamp != null && message.hasOwnProperty("TimeStamp"))
                if (typeof message.TimeStamp === "number")
                    object.TimeStamp = options.longs === String ? String(message.TimeStamp) : message.TimeStamp;
                else
                    object.TimeStamp = options.longs === String ? $util.Long.prototype.toString.call(message.TimeStamp) : options.longs === Number ? new $util.LongBits(message.TimeStamp.low >>> 0, message.TimeStamp.high >>> 0).toNumber(true) : message.TimeStamp;
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (typeof message.UserID === "number")
                    object.UserID = options.longs === String ? String(message.UserID) : message.UserID;
                else
                    object.UserID = options.longs === String ? $util.Long.prototype.toString.call(message.UserID) : options.longs === Number ? new $util.LongBits(message.UserID.low >>> 0, message.UserID.high >>> 0).toNumber(true) : message.UserID;
            return object;
        };

        /**
         * Converts this CMD_Ping to JSON.
         * @function toJSON
         * @memberof Auth.CMD_Ping
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_Ping.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CMD_Ping;
    })();

    Auth.RSP_Ping = (function() {

        /**
         * Properties of a RSP_Ping.
         * @memberof Auth
         * @interface IRSP_Ping
         * @property {number|Long|null} [TimeStamp] RSP_Ping TimeStamp
         * @property {number|Long|null} [UserID] RSP_Ping UserID
         */

        /**
         * Constructs a new RSP_Ping.
         * @memberof Auth
         * @classdesc Represents a RSP_Ping.
         * @implements IRSP_Ping
         * @constructor
         * @param {Auth.IRSP_Ping=} [properties] Properties to set
         */
        function RSP_Ping(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RSP_Ping TimeStamp.
         * @member {number|Long} TimeStamp
         * @memberof Auth.RSP_Ping
         * @instance
         */
        RSP_Ping.prototype.TimeStamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RSP_Ping UserID.
         * @member {number|Long} UserID
         * @memberof Auth.RSP_Ping
         * @instance
         */
        RSP_Ping.prototype.UserID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new RSP_Ping instance using the specified properties.
         * @function create
         * @memberof Auth.RSP_Ping
         * @static
         * @param {Auth.IRSP_Ping=} [properties] Properties to set
         * @returns {Auth.RSP_Ping} RSP_Ping instance
         */
        RSP_Ping.create = function create(properties) {
            return new RSP_Ping(properties);
        };

        /**
         * Encodes the specified RSP_Ping message. Does not implicitly {@link Auth.RSP_Ping.verify|verify} messages.
         * @function encode
         * @memberof Auth.RSP_Ping
         * @static
         * @param {Auth.IRSP_Ping} message RSP_Ping message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_Ping.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.TimeStamp != null && message.hasOwnProperty("TimeStamp"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.TimeStamp);
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.UserID);
            return writer;
        };

        /**
         * Encodes the specified RSP_Ping message, length delimited. Does not implicitly {@link Auth.RSP_Ping.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.RSP_Ping
         * @static
         * @param {Auth.IRSP_Ping} message RSP_Ping message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_Ping.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RSP_Ping message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.RSP_Ping
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.RSP_Ping} RSP_Ping
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_Ping.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.RSP_Ping();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.TimeStamp = reader.uint64();
                    break;
                case 2:
                    message.UserID = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RSP_Ping message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.RSP_Ping
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.RSP_Ping} RSP_Ping
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_Ping.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RSP_Ping message.
         * @function verify
         * @memberof Auth.RSP_Ping
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RSP_Ping.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.TimeStamp != null && message.hasOwnProperty("TimeStamp"))
                if (!$util.isInteger(message.TimeStamp) && !(message.TimeStamp && $util.isInteger(message.TimeStamp.low) && $util.isInteger(message.TimeStamp.high)))
                    return "TimeStamp: integer|Long expected";
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (!$util.isInteger(message.UserID) && !(message.UserID && $util.isInteger(message.UserID.low) && $util.isInteger(message.UserID.high)))
                    return "UserID: integer|Long expected";
            return null;
        };

        /**
         * Creates a RSP_Ping message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.RSP_Ping
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.RSP_Ping} RSP_Ping
         */
        RSP_Ping.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.RSP_Ping)
                return object;
            var message = new $root.Auth.RSP_Ping();
            if (object.TimeStamp != null)
                if ($util.Long)
                    (message.TimeStamp = $util.Long.fromValue(object.TimeStamp)).unsigned = true;
                else if (typeof object.TimeStamp === "string")
                    message.TimeStamp = parseInt(object.TimeStamp, 10);
                else if (typeof object.TimeStamp === "number")
                    message.TimeStamp = object.TimeStamp;
                else if (typeof object.TimeStamp === "object")
                    message.TimeStamp = new $util.LongBits(object.TimeStamp.low >>> 0, object.TimeStamp.high >>> 0).toNumber(true);
            if (object.UserID != null)
                if ($util.Long)
                    (message.UserID = $util.Long.fromValue(object.UserID)).unsigned = true;
                else if (typeof object.UserID === "string")
                    message.UserID = parseInt(object.UserID, 10);
                else if (typeof object.UserID === "number")
                    message.UserID = object.UserID;
                else if (typeof object.UserID === "object")
                    message.UserID = new $util.LongBits(object.UserID.low >>> 0, object.UserID.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a RSP_Ping message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.RSP_Ping
         * @static
         * @param {Auth.RSP_Ping} message RSP_Ping
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RSP_Ping.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.TimeStamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.TimeStamp = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.UserID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.UserID = options.longs === String ? "0" : 0;
            }
            if (message.TimeStamp != null && message.hasOwnProperty("TimeStamp"))
                if (typeof message.TimeStamp === "number")
                    object.TimeStamp = options.longs === String ? String(message.TimeStamp) : message.TimeStamp;
                else
                    object.TimeStamp = options.longs === String ? $util.Long.prototype.toString.call(message.TimeStamp) : options.longs === Number ? new $util.LongBits(message.TimeStamp.low >>> 0, message.TimeStamp.high >>> 0).toNumber(true) : message.TimeStamp;
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (typeof message.UserID === "number")
                    object.UserID = options.longs === String ? String(message.UserID) : message.UserID;
                else
                    object.UserID = options.longs === String ? $util.Long.prototype.toString.call(message.UserID) : options.longs === Number ? new $util.LongBits(message.UserID.low >>> 0, message.UserID.high >>> 0).toNumber(true) : message.UserID;
            return object;
        };

        /**
         * Converts this RSP_Ping to JSON.
         * @function toJSON
         * @memberof Auth.RSP_Ping
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RSP_Ping.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RSP_Ping;
    })();

    Auth.CMD_GoldEnter = (function() {

        /**
         * Properties of a CMD_GoldEnter.
         * @memberof Auth
         * @interface ICMD_GoldEnter
         * @property {number|null} [GoldID] CMD_GoldEnter GoldID
         * @property {number|Long|null} [UserID] CMD_GoldEnter UserID
         * @property {number|null} [CompetitionID] CMD_GoldEnter CompetitionID
         * @property {number|null} [ChannelID] CMD_GoldEnter ChannelID
         */

        /**
         * Constructs a new CMD_GoldEnter.
         * @memberof Auth
         * @classdesc Represents a CMD_GoldEnter.
         * @implements ICMD_GoldEnter
         * @constructor
         * @param {Auth.ICMD_GoldEnter=} [properties] Properties to set
         */
        function CMD_GoldEnter(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_GoldEnter GoldID.
         * @member {number} GoldID
         * @memberof Auth.CMD_GoldEnter
         * @instance
         */
        CMD_GoldEnter.prototype.GoldID = 0;

        /**
         * CMD_GoldEnter UserID.
         * @member {number|Long} UserID
         * @memberof Auth.CMD_GoldEnter
         * @instance
         */
        CMD_GoldEnter.prototype.UserID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CMD_GoldEnter CompetitionID.
         * @member {number} CompetitionID
         * @memberof Auth.CMD_GoldEnter
         * @instance
         */
        CMD_GoldEnter.prototype.CompetitionID = 0;

        /**
         * CMD_GoldEnter ChannelID.
         * @member {number} ChannelID
         * @memberof Auth.CMD_GoldEnter
         * @instance
         */
        CMD_GoldEnter.prototype.ChannelID = 0;

        /**
         * Creates a new CMD_GoldEnter instance using the specified properties.
         * @function create
         * @memberof Auth.CMD_GoldEnter
         * @static
         * @param {Auth.ICMD_GoldEnter=} [properties] Properties to set
         * @returns {Auth.CMD_GoldEnter} CMD_GoldEnter instance
         */
        CMD_GoldEnter.create = function create(properties) {
            return new CMD_GoldEnter(properties);
        };

        /**
         * Encodes the specified CMD_GoldEnter message. Does not implicitly {@link Auth.CMD_GoldEnter.verify|verify} messages.
         * @function encode
         * @memberof Auth.CMD_GoldEnter
         * @static
         * @param {Auth.ICMD_GoldEnter} message CMD_GoldEnter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_GoldEnter.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.GoldID != null && message.hasOwnProperty("GoldID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.GoldID);
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.UserID);
            if (message.CompetitionID != null && message.hasOwnProperty("CompetitionID"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.CompetitionID);
            if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.ChannelID);
            return writer;
        };

        /**
         * Encodes the specified CMD_GoldEnter message, length delimited. Does not implicitly {@link Auth.CMD_GoldEnter.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.CMD_GoldEnter
         * @static
         * @param {Auth.ICMD_GoldEnter} message CMD_GoldEnter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_GoldEnter.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_GoldEnter message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.CMD_GoldEnter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.CMD_GoldEnter} CMD_GoldEnter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_GoldEnter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.CMD_GoldEnter();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.GoldID = reader.uint32();
                    break;
                case 2:
                    message.UserID = reader.uint64();
                    break;
                case 3:
                    message.CompetitionID = reader.uint32();
                    break;
                case 4:
                    message.ChannelID = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_GoldEnter message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.CMD_GoldEnter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.CMD_GoldEnter} CMD_GoldEnter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_GoldEnter.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_GoldEnter message.
         * @function verify
         * @memberof Auth.CMD_GoldEnter
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_GoldEnter.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.GoldID != null && message.hasOwnProperty("GoldID"))
                if (!$util.isInteger(message.GoldID))
                    return "GoldID: integer expected";
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (!$util.isInteger(message.UserID) && !(message.UserID && $util.isInteger(message.UserID.low) && $util.isInteger(message.UserID.high)))
                    return "UserID: integer|Long expected";
            if (message.CompetitionID != null && message.hasOwnProperty("CompetitionID"))
                if (!$util.isInteger(message.CompetitionID))
                    return "CompetitionID: integer expected";
            if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
                if (!$util.isInteger(message.ChannelID))
                    return "ChannelID: integer expected";
            return null;
        };

        /**
         * Creates a CMD_GoldEnter message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.CMD_GoldEnter
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.CMD_GoldEnter} CMD_GoldEnter
         */
        CMD_GoldEnter.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.CMD_GoldEnter)
                return object;
            var message = new $root.Auth.CMD_GoldEnter();
            if (object.GoldID != null)
                message.GoldID = object.GoldID >>> 0;
            if (object.UserID != null)
                if ($util.Long)
                    (message.UserID = $util.Long.fromValue(object.UserID)).unsigned = true;
                else if (typeof object.UserID === "string")
                    message.UserID = parseInt(object.UserID, 10);
                else if (typeof object.UserID === "number")
                    message.UserID = object.UserID;
                else if (typeof object.UserID === "object")
                    message.UserID = new $util.LongBits(object.UserID.low >>> 0, object.UserID.high >>> 0).toNumber(true);
            if (object.CompetitionID != null)
                message.CompetitionID = object.CompetitionID >>> 0;
            if (object.ChannelID != null)
                message.ChannelID = object.ChannelID >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a CMD_GoldEnter message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.CMD_GoldEnter
         * @static
         * @param {Auth.CMD_GoldEnter} message CMD_GoldEnter
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_GoldEnter.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.GoldID = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.UserID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.UserID = options.longs === String ? "0" : 0;
                object.CompetitionID = 0;
                object.ChannelID = 0;
            }
            if (message.GoldID != null && message.hasOwnProperty("GoldID"))
                object.GoldID = message.GoldID;
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (typeof message.UserID === "number")
                    object.UserID = options.longs === String ? String(message.UserID) : message.UserID;
                else
                    object.UserID = options.longs === String ? $util.Long.prototype.toString.call(message.UserID) : options.longs === Number ? new $util.LongBits(message.UserID.low >>> 0, message.UserID.high >>> 0).toNumber(true) : message.UserID;
            if (message.CompetitionID != null && message.hasOwnProperty("CompetitionID"))
                object.CompetitionID = message.CompetitionID;
            if (message.ChannelID != null && message.hasOwnProperty("ChannelID"))
                object.ChannelID = message.ChannelID;
            return object;
        };

        /**
         * Converts this CMD_GoldEnter to JSON.
         * @function toJSON
         * @memberof Auth.CMD_GoldEnter
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_GoldEnter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CMD_GoldEnter;
    })();

    Auth.RSP_GoldEnter = (function() {

        /**
         * Properties of a RSP_GoldEnter.
         * @memberof Auth
         * @interface IRSP_GoldEnter
         * @property {number|null} [GoldID] RSP_GoldEnter GoldID
         * @property {number|Long|null} [UserID] RSP_GoldEnter UserID
         * @property {number|null} [ErrorCode] RSP_GoldEnter ErrorCode
         * @property {string|null} [ErrorInfo] RSP_GoldEnter ErrorInfo
         * @property {string|null} [GameName] RSP_GoldEnter GameName
         * @property {number|null} [CompetitionID] RSP_GoldEnter CompetitionID
         */

        /**
         * Constructs a new RSP_GoldEnter.
         * @memberof Auth
         * @classdesc Represents a RSP_GoldEnter.
         * @implements IRSP_GoldEnter
         * @constructor
         * @param {Auth.IRSP_GoldEnter=} [properties] Properties to set
         */
        function RSP_GoldEnter(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RSP_GoldEnter GoldID.
         * @member {number} GoldID
         * @memberof Auth.RSP_GoldEnter
         * @instance
         */
        RSP_GoldEnter.prototype.GoldID = 0;

        /**
         * RSP_GoldEnter UserID.
         * @member {number|Long} UserID
         * @memberof Auth.RSP_GoldEnter
         * @instance
         */
        RSP_GoldEnter.prototype.UserID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RSP_GoldEnter ErrorCode.
         * @member {number} ErrorCode
         * @memberof Auth.RSP_GoldEnter
         * @instance
         */
        RSP_GoldEnter.prototype.ErrorCode = 0;

        /**
         * RSP_GoldEnter ErrorInfo.
         * @member {string} ErrorInfo
         * @memberof Auth.RSP_GoldEnter
         * @instance
         */
        RSP_GoldEnter.prototype.ErrorInfo = "";

        /**
         * RSP_GoldEnter GameName.
         * @member {string} GameName
         * @memberof Auth.RSP_GoldEnter
         * @instance
         */
        RSP_GoldEnter.prototype.GameName = "";

        /**
         * RSP_GoldEnter CompetitionID.
         * @member {number} CompetitionID
         * @memberof Auth.RSP_GoldEnter
         * @instance
         */
        RSP_GoldEnter.prototype.CompetitionID = 0;

        /**
         * Creates a new RSP_GoldEnter instance using the specified properties.
         * @function create
         * @memberof Auth.RSP_GoldEnter
         * @static
         * @param {Auth.IRSP_GoldEnter=} [properties] Properties to set
         * @returns {Auth.RSP_GoldEnter} RSP_GoldEnter instance
         */
        RSP_GoldEnter.create = function create(properties) {
            return new RSP_GoldEnter(properties);
        };

        /**
         * Encodes the specified RSP_GoldEnter message. Does not implicitly {@link Auth.RSP_GoldEnter.verify|verify} messages.
         * @function encode
         * @memberof Auth.RSP_GoldEnter
         * @static
         * @param {Auth.IRSP_GoldEnter} message RSP_GoldEnter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_GoldEnter.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.GoldID != null && message.hasOwnProperty("GoldID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.GoldID);
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.UserID);
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.ErrorCode);
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.ErrorInfo);
            if (message.GameName != null && message.hasOwnProperty("GameName"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.GameName);
            if (message.CompetitionID != null && message.hasOwnProperty("CompetitionID"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.CompetitionID);
            return writer;
        };

        /**
         * Encodes the specified RSP_GoldEnter message, length delimited. Does not implicitly {@link Auth.RSP_GoldEnter.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.RSP_GoldEnter
         * @static
         * @param {Auth.IRSP_GoldEnter} message RSP_GoldEnter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_GoldEnter.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RSP_GoldEnter message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.RSP_GoldEnter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.RSP_GoldEnter} RSP_GoldEnter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_GoldEnter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.RSP_GoldEnter();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.GoldID = reader.uint32();
                    break;
                case 2:
                    message.UserID = reader.uint64();
                    break;
                case 3:
                    message.ErrorCode = reader.int32();
                    break;
                case 4:
                    message.ErrorInfo = reader.string();
                    break;
                case 5:
                    message.GameName = reader.string();
                    break;
                case 6:
                    message.CompetitionID = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RSP_GoldEnter message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.RSP_GoldEnter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.RSP_GoldEnter} RSP_GoldEnter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_GoldEnter.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RSP_GoldEnter message.
         * @function verify
         * @memberof Auth.RSP_GoldEnter
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RSP_GoldEnter.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.GoldID != null && message.hasOwnProperty("GoldID"))
                if (!$util.isInteger(message.GoldID))
                    return "GoldID: integer expected";
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (!$util.isInteger(message.UserID) && !(message.UserID && $util.isInteger(message.UserID.low) && $util.isInteger(message.UserID.high)))
                    return "UserID: integer|Long expected";
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                if (!$util.isInteger(message.ErrorCode))
                    return "ErrorCode: integer expected";
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                if (!$util.isString(message.ErrorInfo))
                    return "ErrorInfo: string expected";
            if (message.GameName != null && message.hasOwnProperty("GameName"))
                if (!$util.isString(message.GameName))
                    return "GameName: string expected";
            if (message.CompetitionID != null && message.hasOwnProperty("CompetitionID"))
                if (!$util.isInteger(message.CompetitionID))
                    return "CompetitionID: integer expected";
            return null;
        };

        /**
         * Creates a RSP_GoldEnter message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.RSP_GoldEnter
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.RSP_GoldEnter} RSP_GoldEnter
         */
        RSP_GoldEnter.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.RSP_GoldEnter)
                return object;
            var message = new $root.Auth.RSP_GoldEnter();
            if (object.GoldID != null)
                message.GoldID = object.GoldID >>> 0;
            if (object.UserID != null)
                if ($util.Long)
                    (message.UserID = $util.Long.fromValue(object.UserID)).unsigned = true;
                else if (typeof object.UserID === "string")
                    message.UserID = parseInt(object.UserID, 10);
                else if (typeof object.UserID === "number")
                    message.UserID = object.UserID;
                else if (typeof object.UserID === "object")
                    message.UserID = new $util.LongBits(object.UserID.low >>> 0, object.UserID.high >>> 0).toNumber(true);
            if (object.ErrorCode != null)
                message.ErrorCode = object.ErrorCode | 0;
            if (object.ErrorInfo != null)
                message.ErrorInfo = String(object.ErrorInfo);
            if (object.GameName != null)
                message.GameName = String(object.GameName);
            if (object.CompetitionID != null)
                message.CompetitionID = object.CompetitionID >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a RSP_GoldEnter message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.RSP_GoldEnter
         * @static
         * @param {Auth.RSP_GoldEnter} message RSP_GoldEnter
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RSP_GoldEnter.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.GoldID = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.UserID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.UserID = options.longs === String ? "0" : 0;
                object.ErrorCode = 0;
                object.ErrorInfo = "";
                object.GameName = "";
                object.CompetitionID = 0;
            }
            if (message.GoldID != null && message.hasOwnProperty("GoldID"))
                object.GoldID = message.GoldID;
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (typeof message.UserID === "number")
                    object.UserID = options.longs === String ? String(message.UserID) : message.UserID;
                else
                    object.UserID = options.longs === String ? $util.Long.prototype.toString.call(message.UserID) : options.longs === Number ? new $util.LongBits(message.UserID.low >>> 0, message.UserID.high >>> 0).toNumber(true) : message.UserID;
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                object.ErrorCode = message.ErrorCode;
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                object.ErrorInfo = message.ErrorInfo;
            if (message.GameName != null && message.hasOwnProperty("GameName"))
                object.GameName = message.GameName;
            if (message.CompetitionID != null && message.hasOwnProperty("CompetitionID"))
                object.CompetitionID = message.CompetitionID;
            return object;
        };

        /**
         * Converts this RSP_GoldEnter to JSON.
         * @function toJSON
         * @memberof Auth.RSP_GoldEnter
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RSP_GoldEnter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RSP_GoldEnter;
    })();

    Auth.CMD_GoldQuit = (function() {

        /**
         * Properties of a CMD_GoldQuit.
         * @memberof Auth
         * @interface ICMD_GoldQuit
         * @property {number|null} [GoldID] CMD_GoldQuit GoldID
         * @property {number|Long|null} [UserID] CMD_GoldQuit UserID
         * @property {number|null} [CompetitionID] CMD_GoldQuit CompetitionID
         */

        /**
         * Constructs a new CMD_GoldQuit.
         * @memberof Auth
         * @classdesc Represents a CMD_GoldQuit.
         * @implements ICMD_GoldQuit
         * @constructor
         * @param {Auth.ICMD_GoldQuit=} [properties] Properties to set
         */
        function CMD_GoldQuit(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_GoldQuit GoldID.
         * @member {number} GoldID
         * @memberof Auth.CMD_GoldQuit
         * @instance
         */
        CMD_GoldQuit.prototype.GoldID = 0;

        /**
         * CMD_GoldQuit UserID.
         * @member {number|Long} UserID
         * @memberof Auth.CMD_GoldQuit
         * @instance
         */
        CMD_GoldQuit.prototype.UserID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CMD_GoldQuit CompetitionID.
         * @member {number} CompetitionID
         * @memberof Auth.CMD_GoldQuit
         * @instance
         */
        CMD_GoldQuit.prototype.CompetitionID = 0;

        /**
         * Creates a new CMD_GoldQuit instance using the specified properties.
         * @function create
         * @memberof Auth.CMD_GoldQuit
         * @static
         * @param {Auth.ICMD_GoldQuit=} [properties] Properties to set
         * @returns {Auth.CMD_GoldQuit} CMD_GoldQuit instance
         */
        CMD_GoldQuit.create = function create(properties) {
            return new CMD_GoldQuit(properties);
        };

        /**
         * Encodes the specified CMD_GoldQuit message. Does not implicitly {@link Auth.CMD_GoldQuit.verify|verify} messages.
         * @function encode
         * @memberof Auth.CMD_GoldQuit
         * @static
         * @param {Auth.ICMD_GoldQuit} message CMD_GoldQuit message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_GoldQuit.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.GoldID != null && message.hasOwnProperty("GoldID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.GoldID);
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.UserID);
            if (message.CompetitionID != null && message.hasOwnProperty("CompetitionID"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.CompetitionID);
            return writer;
        };

        /**
         * Encodes the specified CMD_GoldQuit message, length delimited. Does not implicitly {@link Auth.CMD_GoldQuit.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.CMD_GoldQuit
         * @static
         * @param {Auth.ICMD_GoldQuit} message CMD_GoldQuit message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_GoldQuit.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_GoldQuit message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.CMD_GoldQuit
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.CMD_GoldQuit} CMD_GoldQuit
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_GoldQuit.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.CMD_GoldQuit();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.GoldID = reader.uint32();
                    break;
                case 2:
                    message.UserID = reader.uint64();
                    break;
                case 3:
                    message.CompetitionID = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_GoldQuit message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.CMD_GoldQuit
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.CMD_GoldQuit} CMD_GoldQuit
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_GoldQuit.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_GoldQuit message.
         * @function verify
         * @memberof Auth.CMD_GoldQuit
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_GoldQuit.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.GoldID != null && message.hasOwnProperty("GoldID"))
                if (!$util.isInteger(message.GoldID))
                    return "GoldID: integer expected";
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (!$util.isInteger(message.UserID) && !(message.UserID && $util.isInteger(message.UserID.low) && $util.isInteger(message.UserID.high)))
                    return "UserID: integer|Long expected";
            if (message.CompetitionID != null && message.hasOwnProperty("CompetitionID"))
                if (!$util.isInteger(message.CompetitionID))
                    return "CompetitionID: integer expected";
            return null;
        };

        /**
         * Creates a CMD_GoldQuit message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.CMD_GoldQuit
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.CMD_GoldQuit} CMD_GoldQuit
         */
        CMD_GoldQuit.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.CMD_GoldQuit)
                return object;
            var message = new $root.Auth.CMD_GoldQuit();
            if (object.GoldID != null)
                message.GoldID = object.GoldID >>> 0;
            if (object.UserID != null)
                if ($util.Long)
                    (message.UserID = $util.Long.fromValue(object.UserID)).unsigned = true;
                else if (typeof object.UserID === "string")
                    message.UserID = parseInt(object.UserID, 10);
                else if (typeof object.UserID === "number")
                    message.UserID = object.UserID;
                else if (typeof object.UserID === "object")
                    message.UserID = new $util.LongBits(object.UserID.low >>> 0, object.UserID.high >>> 0).toNumber(true);
            if (object.CompetitionID != null)
                message.CompetitionID = object.CompetitionID >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a CMD_GoldQuit message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.CMD_GoldQuit
         * @static
         * @param {Auth.CMD_GoldQuit} message CMD_GoldQuit
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_GoldQuit.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.GoldID = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.UserID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.UserID = options.longs === String ? "0" : 0;
                object.CompetitionID = 0;
            }
            if (message.GoldID != null && message.hasOwnProperty("GoldID"))
                object.GoldID = message.GoldID;
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (typeof message.UserID === "number")
                    object.UserID = options.longs === String ? String(message.UserID) : message.UserID;
                else
                    object.UserID = options.longs === String ? $util.Long.prototype.toString.call(message.UserID) : options.longs === Number ? new $util.LongBits(message.UserID.low >>> 0, message.UserID.high >>> 0).toNumber(true) : message.UserID;
            if (message.CompetitionID != null && message.hasOwnProperty("CompetitionID"))
                object.CompetitionID = message.CompetitionID;
            return object;
        };

        /**
         * Converts this CMD_GoldQuit to JSON.
         * @function toJSON
         * @memberof Auth.CMD_GoldQuit
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_GoldQuit.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CMD_GoldQuit;
    })();

    Auth.RSP_GoldQuit = (function() {

        /**
         * Properties of a RSP_GoldQuit.
         * @memberof Auth
         * @interface IRSP_GoldQuit
         * @property {number|null} [GoldID] RSP_GoldQuit GoldID
         * @property {number|Long|null} [UserID] RSP_GoldQuit UserID
         * @property {number|null} [ErrorCode] RSP_GoldQuit ErrorCode
         * @property {string|null} [ErrorInfo] RSP_GoldQuit ErrorInfo
         * @property {number|null} [CompetitionID] RSP_GoldQuit CompetitionID
         */

        /**
         * Constructs a new RSP_GoldQuit.
         * @memberof Auth
         * @classdesc Represents a RSP_GoldQuit.
         * @implements IRSP_GoldQuit
         * @constructor
         * @param {Auth.IRSP_GoldQuit=} [properties] Properties to set
         */
        function RSP_GoldQuit(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RSP_GoldQuit GoldID.
         * @member {number} GoldID
         * @memberof Auth.RSP_GoldQuit
         * @instance
         */
        RSP_GoldQuit.prototype.GoldID = 0;

        /**
         * RSP_GoldQuit UserID.
         * @member {number|Long} UserID
         * @memberof Auth.RSP_GoldQuit
         * @instance
         */
        RSP_GoldQuit.prototype.UserID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RSP_GoldQuit ErrorCode.
         * @member {number} ErrorCode
         * @memberof Auth.RSP_GoldQuit
         * @instance
         */
        RSP_GoldQuit.prototype.ErrorCode = 0;

        /**
         * RSP_GoldQuit ErrorInfo.
         * @member {string} ErrorInfo
         * @memberof Auth.RSP_GoldQuit
         * @instance
         */
        RSP_GoldQuit.prototype.ErrorInfo = "";

        /**
         * RSP_GoldQuit CompetitionID.
         * @member {number} CompetitionID
         * @memberof Auth.RSP_GoldQuit
         * @instance
         */
        RSP_GoldQuit.prototype.CompetitionID = 0;

        /**
         * Creates a new RSP_GoldQuit instance using the specified properties.
         * @function create
         * @memberof Auth.RSP_GoldQuit
         * @static
         * @param {Auth.IRSP_GoldQuit=} [properties] Properties to set
         * @returns {Auth.RSP_GoldQuit} RSP_GoldQuit instance
         */
        RSP_GoldQuit.create = function create(properties) {
            return new RSP_GoldQuit(properties);
        };

        /**
         * Encodes the specified RSP_GoldQuit message. Does not implicitly {@link Auth.RSP_GoldQuit.verify|verify} messages.
         * @function encode
         * @memberof Auth.RSP_GoldQuit
         * @static
         * @param {Auth.IRSP_GoldQuit} message RSP_GoldQuit message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_GoldQuit.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.GoldID != null && message.hasOwnProperty("GoldID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.GoldID);
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.UserID);
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.ErrorCode);
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.ErrorInfo);
            if (message.CompetitionID != null && message.hasOwnProperty("CompetitionID"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.CompetitionID);
            return writer;
        };

        /**
         * Encodes the specified RSP_GoldQuit message, length delimited. Does not implicitly {@link Auth.RSP_GoldQuit.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.RSP_GoldQuit
         * @static
         * @param {Auth.IRSP_GoldQuit} message RSP_GoldQuit message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_GoldQuit.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RSP_GoldQuit message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.RSP_GoldQuit
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.RSP_GoldQuit} RSP_GoldQuit
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_GoldQuit.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.RSP_GoldQuit();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.GoldID = reader.uint32();
                    break;
                case 2:
                    message.UserID = reader.uint64();
                    break;
                case 3:
                    message.ErrorCode = reader.int32();
                    break;
                case 4:
                    message.ErrorInfo = reader.string();
                    break;
                case 5:
                    message.CompetitionID = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RSP_GoldQuit message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.RSP_GoldQuit
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.RSP_GoldQuit} RSP_GoldQuit
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_GoldQuit.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RSP_GoldQuit message.
         * @function verify
         * @memberof Auth.RSP_GoldQuit
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RSP_GoldQuit.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.GoldID != null && message.hasOwnProperty("GoldID"))
                if (!$util.isInteger(message.GoldID))
                    return "GoldID: integer expected";
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (!$util.isInteger(message.UserID) && !(message.UserID && $util.isInteger(message.UserID.low) && $util.isInteger(message.UserID.high)))
                    return "UserID: integer|Long expected";
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                if (!$util.isInteger(message.ErrorCode))
                    return "ErrorCode: integer expected";
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                if (!$util.isString(message.ErrorInfo))
                    return "ErrorInfo: string expected";
            if (message.CompetitionID != null && message.hasOwnProperty("CompetitionID"))
                if (!$util.isInteger(message.CompetitionID))
                    return "CompetitionID: integer expected";
            return null;
        };

        /**
         * Creates a RSP_GoldQuit message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.RSP_GoldQuit
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.RSP_GoldQuit} RSP_GoldQuit
         */
        RSP_GoldQuit.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.RSP_GoldQuit)
                return object;
            var message = new $root.Auth.RSP_GoldQuit();
            if (object.GoldID != null)
                message.GoldID = object.GoldID >>> 0;
            if (object.UserID != null)
                if ($util.Long)
                    (message.UserID = $util.Long.fromValue(object.UserID)).unsigned = true;
                else if (typeof object.UserID === "string")
                    message.UserID = parseInt(object.UserID, 10);
                else if (typeof object.UserID === "number")
                    message.UserID = object.UserID;
                else if (typeof object.UserID === "object")
                    message.UserID = new $util.LongBits(object.UserID.low >>> 0, object.UserID.high >>> 0).toNumber(true);
            if (object.ErrorCode != null)
                message.ErrorCode = object.ErrorCode | 0;
            if (object.ErrorInfo != null)
                message.ErrorInfo = String(object.ErrorInfo);
            if (object.CompetitionID != null)
                message.CompetitionID = object.CompetitionID >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a RSP_GoldQuit message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.RSP_GoldQuit
         * @static
         * @param {Auth.RSP_GoldQuit} message RSP_GoldQuit
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RSP_GoldQuit.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.GoldID = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.UserID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.UserID = options.longs === String ? "0" : 0;
                object.ErrorCode = 0;
                object.ErrorInfo = "";
                object.CompetitionID = 0;
            }
            if (message.GoldID != null && message.hasOwnProperty("GoldID"))
                object.GoldID = message.GoldID;
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (typeof message.UserID === "number")
                    object.UserID = options.longs === String ? String(message.UserID) : message.UserID;
                else
                    object.UserID = options.longs === String ? $util.Long.prototype.toString.call(message.UserID) : options.longs === Number ? new $util.LongBits(message.UserID.low >>> 0, message.UserID.high >>> 0).toNumber(true) : message.UserID;
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                object.ErrorCode = message.ErrorCode;
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                object.ErrorInfo = message.ErrorInfo;
            if (message.CompetitionID != null && message.hasOwnProperty("CompetitionID"))
                object.CompetitionID = message.CompetitionID;
            return object;
        };

        /**
         * Converts this RSP_GoldQuit to JSON.
         * @function toJSON
         * @memberof Auth.RSP_GoldQuit
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RSP_GoldQuit.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RSP_GoldQuit;
    })();

    Auth.Notify_GoldRoomInfo = (function() {

        /**
         * Properties of a Notify_GoldRoomInfo.
         * @memberof Auth
         * @interface INotify_GoldRoomInfo
         * @property {number|null} [RoomID] Notify_GoldRoomInfo RoomID
         * @property {Array.<Auth.Notify_GoldRoomInfo.IPlayerInfo>|null} [Players] Notify_GoldRoomInfo Players
         * @property {number|null} [UserID] Notify_GoldRoomInfo UserID
         * @property {string|null} [Password] Notify_GoldRoomInfo Password
         * @property {string|null} [PlayRule] Notify_GoldRoomInfo PlayRule
         * @property {string|null} [Host] Notify_GoldRoomInfo Host
         * @property {number|null} [Port] Notify_GoldRoomInfo Port
         * @property {number|null} [RoomHisID] Notify_GoldRoomInfo RoomHisID
         */

        /**
         * Constructs a new Notify_GoldRoomInfo.
         * @memberof Auth
         * @classdesc Represents a Notify_GoldRoomInfo.
         * @implements INotify_GoldRoomInfo
         * @constructor
         * @param {Auth.INotify_GoldRoomInfo=} [properties] Properties to set
         */
        function Notify_GoldRoomInfo(properties) {
            this.Players = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Notify_GoldRoomInfo RoomID.
         * @member {number} RoomID
         * @memberof Auth.Notify_GoldRoomInfo
         * @instance
         */
        Notify_GoldRoomInfo.prototype.RoomID = 0;

        /**
         * Notify_GoldRoomInfo Players.
         * @member {Array.<Auth.Notify_GoldRoomInfo.IPlayerInfo>} Players
         * @memberof Auth.Notify_GoldRoomInfo
         * @instance
         */
        Notify_GoldRoomInfo.prototype.Players = $util.emptyArray;

        /**
         * Notify_GoldRoomInfo UserID.
         * @member {number} UserID
         * @memberof Auth.Notify_GoldRoomInfo
         * @instance
         */
        Notify_GoldRoomInfo.prototype.UserID = 0;

        /**
         * Notify_GoldRoomInfo Password.
         * @member {string} Password
         * @memberof Auth.Notify_GoldRoomInfo
         * @instance
         */
        Notify_GoldRoomInfo.prototype.Password = "";

        /**
         * Notify_GoldRoomInfo PlayRule.
         * @member {string} PlayRule
         * @memberof Auth.Notify_GoldRoomInfo
         * @instance
         */
        Notify_GoldRoomInfo.prototype.PlayRule = "";

        /**
         * Notify_GoldRoomInfo Host.
         * @member {string} Host
         * @memberof Auth.Notify_GoldRoomInfo
         * @instance
         */
        Notify_GoldRoomInfo.prototype.Host = "";

        /**
         * Notify_GoldRoomInfo Port.
         * @member {number} Port
         * @memberof Auth.Notify_GoldRoomInfo
         * @instance
         */
        Notify_GoldRoomInfo.prototype.Port = 0;

        /**
         * Notify_GoldRoomInfo RoomHisID.
         * @member {number} RoomHisID
         * @memberof Auth.Notify_GoldRoomInfo
         * @instance
         */
        Notify_GoldRoomInfo.prototype.RoomHisID = 0;

        /**
         * Creates a new Notify_GoldRoomInfo instance using the specified properties.
         * @function create
         * @memberof Auth.Notify_GoldRoomInfo
         * @static
         * @param {Auth.INotify_GoldRoomInfo=} [properties] Properties to set
         * @returns {Auth.Notify_GoldRoomInfo} Notify_GoldRoomInfo instance
         */
        Notify_GoldRoomInfo.create = function create(properties) {
            return new Notify_GoldRoomInfo(properties);
        };

        /**
         * Encodes the specified Notify_GoldRoomInfo message. Does not implicitly {@link Auth.Notify_GoldRoomInfo.verify|verify} messages.
         * @function encode
         * @memberof Auth.Notify_GoldRoomInfo
         * @static
         * @param {Auth.INotify_GoldRoomInfo} message Notify_GoldRoomInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Notify_GoldRoomInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.RoomID != null && message.hasOwnProperty("RoomID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.RoomID);
            if (message.Players != null && message.Players.length)
                for (var i = 0; i < message.Players.length; ++i)
                    $root.Auth.Notify_GoldRoomInfo.PlayerInfo.encode(message.Players[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.UserID);
            if (message.Password != null && message.hasOwnProperty("Password"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.Password);
            if (message.PlayRule != null && message.hasOwnProperty("PlayRule"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.PlayRule);
            if (message.Host != null && message.hasOwnProperty("Host"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.Host);
            if (message.Port != null && message.hasOwnProperty("Port"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.Port);
            if (message.RoomHisID != null && message.hasOwnProperty("RoomHisID"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.RoomHisID);
            return writer;
        };

        /**
         * Encodes the specified Notify_GoldRoomInfo message, length delimited. Does not implicitly {@link Auth.Notify_GoldRoomInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.Notify_GoldRoomInfo
         * @static
         * @param {Auth.INotify_GoldRoomInfo} message Notify_GoldRoomInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Notify_GoldRoomInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Notify_GoldRoomInfo message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.Notify_GoldRoomInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.Notify_GoldRoomInfo} Notify_GoldRoomInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Notify_GoldRoomInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.Notify_GoldRoomInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.RoomID = reader.uint32();
                    break;
                case 2:
                    if (!(message.Players && message.Players.length))
                        message.Players = [];
                    message.Players.push($root.Auth.Notify_GoldRoomInfo.PlayerInfo.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.UserID = reader.uint32();
                    break;
                case 4:
                    message.Password = reader.string();
                    break;
                case 5:
                    message.PlayRule = reader.string();
                    break;
                case 6:
                    message.Host = reader.string();
                    break;
                case 7:
                    message.Port = reader.uint32();
                    break;
                case 8:
                    message.RoomHisID = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Notify_GoldRoomInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.Notify_GoldRoomInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.Notify_GoldRoomInfo} Notify_GoldRoomInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Notify_GoldRoomInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Notify_GoldRoomInfo message.
         * @function verify
         * @memberof Auth.Notify_GoldRoomInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Notify_GoldRoomInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.RoomID != null && message.hasOwnProperty("RoomID"))
                if (!$util.isInteger(message.RoomID))
                    return "RoomID: integer expected";
            if (message.Players != null && message.hasOwnProperty("Players")) {
                if (!Array.isArray(message.Players))
                    return "Players: array expected";
                for (var i = 0; i < message.Players.length; ++i) {
                    var error = $root.Auth.Notify_GoldRoomInfo.PlayerInfo.verify(message.Players[i]);
                    if (error)
                        return "Players." + error;
                }
            }
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (!$util.isInteger(message.UserID))
                    return "UserID: integer expected";
            if (message.Password != null && message.hasOwnProperty("Password"))
                if (!$util.isString(message.Password))
                    return "Password: string expected";
            if (message.PlayRule != null && message.hasOwnProperty("PlayRule"))
                if (!$util.isString(message.PlayRule))
                    return "PlayRule: string expected";
            if (message.Host != null && message.hasOwnProperty("Host"))
                if (!$util.isString(message.Host))
                    return "Host: string expected";
            if (message.Port != null && message.hasOwnProperty("Port"))
                if (!$util.isInteger(message.Port))
                    return "Port: integer expected";
            if (message.RoomHisID != null && message.hasOwnProperty("RoomHisID"))
                if (!$util.isInteger(message.RoomHisID))
                    return "RoomHisID: integer expected";
            return null;
        };

        /**
         * Creates a Notify_GoldRoomInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.Notify_GoldRoomInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.Notify_GoldRoomInfo} Notify_GoldRoomInfo
         */
        Notify_GoldRoomInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.Notify_GoldRoomInfo)
                return object;
            var message = new $root.Auth.Notify_GoldRoomInfo();
            if (object.RoomID != null)
                message.RoomID = object.RoomID >>> 0;
            if (object.Players) {
                if (!Array.isArray(object.Players))
                    throw TypeError(".Auth.Notify_GoldRoomInfo.Players: array expected");
                message.Players = [];
                for (var i = 0; i < object.Players.length; ++i) {
                    if (typeof object.Players[i] !== "object")
                        throw TypeError(".Auth.Notify_GoldRoomInfo.Players: object expected");
                    message.Players[i] = $root.Auth.Notify_GoldRoomInfo.PlayerInfo.fromObject(object.Players[i]);
                }
            }
            if (object.UserID != null)
                message.UserID = object.UserID >>> 0;
            if (object.Password != null)
                message.Password = String(object.Password);
            if (object.PlayRule != null)
                message.PlayRule = String(object.PlayRule);
            if (object.Host != null)
                message.Host = String(object.Host);
            if (object.Port != null)
                message.Port = object.Port >>> 0;
            if (object.RoomHisID != null)
                message.RoomHisID = object.RoomHisID >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Notify_GoldRoomInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.Notify_GoldRoomInfo
         * @static
         * @param {Auth.Notify_GoldRoomInfo} message Notify_GoldRoomInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Notify_GoldRoomInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.Players = [];
            if (options.defaults) {
                object.RoomID = 0;
                object.UserID = 0;
                object.Password = "";
                object.PlayRule = "";
                object.Host = "";
                object.Port = 0;
                object.RoomHisID = 0;
            }
            if (message.RoomID != null && message.hasOwnProperty("RoomID"))
                object.RoomID = message.RoomID;
            if (message.Players && message.Players.length) {
                object.Players = [];
                for (var j = 0; j < message.Players.length; ++j)
                    object.Players[j] = $root.Auth.Notify_GoldRoomInfo.PlayerInfo.toObject(message.Players[j], options);
            }
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                object.UserID = message.UserID;
            if (message.Password != null && message.hasOwnProperty("Password"))
                object.Password = message.Password;
            if (message.PlayRule != null && message.hasOwnProperty("PlayRule"))
                object.PlayRule = message.PlayRule;
            if (message.Host != null && message.hasOwnProperty("Host"))
                object.Host = message.Host;
            if (message.Port != null && message.hasOwnProperty("Port"))
                object.Port = message.Port;
            if (message.RoomHisID != null && message.hasOwnProperty("RoomHisID"))
                object.RoomHisID = message.RoomHisID;
            return object;
        };

        /**
         * Converts this Notify_GoldRoomInfo to JSON.
         * @function toJSON
         * @memberof Auth.Notify_GoldRoomInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Notify_GoldRoomInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        Notify_GoldRoomInfo.PlayerInfo = (function() {

            /**
             * Properties of a PlayerInfo.
             * @memberof Auth.Notify_GoldRoomInfo
             * @interface IPlayerInfo
             * @property {number|Long|null} [UserID] PlayerInfo UserID
             * @property {number|null} [SeatID] PlayerInfo SeatID
             */

            /**
             * Constructs a new PlayerInfo.
             * @memberof Auth.Notify_GoldRoomInfo
             * @classdesc Represents a PlayerInfo.
             * @implements IPlayerInfo
             * @constructor
             * @param {Auth.Notify_GoldRoomInfo.IPlayerInfo=} [properties] Properties to set
             */
            function PlayerInfo(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PlayerInfo UserID.
             * @member {number|Long} UserID
             * @memberof Auth.Notify_GoldRoomInfo.PlayerInfo
             * @instance
             */
            PlayerInfo.prototype.UserID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * PlayerInfo SeatID.
             * @member {number} SeatID
             * @memberof Auth.Notify_GoldRoomInfo.PlayerInfo
             * @instance
             */
            PlayerInfo.prototype.SeatID = 0;

            /**
             * Creates a new PlayerInfo instance using the specified properties.
             * @function create
             * @memberof Auth.Notify_GoldRoomInfo.PlayerInfo
             * @static
             * @param {Auth.Notify_GoldRoomInfo.IPlayerInfo=} [properties] Properties to set
             * @returns {Auth.Notify_GoldRoomInfo.PlayerInfo} PlayerInfo instance
             */
            PlayerInfo.create = function create(properties) {
                return new PlayerInfo(properties);
            };

            /**
             * Encodes the specified PlayerInfo message. Does not implicitly {@link Auth.Notify_GoldRoomInfo.PlayerInfo.verify|verify} messages.
             * @function encode
             * @memberof Auth.Notify_GoldRoomInfo.PlayerInfo
             * @static
             * @param {Auth.Notify_GoldRoomInfo.IPlayerInfo} message PlayerInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PlayerInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.UserID != null && message.hasOwnProperty("UserID"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.UserID);
                if (message.SeatID != null && message.hasOwnProperty("SeatID"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.SeatID);
                return writer;
            };

            /**
             * Encodes the specified PlayerInfo message, length delimited. Does not implicitly {@link Auth.Notify_GoldRoomInfo.PlayerInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Auth.Notify_GoldRoomInfo.PlayerInfo
             * @static
             * @param {Auth.Notify_GoldRoomInfo.IPlayerInfo} message PlayerInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PlayerInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PlayerInfo message from the specified reader or buffer.
             * @function decode
             * @memberof Auth.Notify_GoldRoomInfo.PlayerInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Auth.Notify_GoldRoomInfo.PlayerInfo} PlayerInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PlayerInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.Notify_GoldRoomInfo.PlayerInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.UserID = reader.uint64();
                        break;
                    case 2:
                        message.SeatID = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PlayerInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Auth.Notify_GoldRoomInfo.PlayerInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Auth.Notify_GoldRoomInfo.PlayerInfo} PlayerInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PlayerInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PlayerInfo message.
             * @function verify
             * @memberof Auth.Notify_GoldRoomInfo.PlayerInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PlayerInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.UserID != null && message.hasOwnProperty("UserID"))
                    if (!$util.isInteger(message.UserID) && !(message.UserID && $util.isInteger(message.UserID.low) && $util.isInteger(message.UserID.high)))
                        return "UserID: integer|Long expected";
                if (message.SeatID != null && message.hasOwnProperty("SeatID"))
                    if (!$util.isInteger(message.SeatID))
                        return "SeatID: integer expected";
                return null;
            };

            /**
             * Creates a PlayerInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Auth.Notify_GoldRoomInfo.PlayerInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Auth.Notify_GoldRoomInfo.PlayerInfo} PlayerInfo
             */
            PlayerInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.Auth.Notify_GoldRoomInfo.PlayerInfo)
                    return object;
                var message = new $root.Auth.Notify_GoldRoomInfo.PlayerInfo();
                if (object.UserID != null)
                    if ($util.Long)
                        (message.UserID = $util.Long.fromValue(object.UserID)).unsigned = true;
                    else if (typeof object.UserID === "string")
                        message.UserID = parseInt(object.UserID, 10);
                    else if (typeof object.UserID === "number")
                        message.UserID = object.UserID;
                    else if (typeof object.UserID === "object")
                        message.UserID = new $util.LongBits(object.UserID.low >>> 0, object.UserID.high >>> 0).toNumber(true);
                if (object.SeatID != null)
                    message.SeatID = object.SeatID >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a PlayerInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Auth.Notify_GoldRoomInfo.PlayerInfo
             * @static
             * @param {Auth.Notify_GoldRoomInfo.PlayerInfo} message PlayerInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PlayerInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.UserID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.UserID = options.longs === String ? "0" : 0;
                    object.SeatID = 0;
                }
                if (message.UserID != null && message.hasOwnProperty("UserID"))
                    if (typeof message.UserID === "number")
                        object.UserID = options.longs === String ? String(message.UserID) : message.UserID;
                    else
                        object.UserID = options.longs === String ? $util.Long.prototype.toString.call(message.UserID) : options.longs === Number ? new $util.LongBits(message.UserID.low >>> 0, message.UserID.high >>> 0).toNumber(true) : message.UserID;
                if (message.SeatID != null && message.hasOwnProperty("SeatID"))
                    object.SeatID = message.SeatID;
                return object;
            };

            /**
             * Converts this PlayerInfo to JSON.
             * @function toJSON
             * @memberof Auth.Notify_GoldRoomInfo.PlayerInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PlayerInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return PlayerInfo;
        })();

        return Notify_GoldRoomInfo;
    })();

    Auth.CMD_MatchSignUp = (function() {

        /**
         * Properties of a CMD_MatchSignUp.
         * @memberof Auth
         * @interface ICMD_MatchSignUp
         * @property {number|Long|null} [MatchID] CMD_MatchSignUp MatchID
         * @property {number|Long|null} [StageID] CMD_MatchSignUp StageID
         * @property {number|Long|null} [UserID] CMD_MatchSignUp UserID
         * @property {number|Long|null} [ConditionID] CMD_MatchSignUp ConditionID
         */

        /**
         * Constructs a new CMD_MatchSignUp.
         * @memberof Auth
         * @classdesc Represents a CMD_MatchSignUp.
         * @implements ICMD_MatchSignUp
         * @constructor
         * @param {Auth.ICMD_MatchSignUp=} [properties] Properties to set
         */
        function CMD_MatchSignUp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_MatchSignUp MatchID.
         * @member {number|Long} MatchID
         * @memberof Auth.CMD_MatchSignUp
         * @instance
         */
        CMD_MatchSignUp.prototype.MatchID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CMD_MatchSignUp StageID.
         * @member {number|Long} StageID
         * @memberof Auth.CMD_MatchSignUp
         * @instance
         */
        CMD_MatchSignUp.prototype.StageID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CMD_MatchSignUp UserID.
         * @member {number|Long} UserID
         * @memberof Auth.CMD_MatchSignUp
         * @instance
         */
        CMD_MatchSignUp.prototype.UserID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CMD_MatchSignUp ConditionID.
         * @member {number|Long} ConditionID
         * @memberof Auth.CMD_MatchSignUp
         * @instance
         */
        CMD_MatchSignUp.prototype.ConditionID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new CMD_MatchSignUp instance using the specified properties.
         * @function create
         * @memberof Auth.CMD_MatchSignUp
         * @static
         * @param {Auth.ICMD_MatchSignUp=} [properties] Properties to set
         * @returns {Auth.CMD_MatchSignUp} CMD_MatchSignUp instance
         */
        CMD_MatchSignUp.create = function create(properties) {
            return new CMD_MatchSignUp(properties);
        };

        /**
         * Encodes the specified CMD_MatchSignUp message. Does not implicitly {@link Auth.CMD_MatchSignUp.verify|verify} messages.
         * @function encode
         * @memberof Auth.CMD_MatchSignUp
         * @static
         * @param {Auth.ICMD_MatchSignUp} message CMD_MatchSignUp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_MatchSignUp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.MatchID);
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.StageID);
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.UserID);
            if (message.ConditionID != null && message.hasOwnProperty("ConditionID"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.ConditionID);
            return writer;
        };

        /**
         * Encodes the specified CMD_MatchSignUp message, length delimited. Does not implicitly {@link Auth.CMD_MatchSignUp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.CMD_MatchSignUp
         * @static
         * @param {Auth.ICMD_MatchSignUp} message CMD_MatchSignUp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_MatchSignUp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_MatchSignUp message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.CMD_MatchSignUp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.CMD_MatchSignUp} CMD_MatchSignUp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_MatchSignUp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.CMD_MatchSignUp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.MatchID = reader.uint64();
                    break;
                case 2:
                    message.StageID = reader.uint64();
                    break;
                case 3:
                    message.UserID = reader.uint64();
                    break;
                case 4:
                    message.ConditionID = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_MatchSignUp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.CMD_MatchSignUp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.CMD_MatchSignUp} CMD_MatchSignUp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_MatchSignUp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_MatchSignUp message.
         * @function verify
         * @memberof Auth.CMD_MatchSignUp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_MatchSignUp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                if (!$util.isInteger(message.MatchID) && !(message.MatchID && $util.isInteger(message.MatchID.low) && $util.isInteger(message.MatchID.high)))
                    return "MatchID: integer|Long expected";
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                if (!$util.isInteger(message.StageID) && !(message.StageID && $util.isInteger(message.StageID.low) && $util.isInteger(message.StageID.high)))
                    return "StageID: integer|Long expected";
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (!$util.isInteger(message.UserID) && !(message.UserID && $util.isInteger(message.UserID.low) && $util.isInteger(message.UserID.high)))
                    return "UserID: integer|Long expected";
            if (message.ConditionID != null && message.hasOwnProperty("ConditionID"))
                if (!$util.isInteger(message.ConditionID) && !(message.ConditionID && $util.isInteger(message.ConditionID.low) && $util.isInteger(message.ConditionID.high)))
                    return "ConditionID: integer|Long expected";
            return null;
        };

        /**
         * Creates a CMD_MatchSignUp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.CMD_MatchSignUp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.CMD_MatchSignUp} CMD_MatchSignUp
         */
        CMD_MatchSignUp.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.CMD_MatchSignUp)
                return object;
            var message = new $root.Auth.CMD_MatchSignUp();
            if (object.MatchID != null)
                if ($util.Long)
                    (message.MatchID = $util.Long.fromValue(object.MatchID)).unsigned = true;
                else if (typeof object.MatchID === "string")
                    message.MatchID = parseInt(object.MatchID, 10);
                else if (typeof object.MatchID === "number")
                    message.MatchID = object.MatchID;
                else if (typeof object.MatchID === "object")
                    message.MatchID = new $util.LongBits(object.MatchID.low >>> 0, object.MatchID.high >>> 0).toNumber(true);
            if (object.StageID != null)
                if ($util.Long)
                    (message.StageID = $util.Long.fromValue(object.StageID)).unsigned = true;
                else if (typeof object.StageID === "string")
                    message.StageID = parseInt(object.StageID, 10);
                else if (typeof object.StageID === "number")
                    message.StageID = object.StageID;
                else if (typeof object.StageID === "object")
                    message.StageID = new $util.LongBits(object.StageID.low >>> 0, object.StageID.high >>> 0).toNumber(true);
            if (object.UserID != null)
                if ($util.Long)
                    (message.UserID = $util.Long.fromValue(object.UserID)).unsigned = true;
                else if (typeof object.UserID === "string")
                    message.UserID = parseInt(object.UserID, 10);
                else if (typeof object.UserID === "number")
                    message.UserID = object.UserID;
                else if (typeof object.UserID === "object")
                    message.UserID = new $util.LongBits(object.UserID.low >>> 0, object.UserID.high >>> 0).toNumber(true);
            if (object.ConditionID != null)
                if ($util.Long)
                    (message.ConditionID = $util.Long.fromValue(object.ConditionID)).unsigned = true;
                else if (typeof object.ConditionID === "string")
                    message.ConditionID = parseInt(object.ConditionID, 10);
                else if (typeof object.ConditionID === "number")
                    message.ConditionID = object.ConditionID;
                else if (typeof object.ConditionID === "object")
                    message.ConditionID = new $util.LongBits(object.ConditionID.low >>> 0, object.ConditionID.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a CMD_MatchSignUp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.CMD_MatchSignUp
         * @static
         * @param {Auth.CMD_MatchSignUp} message CMD_MatchSignUp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_MatchSignUp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.MatchID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.MatchID = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.StageID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.StageID = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.UserID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.UserID = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.ConditionID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.ConditionID = options.longs === String ? "0" : 0;
            }
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                if (typeof message.MatchID === "number")
                    object.MatchID = options.longs === String ? String(message.MatchID) : message.MatchID;
                else
                    object.MatchID = options.longs === String ? $util.Long.prototype.toString.call(message.MatchID) : options.longs === Number ? new $util.LongBits(message.MatchID.low >>> 0, message.MatchID.high >>> 0).toNumber(true) : message.MatchID;
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                if (typeof message.StageID === "number")
                    object.StageID = options.longs === String ? String(message.StageID) : message.StageID;
                else
                    object.StageID = options.longs === String ? $util.Long.prototype.toString.call(message.StageID) : options.longs === Number ? new $util.LongBits(message.StageID.low >>> 0, message.StageID.high >>> 0).toNumber(true) : message.StageID;
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (typeof message.UserID === "number")
                    object.UserID = options.longs === String ? String(message.UserID) : message.UserID;
                else
                    object.UserID = options.longs === String ? $util.Long.prototype.toString.call(message.UserID) : options.longs === Number ? new $util.LongBits(message.UserID.low >>> 0, message.UserID.high >>> 0).toNumber(true) : message.UserID;
            if (message.ConditionID != null && message.hasOwnProperty("ConditionID"))
                if (typeof message.ConditionID === "number")
                    object.ConditionID = options.longs === String ? String(message.ConditionID) : message.ConditionID;
                else
                    object.ConditionID = options.longs === String ? $util.Long.prototype.toString.call(message.ConditionID) : options.longs === Number ? new $util.LongBits(message.ConditionID.low >>> 0, message.ConditionID.high >>> 0).toNumber(true) : message.ConditionID;
            return object;
        };

        /**
         * Converts this CMD_MatchSignUp to JSON.
         * @function toJSON
         * @memberof Auth.CMD_MatchSignUp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_MatchSignUp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CMD_MatchSignUp;
    })();

    Auth.RSP_MatchSignUp = (function() {

        /**
         * Properties of a RSP_MatchSignUp.
         * @memberof Auth
         * @interface IRSP_MatchSignUp
         * @property {number|Long|null} [MatchID] RSP_MatchSignUp MatchID
         * @property {number|Long|null} [StageID] RSP_MatchSignUp StageID
         * @property {number|Long|null} [UserID] RSP_MatchSignUp UserID
         * @property {number|null} [ErrorCode] RSP_MatchSignUp ErrorCode
         * @property {string|null} [ErrorInfo] RSP_MatchSignUp ErrorInfo
         * @property {number|Long|null} [SignupUserCnt] RSP_MatchSignUp SignupUserCnt
         */

        /**
         * Constructs a new RSP_MatchSignUp.
         * @memberof Auth
         * @classdesc Represents a RSP_MatchSignUp.
         * @implements IRSP_MatchSignUp
         * @constructor
         * @param {Auth.IRSP_MatchSignUp=} [properties] Properties to set
         */
        function RSP_MatchSignUp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RSP_MatchSignUp MatchID.
         * @member {number|Long} MatchID
         * @memberof Auth.RSP_MatchSignUp
         * @instance
         */
        RSP_MatchSignUp.prototype.MatchID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RSP_MatchSignUp StageID.
         * @member {number|Long} StageID
         * @memberof Auth.RSP_MatchSignUp
         * @instance
         */
        RSP_MatchSignUp.prototype.StageID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RSP_MatchSignUp UserID.
         * @member {number|Long} UserID
         * @memberof Auth.RSP_MatchSignUp
         * @instance
         */
        RSP_MatchSignUp.prototype.UserID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RSP_MatchSignUp ErrorCode.
         * @member {number} ErrorCode
         * @memberof Auth.RSP_MatchSignUp
         * @instance
         */
        RSP_MatchSignUp.prototype.ErrorCode = 0;

        /**
         * RSP_MatchSignUp ErrorInfo.
         * @member {string} ErrorInfo
         * @memberof Auth.RSP_MatchSignUp
         * @instance
         */
        RSP_MatchSignUp.prototype.ErrorInfo = "";

        /**
         * RSP_MatchSignUp SignupUserCnt.
         * @member {number|Long} SignupUserCnt
         * @memberof Auth.RSP_MatchSignUp
         * @instance
         */
        RSP_MatchSignUp.prototype.SignupUserCnt = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new RSP_MatchSignUp instance using the specified properties.
         * @function create
         * @memberof Auth.RSP_MatchSignUp
         * @static
         * @param {Auth.IRSP_MatchSignUp=} [properties] Properties to set
         * @returns {Auth.RSP_MatchSignUp} RSP_MatchSignUp instance
         */
        RSP_MatchSignUp.create = function create(properties) {
            return new RSP_MatchSignUp(properties);
        };

        /**
         * Encodes the specified RSP_MatchSignUp message. Does not implicitly {@link Auth.RSP_MatchSignUp.verify|verify} messages.
         * @function encode
         * @memberof Auth.RSP_MatchSignUp
         * @static
         * @param {Auth.IRSP_MatchSignUp} message RSP_MatchSignUp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_MatchSignUp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.MatchID);
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.StageID);
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.UserID);
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.ErrorCode);
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.ErrorInfo);
            if (message.SignupUserCnt != null && message.hasOwnProperty("SignupUserCnt"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.SignupUserCnt);
            return writer;
        };

        /**
         * Encodes the specified RSP_MatchSignUp message, length delimited. Does not implicitly {@link Auth.RSP_MatchSignUp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.RSP_MatchSignUp
         * @static
         * @param {Auth.IRSP_MatchSignUp} message RSP_MatchSignUp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_MatchSignUp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RSP_MatchSignUp message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.RSP_MatchSignUp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.RSP_MatchSignUp} RSP_MatchSignUp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_MatchSignUp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.RSP_MatchSignUp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.MatchID = reader.uint64();
                    break;
                case 2:
                    message.StageID = reader.uint64();
                    break;
                case 3:
                    message.UserID = reader.uint64();
                    break;
                case 4:
                    message.ErrorCode = reader.uint32();
                    break;
                case 5:
                    message.ErrorInfo = reader.string();
                    break;
                case 6:
                    message.SignupUserCnt = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RSP_MatchSignUp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.RSP_MatchSignUp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.RSP_MatchSignUp} RSP_MatchSignUp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_MatchSignUp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RSP_MatchSignUp message.
         * @function verify
         * @memberof Auth.RSP_MatchSignUp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RSP_MatchSignUp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                if (!$util.isInteger(message.MatchID) && !(message.MatchID && $util.isInteger(message.MatchID.low) && $util.isInteger(message.MatchID.high)))
                    return "MatchID: integer|Long expected";
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                if (!$util.isInteger(message.StageID) && !(message.StageID && $util.isInteger(message.StageID.low) && $util.isInteger(message.StageID.high)))
                    return "StageID: integer|Long expected";
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (!$util.isInteger(message.UserID) && !(message.UserID && $util.isInteger(message.UserID.low) && $util.isInteger(message.UserID.high)))
                    return "UserID: integer|Long expected";
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                if (!$util.isInteger(message.ErrorCode))
                    return "ErrorCode: integer expected";
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                if (!$util.isString(message.ErrorInfo))
                    return "ErrorInfo: string expected";
            if (message.SignupUserCnt != null && message.hasOwnProperty("SignupUserCnt"))
                if (!$util.isInteger(message.SignupUserCnt) && !(message.SignupUserCnt && $util.isInteger(message.SignupUserCnt.low) && $util.isInteger(message.SignupUserCnt.high)))
                    return "SignupUserCnt: integer|Long expected";
            return null;
        };

        /**
         * Creates a RSP_MatchSignUp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.RSP_MatchSignUp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.RSP_MatchSignUp} RSP_MatchSignUp
         */
        RSP_MatchSignUp.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.RSP_MatchSignUp)
                return object;
            var message = new $root.Auth.RSP_MatchSignUp();
            if (object.MatchID != null)
                if ($util.Long)
                    (message.MatchID = $util.Long.fromValue(object.MatchID)).unsigned = true;
                else if (typeof object.MatchID === "string")
                    message.MatchID = parseInt(object.MatchID, 10);
                else if (typeof object.MatchID === "number")
                    message.MatchID = object.MatchID;
                else if (typeof object.MatchID === "object")
                    message.MatchID = new $util.LongBits(object.MatchID.low >>> 0, object.MatchID.high >>> 0).toNumber(true);
            if (object.StageID != null)
                if ($util.Long)
                    (message.StageID = $util.Long.fromValue(object.StageID)).unsigned = true;
                else if (typeof object.StageID === "string")
                    message.StageID = parseInt(object.StageID, 10);
                else if (typeof object.StageID === "number")
                    message.StageID = object.StageID;
                else if (typeof object.StageID === "object")
                    message.StageID = new $util.LongBits(object.StageID.low >>> 0, object.StageID.high >>> 0).toNumber(true);
            if (object.UserID != null)
                if ($util.Long)
                    (message.UserID = $util.Long.fromValue(object.UserID)).unsigned = true;
                else if (typeof object.UserID === "string")
                    message.UserID = parseInt(object.UserID, 10);
                else if (typeof object.UserID === "number")
                    message.UserID = object.UserID;
                else if (typeof object.UserID === "object")
                    message.UserID = new $util.LongBits(object.UserID.low >>> 0, object.UserID.high >>> 0).toNumber(true);
            if (object.ErrorCode != null)
                message.ErrorCode = object.ErrorCode >>> 0;
            if (object.ErrorInfo != null)
                message.ErrorInfo = String(object.ErrorInfo);
            if (object.SignupUserCnt != null)
                if ($util.Long)
                    (message.SignupUserCnt = $util.Long.fromValue(object.SignupUserCnt)).unsigned = true;
                else if (typeof object.SignupUserCnt === "string")
                    message.SignupUserCnt = parseInt(object.SignupUserCnt, 10);
                else if (typeof object.SignupUserCnt === "number")
                    message.SignupUserCnt = object.SignupUserCnt;
                else if (typeof object.SignupUserCnt === "object")
                    message.SignupUserCnt = new $util.LongBits(object.SignupUserCnt.low >>> 0, object.SignupUserCnt.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a RSP_MatchSignUp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.RSP_MatchSignUp
         * @static
         * @param {Auth.RSP_MatchSignUp} message RSP_MatchSignUp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RSP_MatchSignUp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.MatchID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.MatchID = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.StageID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.StageID = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.UserID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.UserID = options.longs === String ? "0" : 0;
                object.ErrorCode = 0;
                object.ErrorInfo = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.SignupUserCnt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.SignupUserCnt = options.longs === String ? "0" : 0;
            }
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                if (typeof message.MatchID === "number")
                    object.MatchID = options.longs === String ? String(message.MatchID) : message.MatchID;
                else
                    object.MatchID = options.longs === String ? $util.Long.prototype.toString.call(message.MatchID) : options.longs === Number ? new $util.LongBits(message.MatchID.low >>> 0, message.MatchID.high >>> 0).toNumber(true) : message.MatchID;
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                if (typeof message.StageID === "number")
                    object.StageID = options.longs === String ? String(message.StageID) : message.StageID;
                else
                    object.StageID = options.longs === String ? $util.Long.prototype.toString.call(message.StageID) : options.longs === Number ? new $util.LongBits(message.StageID.low >>> 0, message.StageID.high >>> 0).toNumber(true) : message.StageID;
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (typeof message.UserID === "number")
                    object.UserID = options.longs === String ? String(message.UserID) : message.UserID;
                else
                    object.UserID = options.longs === String ? $util.Long.prototype.toString.call(message.UserID) : options.longs === Number ? new $util.LongBits(message.UserID.low >>> 0, message.UserID.high >>> 0).toNumber(true) : message.UserID;
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                object.ErrorCode = message.ErrorCode;
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                object.ErrorInfo = message.ErrorInfo;
            if (message.SignupUserCnt != null && message.hasOwnProperty("SignupUserCnt"))
                if (typeof message.SignupUserCnt === "number")
                    object.SignupUserCnt = options.longs === String ? String(message.SignupUserCnt) : message.SignupUserCnt;
                else
                    object.SignupUserCnt = options.longs === String ? $util.Long.prototype.toString.call(message.SignupUserCnt) : options.longs === Number ? new $util.LongBits(message.SignupUserCnt.low >>> 0, message.SignupUserCnt.high >>> 0).toNumber(true) : message.SignupUserCnt;
            return object;
        };

        /**
         * Converts this RSP_MatchSignUp to JSON.
         * @function toJSON
         * @memberof Auth.RSP_MatchSignUp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RSP_MatchSignUp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RSP_MatchSignUp;
    })();

    Auth.CMD_MatchWithdraw = (function() {

        /**
         * Properties of a CMD_MatchWithdraw.
         * @memberof Auth
         * @interface ICMD_MatchWithdraw
         * @property {number|Long|null} [MatchID] CMD_MatchWithdraw MatchID
         * @property {number|Long|null} [StageID] CMD_MatchWithdraw StageID
         * @property {number|Long|null} [UserID] CMD_MatchWithdraw UserID
         */

        /**
         * Constructs a new CMD_MatchWithdraw.
         * @memberof Auth
         * @classdesc Represents a CMD_MatchWithdraw.
         * @implements ICMD_MatchWithdraw
         * @constructor
         * @param {Auth.ICMD_MatchWithdraw=} [properties] Properties to set
         */
        function CMD_MatchWithdraw(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_MatchWithdraw MatchID.
         * @member {number|Long} MatchID
         * @memberof Auth.CMD_MatchWithdraw
         * @instance
         */
        CMD_MatchWithdraw.prototype.MatchID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CMD_MatchWithdraw StageID.
         * @member {number|Long} StageID
         * @memberof Auth.CMD_MatchWithdraw
         * @instance
         */
        CMD_MatchWithdraw.prototype.StageID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CMD_MatchWithdraw UserID.
         * @member {number|Long} UserID
         * @memberof Auth.CMD_MatchWithdraw
         * @instance
         */
        CMD_MatchWithdraw.prototype.UserID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new CMD_MatchWithdraw instance using the specified properties.
         * @function create
         * @memberof Auth.CMD_MatchWithdraw
         * @static
         * @param {Auth.ICMD_MatchWithdraw=} [properties] Properties to set
         * @returns {Auth.CMD_MatchWithdraw} CMD_MatchWithdraw instance
         */
        CMD_MatchWithdraw.create = function create(properties) {
            return new CMD_MatchWithdraw(properties);
        };

        /**
         * Encodes the specified CMD_MatchWithdraw message. Does not implicitly {@link Auth.CMD_MatchWithdraw.verify|verify} messages.
         * @function encode
         * @memberof Auth.CMD_MatchWithdraw
         * @static
         * @param {Auth.ICMD_MatchWithdraw} message CMD_MatchWithdraw message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_MatchWithdraw.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.MatchID);
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.StageID);
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.UserID);
            return writer;
        };

        /**
         * Encodes the specified CMD_MatchWithdraw message, length delimited. Does not implicitly {@link Auth.CMD_MatchWithdraw.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.CMD_MatchWithdraw
         * @static
         * @param {Auth.ICMD_MatchWithdraw} message CMD_MatchWithdraw message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_MatchWithdraw.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_MatchWithdraw message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.CMD_MatchWithdraw
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.CMD_MatchWithdraw} CMD_MatchWithdraw
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_MatchWithdraw.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.CMD_MatchWithdraw();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.MatchID = reader.uint64();
                    break;
                case 2:
                    message.StageID = reader.uint64();
                    break;
                case 3:
                    message.UserID = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_MatchWithdraw message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.CMD_MatchWithdraw
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.CMD_MatchWithdraw} CMD_MatchWithdraw
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_MatchWithdraw.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_MatchWithdraw message.
         * @function verify
         * @memberof Auth.CMD_MatchWithdraw
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_MatchWithdraw.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                if (!$util.isInteger(message.MatchID) && !(message.MatchID && $util.isInteger(message.MatchID.low) && $util.isInteger(message.MatchID.high)))
                    return "MatchID: integer|Long expected";
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                if (!$util.isInteger(message.StageID) && !(message.StageID && $util.isInteger(message.StageID.low) && $util.isInteger(message.StageID.high)))
                    return "StageID: integer|Long expected";
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (!$util.isInteger(message.UserID) && !(message.UserID && $util.isInteger(message.UserID.low) && $util.isInteger(message.UserID.high)))
                    return "UserID: integer|Long expected";
            return null;
        };

        /**
         * Creates a CMD_MatchWithdraw message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.CMD_MatchWithdraw
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.CMD_MatchWithdraw} CMD_MatchWithdraw
         */
        CMD_MatchWithdraw.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.CMD_MatchWithdraw)
                return object;
            var message = new $root.Auth.CMD_MatchWithdraw();
            if (object.MatchID != null)
                if ($util.Long)
                    (message.MatchID = $util.Long.fromValue(object.MatchID)).unsigned = true;
                else if (typeof object.MatchID === "string")
                    message.MatchID = parseInt(object.MatchID, 10);
                else if (typeof object.MatchID === "number")
                    message.MatchID = object.MatchID;
                else if (typeof object.MatchID === "object")
                    message.MatchID = new $util.LongBits(object.MatchID.low >>> 0, object.MatchID.high >>> 0).toNumber(true);
            if (object.StageID != null)
                if ($util.Long)
                    (message.StageID = $util.Long.fromValue(object.StageID)).unsigned = true;
                else if (typeof object.StageID === "string")
                    message.StageID = parseInt(object.StageID, 10);
                else if (typeof object.StageID === "number")
                    message.StageID = object.StageID;
                else if (typeof object.StageID === "object")
                    message.StageID = new $util.LongBits(object.StageID.low >>> 0, object.StageID.high >>> 0).toNumber(true);
            if (object.UserID != null)
                if ($util.Long)
                    (message.UserID = $util.Long.fromValue(object.UserID)).unsigned = true;
                else if (typeof object.UserID === "string")
                    message.UserID = parseInt(object.UserID, 10);
                else if (typeof object.UserID === "number")
                    message.UserID = object.UserID;
                else if (typeof object.UserID === "object")
                    message.UserID = new $util.LongBits(object.UserID.low >>> 0, object.UserID.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a CMD_MatchWithdraw message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.CMD_MatchWithdraw
         * @static
         * @param {Auth.CMD_MatchWithdraw} message CMD_MatchWithdraw
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_MatchWithdraw.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.MatchID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.MatchID = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.StageID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.StageID = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.UserID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.UserID = options.longs === String ? "0" : 0;
            }
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                if (typeof message.MatchID === "number")
                    object.MatchID = options.longs === String ? String(message.MatchID) : message.MatchID;
                else
                    object.MatchID = options.longs === String ? $util.Long.prototype.toString.call(message.MatchID) : options.longs === Number ? new $util.LongBits(message.MatchID.low >>> 0, message.MatchID.high >>> 0).toNumber(true) : message.MatchID;
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                if (typeof message.StageID === "number")
                    object.StageID = options.longs === String ? String(message.StageID) : message.StageID;
                else
                    object.StageID = options.longs === String ? $util.Long.prototype.toString.call(message.StageID) : options.longs === Number ? new $util.LongBits(message.StageID.low >>> 0, message.StageID.high >>> 0).toNumber(true) : message.StageID;
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (typeof message.UserID === "number")
                    object.UserID = options.longs === String ? String(message.UserID) : message.UserID;
                else
                    object.UserID = options.longs === String ? $util.Long.prototype.toString.call(message.UserID) : options.longs === Number ? new $util.LongBits(message.UserID.low >>> 0, message.UserID.high >>> 0).toNumber(true) : message.UserID;
            return object;
        };

        /**
         * Converts this CMD_MatchWithdraw to JSON.
         * @function toJSON
         * @memberof Auth.CMD_MatchWithdraw
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_MatchWithdraw.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CMD_MatchWithdraw;
    })();

    Auth.RSP_MatchWithdraw = (function() {

        /**
         * Properties of a RSP_MatchWithdraw.
         * @memberof Auth
         * @interface IRSP_MatchWithdraw
         * @property {number|Long|null} [MatchID] RSP_MatchWithdraw MatchID
         * @property {number|Long|null} [StageID] RSP_MatchWithdraw StageID
         * @property {number|Long|null} [UserID] RSP_MatchWithdraw UserID
         * @property {number|null} [ErrorCode] RSP_MatchWithdraw ErrorCode
         * @property {string|null} [ErrorInfo] RSP_MatchWithdraw ErrorInfo
         */

        /**
         * Constructs a new RSP_MatchWithdraw.
         * @memberof Auth
         * @classdesc Represents a RSP_MatchWithdraw.
         * @implements IRSP_MatchWithdraw
         * @constructor
         * @param {Auth.IRSP_MatchWithdraw=} [properties] Properties to set
         */
        function RSP_MatchWithdraw(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RSP_MatchWithdraw MatchID.
         * @member {number|Long} MatchID
         * @memberof Auth.RSP_MatchWithdraw
         * @instance
         */
        RSP_MatchWithdraw.prototype.MatchID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RSP_MatchWithdraw StageID.
         * @member {number|Long} StageID
         * @memberof Auth.RSP_MatchWithdraw
         * @instance
         */
        RSP_MatchWithdraw.prototype.StageID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RSP_MatchWithdraw UserID.
         * @member {number|Long} UserID
         * @memberof Auth.RSP_MatchWithdraw
         * @instance
         */
        RSP_MatchWithdraw.prototype.UserID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RSP_MatchWithdraw ErrorCode.
         * @member {number} ErrorCode
         * @memberof Auth.RSP_MatchWithdraw
         * @instance
         */
        RSP_MatchWithdraw.prototype.ErrorCode = 0;

        /**
         * RSP_MatchWithdraw ErrorInfo.
         * @member {string} ErrorInfo
         * @memberof Auth.RSP_MatchWithdraw
         * @instance
         */
        RSP_MatchWithdraw.prototype.ErrorInfo = "";

        /**
         * Creates a new RSP_MatchWithdraw instance using the specified properties.
         * @function create
         * @memberof Auth.RSP_MatchWithdraw
         * @static
         * @param {Auth.IRSP_MatchWithdraw=} [properties] Properties to set
         * @returns {Auth.RSP_MatchWithdraw} RSP_MatchWithdraw instance
         */
        RSP_MatchWithdraw.create = function create(properties) {
            return new RSP_MatchWithdraw(properties);
        };

        /**
         * Encodes the specified RSP_MatchWithdraw message. Does not implicitly {@link Auth.RSP_MatchWithdraw.verify|verify} messages.
         * @function encode
         * @memberof Auth.RSP_MatchWithdraw
         * @static
         * @param {Auth.IRSP_MatchWithdraw} message RSP_MatchWithdraw message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_MatchWithdraw.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.MatchID);
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.StageID);
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.UserID);
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.ErrorCode);
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.ErrorInfo);
            return writer;
        };

        /**
         * Encodes the specified RSP_MatchWithdraw message, length delimited. Does not implicitly {@link Auth.RSP_MatchWithdraw.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.RSP_MatchWithdraw
         * @static
         * @param {Auth.IRSP_MatchWithdraw} message RSP_MatchWithdraw message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_MatchWithdraw.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RSP_MatchWithdraw message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.RSP_MatchWithdraw
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.RSP_MatchWithdraw} RSP_MatchWithdraw
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_MatchWithdraw.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.RSP_MatchWithdraw();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.MatchID = reader.uint64();
                    break;
                case 2:
                    message.StageID = reader.uint64();
                    break;
                case 3:
                    message.UserID = reader.uint64();
                    break;
                case 4:
                    message.ErrorCode = reader.uint32();
                    break;
                case 5:
                    message.ErrorInfo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RSP_MatchWithdraw message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.RSP_MatchWithdraw
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.RSP_MatchWithdraw} RSP_MatchWithdraw
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_MatchWithdraw.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RSP_MatchWithdraw message.
         * @function verify
         * @memberof Auth.RSP_MatchWithdraw
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RSP_MatchWithdraw.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                if (!$util.isInteger(message.MatchID) && !(message.MatchID && $util.isInteger(message.MatchID.low) && $util.isInteger(message.MatchID.high)))
                    return "MatchID: integer|Long expected";
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                if (!$util.isInteger(message.StageID) && !(message.StageID && $util.isInteger(message.StageID.low) && $util.isInteger(message.StageID.high)))
                    return "StageID: integer|Long expected";
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (!$util.isInteger(message.UserID) && !(message.UserID && $util.isInteger(message.UserID.low) && $util.isInteger(message.UserID.high)))
                    return "UserID: integer|Long expected";
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                if (!$util.isInteger(message.ErrorCode))
                    return "ErrorCode: integer expected";
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                if (!$util.isString(message.ErrorInfo))
                    return "ErrorInfo: string expected";
            return null;
        };

        /**
         * Creates a RSP_MatchWithdraw message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.RSP_MatchWithdraw
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.RSP_MatchWithdraw} RSP_MatchWithdraw
         */
        RSP_MatchWithdraw.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.RSP_MatchWithdraw)
                return object;
            var message = new $root.Auth.RSP_MatchWithdraw();
            if (object.MatchID != null)
                if ($util.Long)
                    (message.MatchID = $util.Long.fromValue(object.MatchID)).unsigned = true;
                else if (typeof object.MatchID === "string")
                    message.MatchID = parseInt(object.MatchID, 10);
                else if (typeof object.MatchID === "number")
                    message.MatchID = object.MatchID;
                else if (typeof object.MatchID === "object")
                    message.MatchID = new $util.LongBits(object.MatchID.low >>> 0, object.MatchID.high >>> 0).toNumber(true);
            if (object.StageID != null)
                if ($util.Long)
                    (message.StageID = $util.Long.fromValue(object.StageID)).unsigned = true;
                else if (typeof object.StageID === "string")
                    message.StageID = parseInt(object.StageID, 10);
                else if (typeof object.StageID === "number")
                    message.StageID = object.StageID;
                else if (typeof object.StageID === "object")
                    message.StageID = new $util.LongBits(object.StageID.low >>> 0, object.StageID.high >>> 0).toNumber(true);
            if (object.UserID != null)
                if ($util.Long)
                    (message.UserID = $util.Long.fromValue(object.UserID)).unsigned = true;
                else if (typeof object.UserID === "string")
                    message.UserID = parseInt(object.UserID, 10);
                else if (typeof object.UserID === "number")
                    message.UserID = object.UserID;
                else if (typeof object.UserID === "object")
                    message.UserID = new $util.LongBits(object.UserID.low >>> 0, object.UserID.high >>> 0).toNumber(true);
            if (object.ErrorCode != null)
                message.ErrorCode = object.ErrorCode >>> 0;
            if (object.ErrorInfo != null)
                message.ErrorInfo = String(object.ErrorInfo);
            return message;
        };

        /**
         * Creates a plain object from a RSP_MatchWithdraw message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.RSP_MatchWithdraw
         * @static
         * @param {Auth.RSP_MatchWithdraw} message RSP_MatchWithdraw
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RSP_MatchWithdraw.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.MatchID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.MatchID = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.StageID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.StageID = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.UserID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.UserID = options.longs === String ? "0" : 0;
                object.ErrorCode = 0;
                object.ErrorInfo = "";
            }
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                if (typeof message.MatchID === "number")
                    object.MatchID = options.longs === String ? String(message.MatchID) : message.MatchID;
                else
                    object.MatchID = options.longs === String ? $util.Long.prototype.toString.call(message.MatchID) : options.longs === Number ? new $util.LongBits(message.MatchID.low >>> 0, message.MatchID.high >>> 0).toNumber(true) : message.MatchID;
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                if (typeof message.StageID === "number")
                    object.StageID = options.longs === String ? String(message.StageID) : message.StageID;
                else
                    object.StageID = options.longs === String ? $util.Long.prototype.toString.call(message.StageID) : options.longs === Number ? new $util.LongBits(message.StageID.low >>> 0, message.StageID.high >>> 0).toNumber(true) : message.StageID;
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (typeof message.UserID === "number")
                    object.UserID = options.longs === String ? String(message.UserID) : message.UserID;
                else
                    object.UserID = options.longs === String ? $util.Long.prototype.toString.call(message.UserID) : options.longs === Number ? new $util.LongBits(message.UserID.low >>> 0, message.UserID.high >>> 0).toNumber(true) : message.UserID;
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                object.ErrorCode = message.ErrorCode;
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                object.ErrorInfo = message.ErrorInfo;
            return object;
        };

        /**
         * Converts this RSP_MatchWithdraw to JSON.
         * @function toJSON
         * @memberof Auth.RSP_MatchWithdraw
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RSP_MatchWithdraw.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RSP_MatchWithdraw;
    })();

    Auth.Notify_MatchEvent = (function() {

        /**
         * Properties of a Notify_MatchEvent.
         * @memberof Auth
         * @interface INotify_MatchEvent
         * @property {number|Long|null} [MatchID] Notify_MatchEvent MatchID
         * @property {number|Long|null} [StageID] Notify_MatchEvent StageID
         * @property {number|null} [CurLoopNo] Notify_MatchEvent CurLoopNo
         * @property {number|null} [EventTime] Notify_MatchEvent EventTime
         * @property {Array.<Auth.Notify_MatchEvent.IPlayerInfo>|null} [Users] Notify_MatchEvent Users
         * @property {string|null} [EventArgs] Notify_MatchEvent EventArgs
         * @property {Auth.Notify_MatchEvent.IMatchConfig|null} [config] Notify_MatchEvent config
         */

        /**
         * Constructs a new Notify_MatchEvent.
         * @memberof Auth
         * @classdesc Represents a Notify_MatchEvent.
         * @implements INotify_MatchEvent
         * @constructor
         * @param {Auth.INotify_MatchEvent=} [properties] Properties to set
         */
        function Notify_MatchEvent(properties) {
            this.Users = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Notify_MatchEvent MatchID.
         * @member {number|Long} MatchID
         * @memberof Auth.Notify_MatchEvent
         * @instance
         */
        Notify_MatchEvent.prototype.MatchID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Notify_MatchEvent StageID.
         * @member {number|Long} StageID
         * @memberof Auth.Notify_MatchEvent
         * @instance
         */
        Notify_MatchEvent.prototype.StageID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Notify_MatchEvent CurLoopNo.
         * @member {number} CurLoopNo
         * @memberof Auth.Notify_MatchEvent
         * @instance
         */
        Notify_MatchEvent.prototype.CurLoopNo = 0;

        /**
         * Notify_MatchEvent EventTime.
         * @member {number} EventTime
         * @memberof Auth.Notify_MatchEvent
         * @instance
         */
        Notify_MatchEvent.prototype.EventTime = 0;

        /**
         * Notify_MatchEvent Users.
         * @member {Array.<Auth.Notify_MatchEvent.IPlayerInfo>} Users
         * @memberof Auth.Notify_MatchEvent
         * @instance
         */
        Notify_MatchEvent.prototype.Users = $util.emptyArray;

        /**
         * Notify_MatchEvent EventArgs.
         * @member {string} EventArgs
         * @memberof Auth.Notify_MatchEvent
         * @instance
         */
        Notify_MatchEvent.prototype.EventArgs = "";

        /**
         * Notify_MatchEvent config.
         * @member {Auth.Notify_MatchEvent.IMatchConfig|null|undefined} config
         * @memberof Auth.Notify_MatchEvent
         * @instance
         */
        Notify_MatchEvent.prototype.config = null;

        /**
         * Creates a new Notify_MatchEvent instance using the specified properties.
         * @function create
         * @memberof Auth.Notify_MatchEvent
         * @static
         * @param {Auth.INotify_MatchEvent=} [properties] Properties to set
         * @returns {Auth.Notify_MatchEvent} Notify_MatchEvent instance
         */
        Notify_MatchEvent.create = function create(properties) {
            return new Notify_MatchEvent(properties);
        };

        /**
         * Encodes the specified Notify_MatchEvent message. Does not implicitly {@link Auth.Notify_MatchEvent.verify|verify} messages.
         * @function encode
         * @memberof Auth.Notify_MatchEvent
         * @static
         * @param {Auth.INotify_MatchEvent} message Notify_MatchEvent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Notify_MatchEvent.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.MatchID);
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.StageID);
            if (message.CurLoopNo != null && message.hasOwnProperty("CurLoopNo"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.CurLoopNo);
            if (message.EventTime != null && message.hasOwnProperty("EventTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.EventTime);
            if (message.Users != null && message.Users.length)
                for (var i = 0; i < message.Users.length; ++i)
                    $root.Auth.Notify_MatchEvent.PlayerInfo.encode(message.Users[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.EventArgs != null && message.hasOwnProperty("EventArgs"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.EventArgs);
            if (message.config != null && message.hasOwnProperty("config"))
                $root.Auth.Notify_MatchEvent.MatchConfig.encode(message.config, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Notify_MatchEvent message, length delimited. Does not implicitly {@link Auth.Notify_MatchEvent.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.Notify_MatchEvent
         * @static
         * @param {Auth.INotify_MatchEvent} message Notify_MatchEvent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Notify_MatchEvent.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Notify_MatchEvent message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.Notify_MatchEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.Notify_MatchEvent} Notify_MatchEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Notify_MatchEvent.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.Notify_MatchEvent();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.MatchID = reader.uint64();
                    break;
                case 2:
                    message.StageID = reader.uint64();
                    break;
                case 3:
                    message.CurLoopNo = reader.uint32();
                    break;
                case 4:
                    message.EventTime = reader.uint32();
                    break;
                case 5:
                    if (!(message.Users && message.Users.length))
                        message.Users = [];
                    message.Users.push($root.Auth.Notify_MatchEvent.PlayerInfo.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.EventArgs = reader.string();
                    break;
                case 7:
                    message.config = $root.Auth.Notify_MatchEvent.MatchConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Notify_MatchEvent message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.Notify_MatchEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.Notify_MatchEvent} Notify_MatchEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Notify_MatchEvent.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Notify_MatchEvent message.
         * @function verify
         * @memberof Auth.Notify_MatchEvent
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Notify_MatchEvent.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                if (!$util.isInteger(message.MatchID) && !(message.MatchID && $util.isInteger(message.MatchID.low) && $util.isInteger(message.MatchID.high)))
                    return "MatchID: integer|Long expected";
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                if (!$util.isInteger(message.StageID) && !(message.StageID && $util.isInteger(message.StageID.low) && $util.isInteger(message.StageID.high)))
                    return "StageID: integer|Long expected";
            if (message.CurLoopNo != null && message.hasOwnProperty("CurLoopNo"))
                if (!$util.isInteger(message.CurLoopNo))
                    return "CurLoopNo: integer expected";
            if (message.EventTime != null && message.hasOwnProperty("EventTime"))
                if (!$util.isInteger(message.EventTime))
                    return "EventTime: integer expected";
            if (message.Users != null && message.hasOwnProperty("Users")) {
                if (!Array.isArray(message.Users))
                    return "Users: array expected";
                for (var i = 0; i < message.Users.length; ++i) {
                    var error = $root.Auth.Notify_MatchEvent.PlayerInfo.verify(message.Users[i]);
                    if (error)
                        return "Users." + error;
                }
            }
            if (message.EventArgs != null && message.hasOwnProperty("EventArgs"))
                if (!$util.isString(message.EventArgs))
                    return "EventArgs: string expected";
            if (message.config != null && message.hasOwnProperty("config")) {
                var error = $root.Auth.Notify_MatchEvent.MatchConfig.verify(message.config);
                if (error)
                    return "config." + error;
            }
            return null;
        };

        /**
         * Creates a Notify_MatchEvent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.Notify_MatchEvent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.Notify_MatchEvent} Notify_MatchEvent
         */
        Notify_MatchEvent.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.Notify_MatchEvent)
                return object;
            var message = new $root.Auth.Notify_MatchEvent();
            if (object.MatchID != null)
                if ($util.Long)
                    (message.MatchID = $util.Long.fromValue(object.MatchID)).unsigned = true;
                else if (typeof object.MatchID === "string")
                    message.MatchID = parseInt(object.MatchID, 10);
                else if (typeof object.MatchID === "number")
                    message.MatchID = object.MatchID;
                else if (typeof object.MatchID === "object")
                    message.MatchID = new $util.LongBits(object.MatchID.low >>> 0, object.MatchID.high >>> 0).toNumber(true);
            if (object.StageID != null)
                if ($util.Long)
                    (message.StageID = $util.Long.fromValue(object.StageID)).unsigned = true;
                else if (typeof object.StageID === "string")
                    message.StageID = parseInt(object.StageID, 10);
                else if (typeof object.StageID === "number")
                    message.StageID = object.StageID;
                else if (typeof object.StageID === "object")
                    message.StageID = new $util.LongBits(object.StageID.low >>> 0, object.StageID.high >>> 0).toNumber(true);
            if (object.CurLoopNo != null)
                message.CurLoopNo = object.CurLoopNo >>> 0;
            if (object.EventTime != null)
                message.EventTime = object.EventTime >>> 0;
            if (object.Users) {
                if (!Array.isArray(object.Users))
                    throw TypeError(".Auth.Notify_MatchEvent.Users: array expected");
                message.Users = [];
                for (var i = 0; i < object.Users.length; ++i) {
                    if (typeof object.Users[i] !== "object")
                        throw TypeError(".Auth.Notify_MatchEvent.Users: object expected");
                    message.Users[i] = $root.Auth.Notify_MatchEvent.PlayerInfo.fromObject(object.Users[i]);
                }
            }
            if (object.EventArgs != null)
                message.EventArgs = String(object.EventArgs);
            if (object.config != null) {
                if (typeof object.config !== "object")
                    throw TypeError(".Auth.Notify_MatchEvent.config: object expected");
                message.config = $root.Auth.Notify_MatchEvent.MatchConfig.fromObject(object.config);
            }
            return message;
        };

        /**
         * Creates a plain object from a Notify_MatchEvent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.Notify_MatchEvent
         * @static
         * @param {Auth.Notify_MatchEvent} message Notify_MatchEvent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Notify_MatchEvent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.Users = [];
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.MatchID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.MatchID = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.StageID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.StageID = options.longs === String ? "0" : 0;
                object.CurLoopNo = 0;
                object.EventTime = 0;
                object.EventArgs = "";
                object.config = null;
            }
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                if (typeof message.MatchID === "number")
                    object.MatchID = options.longs === String ? String(message.MatchID) : message.MatchID;
                else
                    object.MatchID = options.longs === String ? $util.Long.prototype.toString.call(message.MatchID) : options.longs === Number ? new $util.LongBits(message.MatchID.low >>> 0, message.MatchID.high >>> 0).toNumber(true) : message.MatchID;
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                if (typeof message.StageID === "number")
                    object.StageID = options.longs === String ? String(message.StageID) : message.StageID;
                else
                    object.StageID = options.longs === String ? $util.Long.prototype.toString.call(message.StageID) : options.longs === Number ? new $util.LongBits(message.StageID.low >>> 0, message.StageID.high >>> 0).toNumber(true) : message.StageID;
            if (message.CurLoopNo != null && message.hasOwnProperty("CurLoopNo"))
                object.CurLoopNo = message.CurLoopNo;
            if (message.EventTime != null && message.hasOwnProperty("EventTime"))
                object.EventTime = message.EventTime;
            if (message.Users && message.Users.length) {
                object.Users = [];
                for (var j = 0; j < message.Users.length; ++j)
                    object.Users[j] = $root.Auth.Notify_MatchEvent.PlayerInfo.toObject(message.Users[j], options);
            }
            if (message.EventArgs != null && message.hasOwnProperty("EventArgs"))
                object.EventArgs = message.EventArgs;
            if (message.config != null && message.hasOwnProperty("config"))
                object.config = $root.Auth.Notify_MatchEvent.MatchConfig.toObject(message.config, options);
            return object;
        };

        /**
         * Converts this Notify_MatchEvent to JSON.
         * @function toJSON
         * @memberof Auth.Notify_MatchEvent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Notify_MatchEvent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        Notify_MatchEvent.MatchConfig = (function() {

            /**
             * Properties of a MatchConfig.
             * @memberof Auth.Notify_MatchEvent
             * @interface IMatchConfig
             * @property {string|null} [PlayRule] MatchConfig PlayRule
             * @property {number|null} [MaxRoundPerLoop] MatchConfig MaxRoundPerLoop
             * @property {number|null} [StartTime] MatchConfig StartTime
             * @property {number|null} [MaxUserCnt] MatchConfig MaxUserCnt
             * @property {number|null} [InitQuitScore] MatchConfig InitQuitScore
             * @property {number|null} [InitBaseScore] MatchConfig InitBaseScore
             * @property {number|null} [StepQuitScore] MatchConfig StepQuitScore
             * @property {number|null} [StepBaseScore] MatchConfig StepBaseScore
             * @property {number|null} [LoopScoreReserveRatio] MatchConfig LoopScoreReserveRatio
             * @property {string|null} [GameName] MatchConfig GameName
             * @property {string|null} [GameID] MatchConfig GameID
             * @property {string|null} [Title] MatchConfig Title
             */

            /**
             * Constructs a new MatchConfig.
             * @memberof Auth.Notify_MatchEvent
             * @classdesc Represents a MatchConfig.
             * @implements IMatchConfig
             * @constructor
             * @param {Auth.Notify_MatchEvent.IMatchConfig=} [properties] Properties to set
             */
            function MatchConfig(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MatchConfig PlayRule.
             * @member {string} PlayRule
             * @memberof Auth.Notify_MatchEvent.MatchConfig
             * @instance
             */
            MatchConfig.prototype.PlayRule = "";

            /**
             * MatchConfig MaxRoundPerLoop.
             * @member {number} MaxRoundPerLoop
             * @memberof Auth.Notify_MatchEvent.MatchConfig
             * @instance
             */
            MatchConfig.prototype.MaxRoundPerLoop = 0;

            /**
             * MatchConfig StartTime.
             * @member {number} StartTime
             * @memberof Auth.Notify_MatchEvent.MatchConfig
             * @instance
             */
            MatchConfig.prototype.StartTime = 0;

            /**
             * MatchConfig MaxUserCnt.
             * @member {number} MaxUserCnt
             * @memberof Auth.Notify_MatchEvent.MatchConfig
             * @instance
             */
            MatchConfig.prototype.MaxUserCnt = 0;

            /**
             * MatchConfig InitQuitScore.
             * @member {number} InitQuitScore
             * @memberof Auth.Notify_MatchEvent.MatchConfig
             * @instance
             */
            MatchConfig.prototype.InitQuitScore = 0;

            /**
             * MatchConfig InitBaseScore.
             * @member {number} InitBaseScore
             * @memberof Auth.Notify_MatchEvent.MatchConfig
             * @instance
             */
            MatchConfig.prototype.InitBaseScore = 0;

            /**
             * MatchConfig StepQuitScore.
             * @member {number} StepQuitScore
             * @memberof Auth.Notify_MatchEvent.MatchConfig
             * @instance
             */
            MatchConfig.prototype.StepQuitScore = 0;

            /**
             * MatchConfig StepBaseScore.
             * @member {number} StepBaseScore
             * @memberof Auth.Notify_MatchEvent.MatchConfig
             * @instance
             */
            MatchConfig.prototype.StepBaseScore = 0;

            /**
             * MatchConfig LoopScoreReserveRatio.
             * @member {number} LoopScoreReserveRatio
             * @memberof Auth.Notify_MatchEvent.MatchConfig
             * @instance
             */
            MatchConfig.prototype.LoopScoreReserveRatio = 0;

            /**
             * MatchConfig GameName.
             * @member {string} GameName
             * @memberof Auth.Notify_MatchEvent.MatchConfig
             * @instance
             */
            MatchConfig.prototype.GameName = "";

            /**
             * MatchConfig GameID.
             * @member {string} GameID
             * @memberof Auth.Notify_MatchEvent.MatchConfig
             * @instance
             */
            MatchConfig.prototype.GameID = "";

            /**
             * MatchConfig Title.
             * @member {string} Title
             * @memberof Auth.Notify_MatchEvent.MatchConfig
             * @instance
             */
            MatchConfig.prototype.Title = "";

            /**
             * Creates a new MatchConfig instance using the specified properties.
             * @function create
             * @memberof Auth.Notify_MatchEvent.MatchConfig
             * @static
             * @param {Auth.Notify_MatchEvent.IMatchConfig=} [properties] Properties to set
             * @returns {Auth.Notify_MatchEvent.MatchConfig} MatchConfig instance
             */
            MatchConfig.create = function create(properties) {
                return new MatchConfig(properties);
            };

            /**
             * Encodes the specified MatchConfig message. Does not implicitly {@link Auth.Notify_MatchEvent.MatchConfig.verify|verify} messages.
             * @function encode
             * @memberof Auth.Notify_MatchEvent.MatchConfig
             * @static
             * @param {Auth.Notify_MatchEvent.IMatchConfig} message MatchConfig message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MatchConfig.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.PlayRule != null && message.hasOwnProperty("PlayRule"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.PlayRule);
                if (message.MaxRoundPerLoop != null && message.hasOwnProperty("MaxRoundPerLoop"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.MaxRoundPerLoop);
                if (message.StartTime != null && message.hasOwnProperty("StartTime"))
                    writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.StartTime);
                if (message.MaxUserCnt != null && message.hasOwnProperty("MaxUserCnt"))
                    writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.MaxUserCnt);
                if (message.InitQuitScore != null && message.hasOwnProperty("InitQuitScore"))
                    writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.InitQuitScore);
                if (message.InitBaseScore != null && message.hasOwnProperty("InitBaseScore"))
                    writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.InitBaseScore);
                if (message.StepQuitScore != null && message.hasOwnProperty("StepQuitScore"))
                    writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.StepQuitScore);
                if (message.StepBaseScore != null && message.hasOwnProperty("StepBaseScore"))
                    writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.StepBaseScore);
                if (message.LoopScoreReserveRatio != null && message.hasOwnProperty("LoopScoreReserveRatio"))
                    writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.LoopScoreReserveRatio);
                if (message.GameName != null && message.hasOwnProperty("GameName"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.GameName);
                if (message.GameID != null && message.hasOwnProperty("GameID"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.GameID);
                if (message.Title != null && message.hasOwnProperty("Title"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.Title);
                return writer;
            };

            /**
             * Encodes the specified MatchConfig message, length delimited. Does not implicitly {@link Auth.Notify_MatchEvent.MatchConfig.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Auth.Notify_MatchEvent.MatchConfig
             * @static
             * @param {Auth.Notify_MatchEvent.IMatchConfig} message MatchConfig message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MatchConfig.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MatchConfig message from the specified reader or buffer.
             * @function decode
             * @memberof Auth.Notify_MatchEvent.MatchConfig
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Auth.Notify_MatchEvent.MatchConfig} MatchConfig
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MatchConfig.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.Notify_MatchEvent.MatchConfig();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.PlayRule = reader.string();
                        break;
                    case 3:
                        message.MaxRoundPerLoop = reader.uint32();
                        break;
                    case 4:
                        message.StartTime = reader.uint32();
                        break;
                    case 6:
                        message.MaxUserCnt = reader.uint32();
                        break;
                    case 7:
                        message.InitQuitScore = reader.uint32();
                        break;
                    case 8:
                        message.InitBaseScore = reader.uint32();
                        break;
                    case 9:
                        message.StepQuitScore = reader.uint32();
                        break;
                    case 10:
                        message.StepBaseScore = reader.uint32();
                        break;
                    case 11:
                        message.LoopScoreReserveRatio = reader.uint32();
                        break;
                    case 12:
                        message.GameName = reader.string();
                        break;
                    case 13:
                        message.GameID = reader.string();
                        break;
                    case 14:
                        message.Title = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MatchConfig message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Auth.Notify_MatchEvent.MatchConfig
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Auth.Notify_MatchEvent.MatchConfig} MatchConfig
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MatchConfig.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MatchConfig message.
             * @function verify
             * @memberof Auth.Notify_MatchEvent.MatchConfig
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MatchConfig.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.PlayRule != null && message.hasOwnProperty("PlayRule"))
                    if (!$util.isString(message.PlayRule))
                        return "PlayRule: string expected";
                if (message.MaxRoundPerLoop != null && message.hasOwnProperty("MaxRoundPerLoop"))
                    if (!$util.isInteger(message.MaxRoundPerLoop))
                        return "MaxRoundPerLoop: integer expected";
                if (message.StartTime != null && message.hasOwnProperty("StartTime"))
                    if (!$util.isInteger(message.StartTime))
                        return "StartTime: integer expected";
                if (message.MaxUserCnt != null && message.hasOwnProperty("MaxUserCnt"))
                    if (!$util.isInteger(message.MaxUserCnt))
                        return "MaxUserCnt: integer expected";
                if (message.InitQuitScore != null && message.hasOwnProperty("InitQuitScore"))
                    if (!$util.isInteger(message.InitQuitScore))
                        return "InitQuitScore: integer expected";
                if (message.InitBaseScore != null && message.hasOwnProperty("InitBaseScore"))
                    if (!$util.isInteger(message.InitBaseScore))
                        return "InitBaseScore: integer expected";
                if (message.StepQuitScore != null && message.hasOwnProperty("StepQuitScore"))
                    if (!$util.isInteger(message.StepQuitScore))
                        return "StepQuitScore: integer expected";
                if (message.StepBaseScore != null && message.hasOwnProperty("StepBaseScore"))
                    if (!$util.isInteger(message.StepBaseScore))
                        return "StepBaseScore: integer expected";
                if (message.LoopScoreReserveRatio != null && message.hasOwnProperty("LoopScoreReserveRatio"))
                    if (!$util.isInteger(message.LoopScoreReserveRatio))
                        return "LoopScoreReserveRatio: integer expected";
                if (message.GameName != null && message.hasOwnProperty("GameName"))
                    if (!$util.isString(message.GameName))
                        return "GameName: string expected";
                if (message.GameID != null && message.hasOwnProperty("GameID"))
                    if (!$util.isString(message.GameID))
                        return "GameID: string expected";
                if (message.Title != null && message.hasOwnProperty("Title"))
                    if (!$util.isString(message.Title))
                        return "Title: string expected";
                return null;
            };

            /**
             * Creates a MatchConfig message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Auth.Notify_MatchEvent.MatchConfig
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Auth.Notify_MatchEvent.MatchConfig} MatchConfig
             */
            MatchConfig.fromObject = function fromObject(object) {
                if (object instanceof $root.Auth.Notify_MatchEvent.MatchConfig)
                    return object;
                var message = new $root.Auth.Notify_MatchEvent.MatchConfig();
                if (object.PlayRule != null)
                    message.PlayRule = String(object.PlayRule);
                if (object.MaxRoundPerLoop != null)
                    message.MaxRoundPerLoop = object.MaxRoundPerLoop >>> 0;
                if (object.StartTime != null)
                    message.StartTime = object.StartTime >>> 0;
                if (object.MaxUserCnt != null)
                    message.MaxUserCnt = object.MaxUserCnt >>> 0;
                if (object.InitQuitScore != null)
                    message.InitQuitScore = object.InitQuitScore >>> 0;
                if (object.InitBaseScore != null)
                    message.InitBaseScore = object.InitBaseScore >>> 0;
                if (object.StepQuitScore != null)
                    message.StepQuitScore = object.StepQuitScore >>> 0;
                if (object.StepBaseScore != null)
                    message.StepBaseScore = object.StepBaseScore >>> 0;
                if (object.LoopScoreReserveRatio != null)
                    message.LoopScoreReserveRatio = object.LoopScoreReserveRatio >>> 0;
                if (object.GameName != null)
                    message.GameName = String(object.GameName);
                if (object.GameID != null)
                    message.GameID = String(object.GameID);
                if (object.Title != null)
                    message.Title = String(object.Title);
                return message;
            };

            /**
             * Creates a plain object from a MatchConfig message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Auth.Notify_MatchEvent.MatchConfig
             * @static
             * @param {Auth.Notify_MatchEvent.MatchConfig} message MatchConfig
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MatchConfig.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.PlayRule = "";
                    object.MaxRoundPerLoop = 0;
                    object.StartTime = 0;
                    object.MaxUserCnt = 0;
                    object.InitQuitScore = 0;
                    object.InitBaseScore = 0;
                    object.StepQuitScore = 0;
                    object.StepBaseScore = 0;
                    object.LoopScoreReserveRatio = 0;
                    object.GameName = "";
                    object.GameID = "";
                    object.Title = "";
                }
                if (message.PlayRule != null && message.hasOwnProperty("PlayRule"))
                    object.PlayRule = message.PlayRule;
                if (message.MaxRoundPerLoop != null && message.hasOwnProperty("MaxRoundPerLoop"))
                    object.MaxRoundPerLoop = message.MaxRoundPerLoop;
                if (message.StartTime != null && message.hasOwnProperty("StartTime"))
                    object.StartTime = message.StartTime;
                if (message.MaxUserCnt != null && message.hasOwnProperty("MaxUserCnt"))
                    object.MaxUserCnt = message.MaxUserCnt;
                if (message.InitQuitScore != null && message.hasOwnProperty("InitQuitScore"))
                    object.InitQuitScore = message.InitQuitScore;
                if (message.InitBaseScore != null && message.hasOwnProperty("InitBaseScore"))
                    object.InitBaseScore = message.InitBaseScore;
                if (message.StepQuitScore != null && message.hasOwnProperty("StepQuitScore"))
                    object.StepQuitScore = message.StepQuitScore;
                if (message.StepBaseScore != null && message.hasOwnProperty("StepBaseScore"))
                    object.StepBaseScore = message.StepBaseScore;
                if (message.LoopScoreReserveRatio != null && message.hasOwnProperty("LoopScoreReserveRatio"))
                    object.LoopScoreReserveRatio = message.LoopScoreReserveRatio;
                if (message.GameName != null && message.hasOwnProperty("GameName"))
                    object.GameName = message.GameName;
                if (message.GameID != null && message.hasOwnProperty("GameID"))
                    object.GameID = message.GameID;
                if (message.Title != null && message.hasOwnProperty("Title"))
                    object.Title = message.Title;
                return object;
            };

            /**
             * Converts this MatchConfig to JSON.
             * @function toJSON
             * @memberof Auth.Notify_MatchEvent.MatchConfig
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MatchConfig.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return MatchConfig;
        })();

        Notify_MatchEvent.PlayerInfo = (function() {

            /**
             * Properties of a PlayerInfo.
             * @memberof Auth.Notify_MatchEvent
             * @interface IPlayerInfo
             * @property {number|Long|null} [UserID] PlayerInfo UserID
             * @property {number|null} [Score] PlayerInfo Score
             * @property {number|null} [Rank] PlayerInfo Rank
             */

            /**
             * Constructs a new PlayerInfo.
             * @memberof Auth.Notify_MatchEvent
             * @classdesc Represents a PlayerInfo.
             * @implements IPlayerInfo
             * @constructor
             * @param {Auth.Notify_MatchEvent.IPlayerInfo=} [properties] Properties to set
             */
            function PlayerInfo(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PlayerInfo UserID.
             * @member {number|Long} UserID
             * @memberof Auth.Notify_MatchEvent.PlayerInfo
             * @instance
             */
            PlayerInfo.prototype.UserID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * PlayerInfo Score.
             * @member {number} Score
             * @memberof Auth.Notify_MatchEvent.PlayerInfo
             * @instance
             */
            PlayerInfo.prototype.Score = 0;

            /**
             * PlayerInfo Rank.
             * @member {number} Rank
             * @memberof Auth.Notify_MatchEvent.PlayerInfo
             * @instance
             */
            PlayerInfo.prototype.Rank = 0;

            /**
             * Creates a new PlayerInfo instance using the specified properties.
             * @function create
             * @memberof Auth.Notify_MatchEvent.PlayerInfo
             * @static
             * @param {Auth.Notify_MatchEvent.IPlayerInfo=} [properties] Properties to set
             * @returns {Auth.Notify_MatchEvent.PlayerInfo} PlayerInfo instance
             */
            PlayerInfo.create = function create(properties) {
                return new PlayerInfo(properties);
            };

            /**
             * Encodes the specified PlayerInfo message. Does not implicitly {@link Auth.Notify_MatchEvent.PlayerInfo.verify|verify} messages.
             * @function encode
             * @memberof Auth.Notify_MatchEvent.PlayerInfo
             * @static
             * @param {Auth.Notify_MatchEvent.IPlayerInfo} message PlayerInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PlayerInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.UserID != null && message.hasOwnProperty("UserID"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.UserID);
                if (message.Score != null && message.hasOwnProperty("Score"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.Score);
                if (message.Rank != null && message.hasOwnProperty("Rank"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.Rank);
                return writer;
            };

            /**
             * Encodes the specified PlayerInfo message, length delimited. Does not implicitly {@link Auth.Notify_MatchEvent.PlayerInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Auth.Notify_MatchEvent.PlayerInfo
             * @static
             * @param {Auth.Notify_MatchEvent.IPlayerInfo} message PlayerInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PlayerInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PlayerInfo message from the specified reader or buffer.
             * @function decode
             * @memberof Auth.Notify_MatchEvent.PlayerInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Auth.Notify_MatchEvent.PlayerInfo} PlayerInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PlayerInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.Notify_MatchEvent.PlayerInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.UserID = reader.uint64();
                        break;
                    case 2:
                        message.Score = reader.int32();
                        break;
                    case 3:
                        message.Rank = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PlayerInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Auth.Notify_MatchEvent.PlayerInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Auth.Notify_MatchEvent.PlayerInfo} PlayerInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PlayerInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PlayerInfo message.
             * @function verify
             * @memberof Auth.Notify_MatchEvent.PlayerInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PlayerInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.UserID != null && message.hasOwnProperty("UserID"))
                    if (!$util.isInteger(message.UserID) && !(message.UserID && $util.isInteger(message.UserID.low) && $util.isInteger(message.UserID.high)))
                        return "UserID: integer|Long expected";
                if (message.Score != null && message.hasOwnProperty("Score"))
                    if (!$util.isInteger(message.Score))
                        return "Score: integer expected";
                if (message.Rank != null && message.hasOwnProperty("Rank"))
                    if (!$util.isInteger(message.Rank))
                        return "Rank: integer expected";
                return null;
            };

            /**
             * Creates a PlayerInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Auth.Notify_MatchEvent.PlayerInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Auth.Notify_MatchEvent.PlayerInfo} PlayerInfo
             */
            PlayerInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.Auth.Notify_MatchEvent.PlayerInfo)
                    return object;
                var message = new $root.Auth.Notify_MatchEvent.PlayerInfo();
                if (object.UserID != null)
                    if ($util.Long)
                        (message.UserID = $util.Long.fromValue(object.UserID)).unsigned = true;
                    else if (typeof object.UserID === "string")
                        message.UserID = parseInt(object.UserID, 10);
                    else if (typeof object.UserID === "number")
                        message.UserID = object.UserID;
                    else if (typeof object.UserID === "object")
                        message.UserID = new $util.LongBits(object.UserID.low >>> 0, object.UserID.high >>> 0).toNumber(true);
                if (object.Score != null)
                    message.Score = object.Score | 0;
                if (object.Rank != null)
                    message.Rank = object.Rank | 0;
                return message;
            };

            /**
             * Creates a plain object from a PlayerInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Auth.Notify_MatchEvent.PlayerInfo
             * @static
             * @param {Auth.Notify_MatchEvent.PlayerInfo} message PlayerInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PlayerInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.UserID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.UserID = options.longs === String ? "0" : 0;
                    object.Score = 0;
                    object.Rank = 0;
                }
                if (message.UserID != null && message.hasOwnProperty("UserID"))
                    if (typeof message.UserID === "number")
                        object.UserID = options.longs === String ? String(message.UserID) : message.UserID;
                    else
                        object.UserID = options.longs === String ? $util.Long.prototype.toString.call(message.UserID) : options.longs === Number ? new $util.LongBits(message.UserID.low >>> 0, message.UserID.high >>> 0).toNumber(true) : message.UserID;
                if (message.Score != null && message.hasOwnProperty("Score"))
                    object.Score = message.Score;
                if (message.Rank != null && message.hasOwnProperty("Rank"))
                    object.Rank = message.Rank;
                return object;
            };

            /**
             * Converts this PlayerInfo to JSON.
             * @function toJSON
             * @memberof Auth.Notify_MatchEvent.PlayerInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PlayerInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return PlayerInfo;
        })();

        return Notify_MatchEvent;
    })();

    Auth.Notify_MatchRoomInfo = (function() {

        /**
         * Properties of a Notify_MatchRoomInfo.
         * @memberof Auth
         * @interface INotify_MatchRoomInfo
         * @property {number|null} [RoomID] Notify_MatchRoomInfo RoomID
         * @property {Array.<Auth.Notify_MatchRoomInfo.IPlayerInfo>|null} [Players] Notify_MatchRoomInfo Players
         * @property {number|null} [UserID] Notify_MatchRoomInfo UserID
         * @property {string|null} [Password] Notify_MatchRoomInfo Password
         * @property {string|null} [PlayRule] Notify_MatchRoomInfo PlayRule
         * @property {string|null} [Host] Notify_MatchRoomInfo Host
         * @property {number|null} [Port] Notify_MatchRoomInfo Port
         * @property {number|null} [RoomHisID] Notify_MatchRoomInfo RoomHisID
         */

        /**
         * Constructs a new Notify_MatchRoomInfo.
         * @memberof Auth
         * @classdesc Represents a Notify_MatchRoomInfo.
         * @implements INotify_MatchRoomInfo
         * @constructor
         * @param {Auth.INotify_MatchRoomInfo=} [properties] Properties to set
         */
        function Notify_MatchRoomInfo(properties) {
            this.Players = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Notify_MatchRoomInfo RoomID.
         * @member {number} RoomID
         * @memberof Auth.Notify_MatchRoomInfo
         * @instance
         */
        Notify_MatchRoomInfo.prototype.RoomID = 0;

        /**
         * Notify_MatchRoomInfo Players.
         * @member {Array.<Auth.Notify_MatchRoomInfo.IPlayerInfo>} Players
         * @memberof Auth.Notify_MatchRoomInfo
         * @instance
         */
        Notify_MatchRoomInfo.prototype.Players = $util.emptyArray;

        /**
         * Notify_MatchRoomInfo UserID.
         * @member {number} UserID
         * @memberof Auth.Notify_MatchRoomInfo
         * @instance
         */
        Notify_MatchRoomInfo.prototype.UserID = 0;

        /**
         * Notify_MatchRoomInfo Password.
         * @member {string} Password
         * @memberof Auth.Notify_MatchRoomInfo
         * @instance
         */
        Notify_MatchRoomInfo.prototype.Password = "";

        /**
         * Notify_MatchRoomInfo PlayRule.
         * @member {string} PlayRule
         * @memberof Auth.Notify_MatchRoomInfo
         * @instance
         */
        Notify_MatchRoomInfo.prototype.PlayRule = "";

        /**
         * Notify_MatchRoomInfo Host.
         * @member {string} Host
         * @memberof Auth.Notify_MatchRoomInfo
         * @instance
         */
        Notify_MatchRoomInfo.prototype.Host = "";

        /**
         * Notify_MatchRoomInfo Port.
         * @member {number} Port
         * @memberof Auth.Notify_MatchRoomInfo
         * @instance
         */
        Notify_MatchRoomInfo.prototype.Port = 0;

        /**
         * Notify_MatchRoomInfo RoomHisID.
         * @member {number} RoomHisID
         * @memberof Auth.Notify_MatchRoomInfo
         * @instance
         */
        Notify_MatchRoomInfo.prototype.RoomHisID = 0;

        /**
         * Creates a new Notify_MatchRoomInfo instance using the specified properties.
         * @function create
         * @memberof Auth.Notify_MatchRoomInfo
         * @static
         * @param {Auth.INotify_MatchRoomInfo=} [properties] Properties to set
         * @returns {Auth.Notify_MatchRoomInfo} Notify_MatchRoomInfo instance
         */
        Notify_MatchRoomInfo.create = function create(properties) {
            return new Notify_MatchRoomInfo(properties);
        };

        /**
         * Encodes the specified Notify_MatchRoomInfo message. Does not implicitly {@link Auth.Notify_MatchRoomInfo.verify|verify} messages.
         * @function encode
         * @memberof Auth.Notify_MatchRoomInfo
         * @static
         * @param {Auth.INotify_MatchRoomInfo} message Notify_MatchRoomInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Notify_MatchRoomInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.RoomID != null && message.hasOwnProperty("RoomID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.RoomID);
            if (message.Players != null && message.Players.length)
                for (var i = 0; i < message.Players.length; ++i)
                    $root.Auth.Notify_MatchRoomInfo.PlayerInfo.encode(message.Players[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.UserID);
            if (message.Password != null && message.hasOwnProperty("Password"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.Password);
            if (message.PlayRule != null && message.hasOwnProperty("PlayRule"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.PlayRule);
            if (message.Host != null && message.hasOwnProperty("Host"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.Host);
            if (message.Port != null && message.hasOwnProperty("Port"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.Port);
            if (message.RoomHisID != null && message.hasOwnProperty("RoomHisID"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.RoomHisID);
            return writer;
        };

        /**
         * Encodes the specified Notify_MatchRoomInfo message, length delimited. Does not implicitly {@link Auth.Notify_MatchRoomInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.Notify_MatchRoomInfo
         * @static
         * @param {Auth.INotify_MatchRoomInfo} message Notify_MatchRoomInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Notify_MatchRoomInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Notify_MatchRoomInfo message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.Notify_MatchRoomInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.Notify_MatchRoomInfo} Notify_MatchRoomInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Notify_MatchRoomInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.Notify_MatchRoomInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.RoomID = reader.uint32();
                    break;
                case 2:
                    if (!(message.Players && message.Players.length))
                        message.Players = [];
                    message.Players.push($root.Auth.Notify_MatchRoomInfo.PlayerInfo.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.UserID = reader.uint32();
                    break;
                case 4:
                    message.Password = reader.string();
                    break;
                case 5:
                    message.PlayRule = reader.string();
                    break;
                case 6:
                    message.Host = reader.string();
                    break;
                case 7:
                    message.Port = reader.uint32();
                    break;
                case 8:
                    message.RoomHisID = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Notify_MatchRoomInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.Notify_MatchRoomInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.Notify_MatchRoomInfo} Notify_MatchRoomInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Notify_MatchRoomInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Notify_MatchRoomInfo message.
         * @function verify
         * @memberof Auth.Notify_MatchRoomInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Notify_MatchRoomInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.RoomID != null && message.hasOwnProperty("RoomID"))
                if (!$util.isInteger(message.RoomID))
                    return "RoomID: integer expected";
            if (message.Players != null && message.hasOwnProperty("Players")) {
                if (!Array.isArray(message.Players))
                    return "Players: array expected";
                for (var i = 0; i < message.Players.length; ++i) {
                    var error = $root.Auth.Notify_MatchRoomInfo.PlayerInfo.verify(message.Players[i]);
                    if (error)
                        return "Players." + error;
                }
            }
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (!$util.isInteger(message.UserID))
                    return "UserID: integer expected";
            if (message.Password != null && message.hasOwnProperty("Password"))
                if (!$util.isString(message.Password))
                    return "Password: string expected";
            if (message.PlayRule != null && message.hasOwnProperty("PlayRule"))
                if (!$util.isString(message.PlayRule))
                    return "PlayRule: string expected";
            if (message.Host != null && message.hasOwnProperty("Host"))
                if (!$util.isString(message.Host))
                    return "Host: string expected";
            if (message.Port != null && message.hasOwnProperty("Port"))
                if (!$util.isInteger(message.Port))
                    return "Port: integer expected";
            if (message.RoomHisID != null && message.hasOwnProperty("RoomHisID"))
                if (!$util.isInteger(message.RoomHisID))
                    return "RoomHisID: integer expected";
            return null;
        };

        /**
         * Creates a Notify_MatchRoomInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.Notify_MatchRoomInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.Notify_MatchRoomInfo} Notify_MatchRoomInfo
         */
        Notify_MatchRoomInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.Notify_MatchRoomInfo)
                return object;
            var message = new $root.Auth.Notify_MatchRoomInfo();
            if (object.RoomID != null)
                message.RoomID = object.RoomID >>> 0;
            if (object.Players) {
                if (!Array.isArray(object.Players))
                    throw TypeError(".Auth.Notify_MatchRoomInfo.Players: array expected");
                message.Players = [];
                for (var i = 0; i < object.Players.length; ++i) {
                    if (typeof object.Players[i] !== "object")
                        throw TypeError(".Auth.Notify_MatchRoomInfo.Players: object expected");
                    message.Players[i] = $root.Auth.Notify_MatchRoomInfo.PlayerInfo.fromObject(object.Players[i]);
                }
            }
            if (object.UserID != null)
                message.UserID = object.UserID >>> 0;
            if (object.Password != null)
                message.Password = String(object.Password);
            if (object.PlayRule != null)
                message.PlayRule = String(object.PlayRule);
            if (object.Host != null)
                message.Host = String(object.Host);
            if (object.Port != null)
                message.Port = object.Port >>> 0;
            if (object.RoomHisID != null)
                message.RoomHisID = object.RoomHisID >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Notify_MatchRoomInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.Notify_MatchRoomInfo
         * @static
         * @param {Auth.Notify_MatchRoomInfo} message Notify_MatchRoomInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Notify_MatchRoomInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.Players = [];
            if (options.defaults) {
                object.RoomID = 0;
                object.UserID = 0;
                object.Password = "";
                object.PlayRule = "";
                object.Host = "";
                object.Port = 0;
                object.RoomHisID = 0;
            }
            if (message.RoomID != null && message.hasOwnProperty("RoomID"))
                object.RoomID = message.RoomID;
            if (message.Players && message.Players.length) {
                object.Players = [];
                for (var j = 0; j < message.Players.length; ++j)
                    object.Players[j] = $root.Auth.Notify_MatchRoomInfo.PlayerInfo.toObject(message.Players[j], options);
            }
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                object.UserID = message.UserID;
            if (message.Password != null && message.hasOwnProperty("Password"))
                object.Password = message.Password;
            if (message.PlayRule != null && message.hasOwnProperty("PlayRule"))
                object.PlayRule = message.PlayRule;
            if (message.Host != null && message.hasOwnProperty("Host"))
                object.Host = message.Host;
            if (message.Port != null && message.hasOwnProperty("Port"))
                object.Port = message.Port;
            if (message.RoomHisID != null && message.hasOwnProperty("RoomHisID"))
                object.RoomHisID = message.RoomHisID;
            return object;
        };

        /**
         * Converts this Notify_MatchRoomInfo to JSON.
         * @function toJSON
         * @memberof Auth.Notify_MatchRoomInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Notify_MatchRoomInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        Notify_MatchRoomInfo.PlayerInfo = (function() {

            /**
             * Properties of a PlayerInfo.
             * @memberof Auth.Notify_MatchRoomInfo
             * @interface IPlayerInfo
             * @property {number|Long|null} [UserID] PlayerInfo UserID
             * @property {number|null} [SeatID] PlayerInfo SeatID
             */

            /**
             * Constructs a new PlayerInfo.
             * @memberof Auth.Notify_MatchRoomInfo
             * @classdesc Represents a PlayerInfo.
             * @implements IPlayerInfo
             * @constructor
             * @param {Auth.Notify_MatchRoomInfo.IPlayerInfo=} [properties] Properties to set
             */
            function PlayerInfo(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PlayerInfo UserID.
             * @member {number|Long} UserID
             * @memberof Auth.Notify_MatchRoomInfo.PlayerInfo
             * @instance
             */
            PlayerInfo.prototype.UserID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * PlayerInfo SeatID.
             * @member {number} SeatID
             * @memberof Auth.Notify_MatchRoomInfo.PlayerInfo
             * @instance
             */
            PlayerInfo.prototype.SeatID = 0;

            /**
             * Creates a new PlayerInfo instance using the specified properties.
             * @function create
             * @memberof Auth.Notify_MatchRoomInfo.PlayerInfo
             * @static
             * @param {Auth.Notify_MatchRoomInfo.IPlayerInfo=} [properties] Properties to set
             * @returns {Auth.Notify_MatchRoomInfo.PlayerInfo} PlayerInfo instance
             */
            PlayerInfo.create = function create(properties) {
                return new PlayerInfo(properties);
            };

            /**
             * Encodes the specified PlayerInfo message. Does not implicitly {@link Auth.Notify_MatchRoomInfo.PlayerInfo.verify|verify} messages.
             * @function encode
             * @memberof Auth.Notify_MatchRoomInfo.PlayerInfo
             * @static
             * @param {Auth.Notify_MatchRoomInfo.IPlayerInfo} message PlayerInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PlayerInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.UserID != null && message.hasOwnProperty("UserID"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.UserID);
                if (message.SeatID != null && message.hasOwnProperty("SeatID"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.SeatID);
                return writer;
            };

            /**
             * Encodes the specified PlayerInfo message, length delimited. Does not implicitly {@link Auth.Notify_MatchRoomInfo.PlayerInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Auth.Notify_MatchRoomInfo.PlayerInfo
             * @static
             * @param {Auth.Notify_MatchRoomInfo.IPlayerInfo} message PlayerInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PlayerInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PlayerInfo message from the specified reader or buffer.
             * @function decode
             * @memberof Auth.Notify_MatchRoomInfo.PlayerInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Auth.Notify_MatchRoomInfo.PlayerInfo} PlayerInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PlayerInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.Notify_MatchRoomInfo.PlayerInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.UserID = reader.uint64();
                        break;
                    case 2:
                        message.SeatID = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PlayerInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Auth.Notify_MatchRoomInfo.PlayerInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Auth.Notify_MatchRoomInfo.PlayerInfo} PlayerInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PlayerInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PlayerInfo message.
             * @function verify
             * @memberof Auth.Notify_MatchRoomInfo.PlayerInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PlayerInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.UserID != null && message.hasOwnProperty("UserID"))
                    if (!$util.isInteger(message.UserID) && !(message.UserID && $util.isInteger(message.UserID.low) && $util.isInteger(message.UserID.high)))
                        return "UserID: integer|Long expected";
                if (message.SeatID != null && message.hasOwnProperty("SeatID"))
                    if (!$util.isInteger(message.SeatID))
                        return "SeatID: integer expected";
                return null;
            };

            /**
             * Creates a PlayerInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Auth.Notify_MatchRoomInfo.PlayerInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Auth.Notify_MatchRoomInfo.PlayerInfo} PlayerInfo
             */
            PlayerInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.Auth.Notify_MatchRoomInfo.PlayerInfo)
                    return object;
                var message = new $root.Auth.Notify_MatchRoomInfo.PlayerInfo();
                if (object.UserID != null)
                    if ($util.Long)
                        (message.UserID = $util.Long.fromValue(object.UserID)).unsigned = true;
                    else if (typeof object.UserID === "string")
                        message.UserID = parseInt(object.UserID, 10);
                    else if (typeof object.UserID === "number")
                        message.UserID = object.UserID;
                    else if (typeof object.UserID === "object")
                        message.UserID = new $util.LongBits(object.UserID.low >>> 0, object.UserID.high >>> 0).toNumber(true);
                if (object.SeatID != null)
                    message.SeatID = object.SeatID >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a PlayerInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Auth.Notify_MatchRoomInfo.PlayerInfo
             * @static
             * @param {Auth.Notify_MatchRoomInfo.PlayerInfo} message PlayerInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PlayerInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.UserID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.UserID = options.longs === String ? "0" : 0;
                    object.SeatID = 0;
                }
                if (message.UserID != null && message.hasOwnProperty("UserID"))
                    if (typeof message.UserID === "number")
                        object.UserID = options.longs === String ? String(message.UserID) : message.UserID;
                    else
                        object.UserID = options.longs === String ? $util.Long.prototype.toString.call(message.UserID) : options.longs === Number ? new $util.LongBits(message.UserID.low >>> 0, message.UserID.high >>> 0).toNumber(true) : message.UserID;
                if (message.SeatID != null && message.hasOwnProperty("SeatID"))
                    object.SeatID = message.SeatID;
                return object;
            };

            /**
             * Converts this PlayerInfo to JSON.
             * @function toJSON
             * @memberof Auth.Notify_MatchRoomInfo.PlayerInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PlayerInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return PlayerInfo;
        })();

        return Notify_MatchRoomInfo;
    })();

    Auth.CMD_MatchEnter = (function() {

        /**
         * Properties of a CMD_MatchEnter.
         * @memberof Auth
         * @interface ICMD_MatchEnter
         * @property {number|Long|null} [MatchID] CMD_MatchEnter MatchID
         * @property {number|Long|null} [StageID] CMD_MatchEnter StageID
         * @property {number|Long|null} [UserID] CMD_MatchEnter UserID
         */

        /**
         * Constructs a new CMD_MatchEnter.
         * @memberof Auth
         * @classdesc Represents a CMD_MatchEnter.
         * @implements ICMD_MatchEnter
         * @constructor
         * @param {Auth.ICMD_MatchEnter=} [properties] Properties to set
         */
        function CMD_MatchEnter(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_MatchEnter MatchID.
         * @member {number|Long} MatchID
         * @memberof Auth.CMD_MatchEnter
         * @instance
         */
        CMD_MatchEnter.prototype.MatchID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CMD_MatchEnter StageID.
         * @member {number|Long} StageID
         * @memberof Auth.CMD_MatchEnter
         * @instance
         */
        CMD_MatchEnter.prototype.StageID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CMD_MatchEnter UserID.
         * @member {number|Long} UserID
         * @memberof Auth.CMD_MatchEnter
         * @instance
         */
        CMD_MatchEnter.prototype.UserID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new CMD_MatchEnter instance using the specified properties.
         * @function create
         * @memberof Auth.CMD_MatchEnter
         * @static
         * @param {Auth.ICMD_MatchEnter=} [properties] Properties to set
         * @returns {Auth.CMD_MatchEnter} CMD_MatchEnter instance
         */
        CMD_MatchEnter.create = function create(properties) {
            return new CMD_MatchEnter(properties);
        };

        /**
         * Encodes the specified CMD_MatchEnter message. Does not implicitly {@link Auth.CMD_MatchEnter.verify|verify} messages.
         * @function encode
         * @memberof Auth.CMD_MatchEnter
         * @static
         * @param {Auth.ICMD_MatchEnter} message CMD_MatchEnter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_MatchEnter.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.MatchID);
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.StageID);
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.UserID);
            return writer;
        };

        /**
         * Encodes the specified CMD_MatchEnter message, length delimited. Does not implicitly {@link Auth.CMD_MatchEnter.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.CMD_MatchEnter
         * @static
         * @param {Auth.ICMD_MatchEnter} message CMD_MatchEnter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_MatchEnter.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_MatchEnter message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.CMD_MatchEnter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.CMD_MatchEnter} CMD_MatchEnter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_MatchEnter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.CMD_MatchEnter();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.MatchID = reader.uint64();
                    break;
                case 2:
                    message.StageID = reader.uint64();
                    break;
                case 3:
                    message.UserID = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_MatchEnter message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.CMD_MatchEnter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.CMD_MatchEnter} CMD_MatchEnter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_MatchEnter.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_MatchEnter message.
         * @function verify
         * @memberof Auth.CMD_MatchEnter
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_MatchEnter.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                if (!$util.isInteger(message.MatchID) && !(message.MatchID && $util.isInteger(message.MatchID.low) && $util.isInteger(message.MatchID.high)))
                    return "MatchID: integer|Long expected";
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                if (!$util.isInteger(message.StageID) && !(message.StageID && $util.isInteger(message.StageID.low) && $util.isInteger(message.StageID.high)))
                    return "StageID: integer|Long expected";
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (!$util.isInteger(message.UserID) && !(message.UserID && $util.isInteger(message.UserID.low) && $util.isInteger(message.UserID.high)))
                    return "UserID: integer|Long expected";
            return null;
        };

        /**
         * Creates a CMD_MatchEnter message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.CMD_MatchEnter
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.CMD_MatchEnter} CMD_MatchEnter
         */
        CMD_MatchEnter.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.CMD_MatchEnter)
                return object;
            var message = new $root.Auth.CMD_MatchEnter();
            if (object.MatchID != null)
                if ($util.Long)
                    (message.MatchID = $util.Long.fromValue(object.MatchID)).unsigned = true;
                else if (typeof object.MatchID === "string")
                    message.MatchID = parseInt(object.MatchID, 10);
                else if (typeof object.MatchID === "number")
                    message.MatchID = object.MatchID;
                else if (typeof object.MatchID === "object")
                    message.MatchID = new $util.LongBits(object.MatchID.low >>> 0, object.MatchID.high >>> 0).toNumber(true);
            if (object.StageID != null)
                if ($util.Long)
                    (message.StageID = $util.Long.fromValue(object.StageID)).unsigned = true;
                else if (typeof object.StageID === "string")
                    message.StageID = parseInt(object.StageID, 10);
                else if (typeof object.StageID === "number")
                    message.StageID = object.StageID;
                else if (typeof object.StageID === "object")
                    message.StageID = new $util.LongBits(object.StageID.low >>> 0, object.StageID.high >>> 0).toNumber(true);
            if (object.UserID != null)
                if ($util.Long)
                    (message.UserID = $util.Long.fromValue(object.UserID)).unsigned = true;
                else if (typeof object.UserID === "string")
                    message.UserID = parseInt(object.UserID, 10);
                else if (typeof object.UserID === "number")
                    message.UserID = object.UserID;
                else if (typeof object.UserID === "object")
                    message.UserID = new $util.LongBits(object.UserID.low >>> 0, object.UserID.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a CMD_MatchEnter message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.CMD_MatchEnter
         * @static
         * @param {Auth.CMD_MatchEnter} message CMD_MatchEnter
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_MatchEnter.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.MatchID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.MatchID = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.StageID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.StageID = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.UserID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.UserID = options.longs === String ? "0" : 0;
            }
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                if (typeof message.MatchID === "number")
                    object.MatchID = options.longs === String ? String(message.MatchID) : message.MatchID;
                else
                    object.MatchID = options.longs === String ? $util.Long.prototype.toString.call(message.MatchID) : options.longs === Number ? new $util.LongBits(message.MatchID.low >>> 0, message.MatchID.high >>> 0).toNumber(true) : message.MatchID;
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                if (typeof message.StageID === "number")
                    object.StageID = options.longs === String ? String(message.StageID) : message.StageID;
                else
                    object.StageID = options.longs === String ? $util.Long.prototype.toString.call(message.StageID) : options.longs === Number ? new $util.LongBits(message.StageID.low >>> 0, message.StageID.high >>> 0).toNumber(true) : message.StageID;
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (typeof message.UserID === "number")
                    object.UserID = options.longs === String ? String(message.UserID) : message.UserID;
                else
                    object.UserID = options.longs === String ? $util.Long.prototype.toString.call(message.UserID) : options.longs === Number ? new $util.LongBits(message.UserID.low >>> 0, message.UserID.high >>> 0).toNumber(true) : message.UserID;
            return object;
        };

        /**
         * Converts this CMD_MatchEnter to JSON.
         * @function toJSON
         * @memberof Auth.CMD_MatchEnter
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_MatchEnter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CMD_MatchEnter;
    })();

    Auth.RSP_MatchEnter = (function() {

        /**
         * Properties of a RSP_MatchEnter.
         * @memberof Auth
         * @interface IRSP_MatchEnter
         * @property {number|Long|null} [MatchID] RSP_MatchEnter MatchID
         * @property {number|Long|null} [StageID] RSP_MatchEnter StageID
         * @property {number|Long|null} [UserID] RSP_MatchEnter UserID
         * @property {number|null} [ErrorCode] RSP_MatchEnter ErrorCode
         * @property {string|null} [ErrorInfo] RSP_MatchEnter ErrorInfo
         * @property {boolean|null} [IsStart] RSP_MatchEnter IsStart
         * @property {number|null} [CurLoopNo] RSP_MatchEnter CurLoopNo
         * @property {number|null} [UserCnt] RSP_MatchEnter UserCnt
         * @property {number|null} [SignupUserCnt] RSP_MatchEnter SignupUserCnt
         * @property {number|null} [RoomCnt] RSP_MatchEnter RoomCnt
         * @property {number|null} [QuitScore] RSP_MatchEnter QuitScore
         * @property {number|null} [Rank] RSP_MatchEnter Rank
         * @property {number|null} [Score] RSP_MatchEnter Score
         * @property {number|null} [State] RSP_MatchEnter State
         * @property {string|null} [GameName] RSP_MatchEnter GameName
         */

        /**
         * Constructs a new RSP_MatchEnter.
         * @memberof Auth
         * @classdesc Represents a RSP_MatchEnter.
         * @implements IRSP_MatchEnter
         * @constructor
         * @param {Auth.IRSP_MatchEnter=} [properties] Properties to set
         */
        function RSP_MatchEnter(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RSP_MatchEnter MatchID.
         * @member {number|Long} MatchID
         * @memberof Auth.RSP_MatchEnter
         * @instance
         */
        RSP_MatchEnter.prototype.MatchID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RSP_MatchEnter StageID.
         * @member {number|Long} StageID
         * @memberof Auth.RSP_MatchEnter
         * @instance
         */
        RSP_MatchEnter.prototype.StageID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RSP_MatchEnter UserID.
         * @member {number|Long} UserID
         * @memberof Auth.RSP_MatchEnter
         * @instance
         */
        RSP_MatchEnter.prototype.UserID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RSP_MatchEnter ErrorCode.
         * @member {number} ErrorCode
         * @memberof Auth.RSP_MatchEnter
         * @instance
         */
        RSP_MatchEnter.prototype.ErrorCode = 0;

        /**
         * RSP_MatchEnter ErrorInfo.
         * @member {string} ErrorInfo
         * @memberof Auth.RSP_MatchEnter
         * @instance
         */
        RSP_MatchEnter.prototype.ErrorInfo = "";

        /**
         * RSP_MatchEnter IsStart.
         * @member {boolean} IsStart
         * @memberof Auth.RSP_MatchEnter
         * @instance
         */
        RSP_MatchEnter.prototype.IsStart = false;

        /**
         * RSP_MatchEnter CurLoopNo.
         * @member {number} CurLoopNo
         * @memberof Auth.RSP_MatchEnter
         * @instance
         */
        RSP_MatchEnter.prototype.CurLoopNo = 0;

        /**
         * RSP_MatchEnter UserCnt.
         * @member {number} UserCnt
         * @memberof Auth.RSP_MatchEnter
         * @instance
         */
        RSP_MatchEnter.prototype.UserCnt = 0;

        /**
         * RSP_MatchEnter SignupUserCnt.
         * @member {number} SignupUserCnt
         * @memberof Auth.RSP_MatchEnter
         * @instance
         */
        RSP_MatchEnter.prototype.SignupUserCnt = 0;

        /**
         * RSP_MatchEnter RoomCnt.
         * @member {number} RoomCnt
         * @memberof Auth.RSP_MatchEnter
         * @instance
         */
        RSP_MatchEnter.prototype.RoomCnt = 0;

        /**
         * RSP_MatchEnter QuitScore.
         * @member {number} QuitScore
         * @memberof Auth.RSP_MatchEnter
         * @instance
         */
        RSP_MatchEnter.prototype.QuitScore = 0;

        /**
         * RSP_MatchEnter Rank.
         * @member {number} Rank
         * @memberof Auth.RSP_MatchEnter
         * @instance
         */
        RSP_MatchEnter.prototype.Rank = 0;

        /**
         * RSP_MatchEnter Score.
         * @member {number} Score
         * @memberof Auth.RSP_MatchEnter
         * @instance
         */
        RSP_MatchEnter.prototype.Score = 0;

        /**
         * RSP_MatchEnter State.
         * @member {number} State
         * @memberof Auth.RSP_MatchEnter
         * @instance
         */
        RSP_MatchEnter.prototype.State = 0;

        /**
         * RSP_MatchEnter GameName.
         * @member {string} GameName
         * @memberof Auth.RSP_MatchEnter
         * @instance
         */
        RSP_MatchEnter.prototype.GameName = "";

        /**
         * Creates a new RSP_MatchEnter instance using the specified properties.
         * @function create
         * @memberof Auth.RSP_MatchEnter
         * @static
         * @param {Auth.IRSP_MatchEnter=} [properties] Properties to set
         * @returns {Auth.RSP_MatchEnter} RSP_MatchEnter instance
         */
        RSP_MatchEnter.create = function create(properties) {
            return new RSP_MatchEnter(properties);
        };

        /**
         * Encodes the specified RSP_MatchEnter message. Does not implicitly {@link Auth.RSP_MatchEnter.verify|verify} messages.
         * @function encode
         * @memberof Auth.RSP_MatchEnter
         * @static
         * @param {Auth.IRSP_MatchEnter} message RSP_MatchEnter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_MatchEnter.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.MatchID);
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.StageID);
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.UserID);
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.ErrorCode);
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.ErrorInfo);
            if (message.IsStart != null && message.hasOwnProperty("IsStart"))
                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.IsStart);
            if (message.CurLoopNo != null && message.hasOwnProperty("CurLoopNo"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.CurLoopNo);
            if (message.UserCnt != null && message.hasOwnProperty("UserCnt"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.UserCnt);
            if (message.SignupUserCnt != null && message.hasOwnProperty("SignupUserCnt"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.SignupUserCnt);
            if (message.RoomCnt != null && message.hasOwnProperty("RoomCnt"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.RoomCnt);
            if (message.QuitScore != null && message.hasOwnProperty("QuitScore"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.QuitScore);
            if (message.Rank != null && message.hasOwnProperty("Rank"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.Rank);
            if (message.Score != null && message.hasOwnProperty("Score"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.Score);
            if (message.State != null && message.hasOwnProperty("State"))
                writer.uint32(/* id 14, wireType 0 =*/112).int32(message.State);
            if (message.GameName != null && message.hasOwnProperty("GameName"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.GameName);
            return writer;
        };

        /**
         * Encodes the specified RSP_MatchEnter message, length delimited. Does not implicitly {@link Auth.RSP_MatchEnter.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.RSP_MatchEnter
         * @static
         * @param {Auth.IRSP_MatchEnter} message RSP_MatchEnter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_MatchEnter.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RSP_MatchEnter message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.RSP_MatchEnter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.RSP_MatchEnter} RSP_MatchEnter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_MatchEnter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.RSP_MatchEnter();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.MatchID = reader.uint64();
                    break;
                case 2:
                    message.StageID = reader.uint64();
                    break;
                case 3:
                    message.UserID = reader.uint64();
                    break;
                case 4:
                    message.ErrorCode = reader.uint32();
                    break;
                case 5:
                    message.ErrorInfo = reader.string();
                    break;
                case 6:
                    message.IsStart = reader.bool();
                    break;
                case 7:
                    message.CurLoopNo = reader.int32();
                    break;
                case 8:
                    message.UserCnt = reader.int32();
                    break;
                case 9:
                    message.SignupUserCnt = reader.int32();
                    break;
                case 10:
                    message.RoomCnt = reader.int32();
                    break;
                case 11:
                    message.QuitScore = reader.int32();
                    break;
                case 12:
                    message.Rank = reader.int32();
                    break;
                case 13:
                    message.Score = reader.int32();
                    break;
                case 14:
                    message.State = reader.int32();
                    break;
                case 15:
                    message.GameName = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RSP_MatchEnter message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.RSP_MatchEnter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.RSP_MatchEnter} RSP_MatchEnter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_MatchEnter.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RSP_MatchEnter message.
         * @function verify
         * @memberof Auth.RSP_MatchEnter
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RSP_MatchEnter.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                if (!$util.isInteger(message.MatchID) && !(message.MatchID && $util.isInteger(message.MatchID.low) && $util.isInteger(message.MatchID.high)))
                    return "MatchID: integer|Long expected";
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                if (!$util.isInteger(message.StageID) && !(message.StageID && $util.isInteger(message.StageID.low) && $util.isInteger(message.StageID.high)))
                    return "StageID: integer|Long expected";
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (!$util.isInteger(message.UserID) && !(message.UserID && $util.isInteger(message.UserID.low) && $util.isInteger(message.UserID.high)))
                    return "UserID: integer|Long expected";
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                if (!$util.isInteger(message.ErrorCode))
                    return "ErrorCode: integer expected";
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                if (!$util.isString(message.ErrorInfo))
                    return "ErrorInfo: string expected";
            if (message.IsStart != null && message.hasOwnProperty("IsStart"))
                if (typeof message.IsStart !== "boolean")
                    return "IsStart: boolean expected";
            if (message.CurLoopNo != null && message.hasOwnProperty("CurLoopNo"))
                if (!$util.isInteger(message.CurLoopNo))
                    return "CurLoopNo: integer expected";
            if (message.UserCnt != null && message.hasOwnProperty("UserCnt"))
                if (!$util.isInteger(message.UserCnt))
                    return "UserCnt: integer expected";
            if (message.SignupUserCnt != null && message.hasOwnProperty("SignupUserCnt"))
                if (!$util.isInteger(message.SignupUserCnt))
                    return "SignupUserCnt: integer expected";
            if (message.RoomCnt != null && message.hasOwnProperty("RoomCnt"))
                if (!$util.isInteger(message.RoomCnt))
                    return "RoomCnt: integer expected";
            if (message.QuitScore != null && message.hasOwnProperty("QuitScore"))
                if (!$util.isInteger(message.QuitScore))
                    return "QuitScore: integer expected";
            if (message.Rank != null && message.hasOwnProperty("Rank"))
                if (!$util.isInteger(message.Rank))
                    return "Rank: integer expected";
            if (message.Score != null && message.hasOwnProperty("Score"))
                if (!$util.isInteger(message.Score))
                    return "Score: integer expected";
            if (message.State != null && message.hasOwnProperty("State"))
                if (!$util.isInteger(message.State))
                    return "State: integer expected";
            if (message.GameName != null && message.hasOwnProperty("GameName"))
                if (!$util.isString(message.GameName))
                    return "GameName: string expected";
            return null;
        };

        /**
         * Creates a RSP_MatchEnter message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.RSP_MatchEnter
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.RSP_MatchEnter} RSP_MatchEnter
         */
        RSP_MatchEnter.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.RSP_MatchEnter)
                return object;
            var message = new $root.Auth.RSP_MatchEnter();
            if (object.MatchID != null)
                if ($util.Long)
                    (message.MatchID = $util.Long.fromValue(object.MatchID)).unsigned = true;
                else if (typeof object.MatchID === "string")
                    message.MatchID = parseInt(object.MatchID, 10);
                else if (typeof object.MatchID === "number")
                    message.MatchID = object.MatchID;
                else if (typeof object.MatchID === "object")
                    message.MatchID = new $util.LongBits(object.MatchID.low >>> 0, object.MatchID.high >>> 0).toNumber(true);
            if (object.StageID != null)
                if ($util.Long)
                    (message.StageID = $util.Long.fromValue(object.StageID)).unsigned = true;
                else if (typeof object.StageID === "string")
                    message.StageID = parseInt(object.StageID, 10);
                else if (typeof object.StageID === "number")
                    message.StageID = object.StageID;
                else if (typeof object.StageID === "object")
                    message.StageID = new $util.LongBits(object.StageID.low >>> 0, object.StageID.high >>> 0).toNumber(true);
            if (object.UserID != null)
                if ($util.Long)
                    (message.UserID = $util.Long.fromValue(object.UserID)).unsigned = true;
                else if (typeof object.UserID === "string")
                    message.UserID = parseInt(object.UserID, 10);
                else if (typeof object.UserID === "number")
                    message.UserID = object.UserID;
                else if (typeof object.UserID === "object")
                    message.UserID = new $util.LongBits(object.UserID.low >>> 0, object.UserID.high >>> 0).toNumber(true);
            if (object.ErrorCode != null)
                message.ErrorCode = object.ErrorCode >>> 0;
            if (object.ErrorInfo != null)
                message.ErrorInfo = String(object.ErrorInfo);
            if (object.IsStart != null)
                message.IsStart = Boolean(object.IsStart);
            if (object.CurLoopNo != null)
                message.CurLoopNo = object.CurLoopNo | 0;
            if (object.UserCnt != null)
                message.UserCnt = object.UserCnt | 0;
            if (object.SignupUserCnt != null)
                message.SignupUserCnt = object.SignupUserCnt | 0;
            if (object.RoomCnt != null)
                message.RoomCnt = object.RoomCnt | 0;
            if (object.QuitScore != null)
                message.QuitScore = object.QuitScore | 0;
            if (object.Rank != null)
                message.Rank = object.Rank | 0;
            if (object.Score != null)
                message.Score = object.Score | 0;
            if (object.State != null)
                message.State = object.State | 0;
            if (object.GameName != null)
                message.GameName = String(object.GameName);
            return message;
        };

        /**
         * Creates a plain object from a RSP_MatchEnter message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.RSP_MatchEnter
         * @static
         * @param {Auth.RSP_MatchEnter} message RSP_MatchEnter
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RSP_MatchEnter.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.MatchID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.MatchID = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.StageID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.StageID = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.UserID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.UserID = options.longs === String ? "0" : 0;
                object.ErrorCode = 0;
                object.ErrorInfo = "";
                object.IsStart = false;
                object.CurLoopNo = 0;
                object.UserCnt = 0;
                object.SignupUserCnt = 0;
                object.RoomCnt = 0;
                object.QuitScore = 0;
                object.Rank = 0;
                object.Score = 0;
                object.State = 0;
                object.GameName = "";
            }
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                if (typeof message.MatchID === "number")
                    object.MatchID = options.longs === String ? String(message.MatchID) : message.MatchID;
                else
                    object.MatchID = options.longs === String ? $util.Long.prototype.toString.call(message.MatchID) : options.longs === Number ? new $util.LongBits(message.MatchID.low >>> 0, message.MatchID.high >>> 0).toNumber(true) : message.MatchID;
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                if (typeof message.StageID === "number")
                    object.StageID = options.longs === String ? String(message.StageID) : message.StageID;
                else
                    object.StageID = options.longs === String ? $util.Long.prototype.toString.call(message.StageID) : options.longs === Number ? new $util.LongBits(message.StageID.low >>> 0, message.StageID.high >>> 0).toNumber(true) : message.StageID;
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (typeof message.UserID === "number")
                    object.UserID = options.longs === String ? String(message.UserID) : message.UserID;
                else
                    object.UserID = options.longs === String ? $util.Long.prototype.toString.call(message.UserID) : options.longs === Number ? new $util.LongBits(message.UserID.low >>> 0, message.UserID.high >>> 0).toNumber(true) : message.UserID;
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                object.ErrorCode = message.ErrorCode;
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                object.ErrorInfo = message.ErrorInfo;
            if (message.IsStart != null && message.hasOwnProperty("IsStart"))
                object.IsStart = message.IsStart;
            if (message.CurLoopNo != null && message.hasOwnProperty("CurLoopNo"))
                object.CurLoopNo = message.CurLoopNo;
            if (message.UserCnt != null && message.hasOwnProperty("UserCnt"))
                object.UserCnt = message.UserCnt;
            if (message.SignupUserCnt != null && message.hasOwnProperty("SignupUserCnt"))
                object.SignupUserCnt = message.SignupUserCnt;
            if (message.RoomCnt != null && message.hasOwnProperty("RoomCnt"))
                object.RoomCnt = message.RoomCnt;
            if (message.QuitScore != null && message.hasOwnProperty("QuitScore"))
                object.QuitScore = message.QuitScore;
            if (message.Rank != null && message.hasOwnProperty("Rank"))
                object.Rank = message.Rank;
            if (message.Score != null && message.hasOwnProperty("Score"))
                object.Score = message.Score;
            if (message.State != null && message.hasOwnProperty("State"))
                object.State = message.State;
            if (message.GameName != null && message.hasOwnProperty("GameName"))
                object.GameName = message.GameName;
            return object;
        };

        /**
         * Converts this RSP_MatchEnter to JSON.
         * @function toJSON
         * @memberof Auth.RSP_MatchEnter
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RSP_MatchEnter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RSP_MatchEnter;
    })();

    Auth.Notify_Extrusion = (function() {

        /**
         * Properties of a Notify_Extrusion.
         * @memberof Auth
         * @interface INotify_Extrusion
         * @property {number|Long|null} [UserID] Notify_Extrusion UserID
         */

        /**
         * Constructs a new Notify_Extrusion.
         * @memberof Auth
         * @classdesc Represents a Notify_Extrusion.
         * @implements INotify_Extrusion
         * @constructor
         * @param {Auth.INotify_Extrusion=} [properties] Properties to set
         */
        function Notify_Extrusion(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Notify_Extrusion UserID.
         * @member {number|Long} UserID
         * @memberof Auth.Notify_Extrusion
         * @instance
         */
        Notify_Extrusion.prototype.UserID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new Notify_Extrusion instance using the specified properties.
         * @function create
         * @memberof Auth.Notify_Extrusion
         * @static
         * @param {Auth.INotify_Extrusion=} [properties] Properties to set
         * @returns {Auth.Notify_Extrusion} Notify_Extrusion instance
         */
        Notify_Extrusion.create = function create(properties) {
            return new Notify_Extrusion(properties);
        };

        /**
         * Encodes the specified Notify_Extrusion message. Does not implicitly {@link Auth.Notify_Extrusion.verify|verify} messages.
         * @function encode
         * @memberof Auth.Notify_Extrusion
         * @static
         * @param {Auth.INotify_Extrusion} message Notify_Extrusion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Notify_Extrusion.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.UserID);
            return writer;
        };

        /**
         * Encodes the specified Notify_Extrusion message, length delimited. Does not implicitly {@link Auth.Notify_Extrusion.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.Notify_Extrusion
         * @static
         * @param {Auth.INotify_Extrusion} message Notify_Extrusion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Notify_Extrusion.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Notify_Extrusion message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.Notify_Extrusion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.Notify_Extrusion} Notify_Extrusion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Notify_Extrusion.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.Notify_Extrusion();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.UserID = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Notify_Extrusion message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.Notify_Extrusion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.Notify_Extrusion} Notify_Extrusion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Notify_Extrusion.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Notify_Extrusion message.
         * @function verify
         * @memberof Auth.Notify_Extrusion
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Notify_Extrusion.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (!$util.isInteger(message.UserID) && !(message.UserID && $util.isInteger(message.UserID.low) && $util.isInteger(message.UserID.high)))
                    return "UserID: integer|Long expected";
            return null;
        };

        /**
         * Creates a Notify_Extrusion message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.Notify_Extrusion
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.Notify_Extrusion} Notify_Extrusion
         */
        Notify_Extrusion.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.Notify_Extrusion)
                return object;
            var message = new $root.Auth.Notify_Extrusion();
            if (object.UserID != null)
                if ($util.Long)
                    (message.UserID = $util.Long.fromValue(object.UserID)).unsigned = true;
                else if (typeof object.UserID === "string")
                    message.UserID = parseInt(object.UserID, 10);
                else if (typeof object.UserID === "number")
                    message.UserID = object.UserID;
                else if (typeof object.UserID === "object")
                    message.UserID = new $util.LongBits(object.UserID.low >>> 0, object.UserID.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a Notify_Extrusion message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.Notify_Extrusion
         * @static
         * @param {Auth.Notify_Extrusion} message Notify_Extrusion
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Notify_Extrusion.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.UserID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.UserID = options.longs === String ? "0" : 0;
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (typeof message.UserID === "number")
                    object.UserID = options.longs === String ? String(message.UserID) : message.UserID;
                else
                    object.UserID = options.longs === String ? $util.Long.prototype.toString.call(message.UserID) : options.longs === Number ? new $util.LongBits(message.UserID.low >>> 0, message.UserID.high >>> 0).toNumber(true) : message.UserID;
            return object;
        };

        /**
         * Converts this Notify_Extrusion to JSON.
         * @function toJSON
         * @memberof Auth.Notify_Extrusion
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Notify_Extrusion.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Notify_Extrusion;
    })();

    Auth.CMD_MatchQuit = (function() {

        /**
         * Properties of a CMD_MatchQuit.
         * @memberof Auth
         * @interface ICMD_MatchQuit
         * @property {number|Long|null} [MatchID] CMD_MatchQuit MatchID
         * @property {number|Long|null} [StageID] CMD_MatchQuit StageID
         * @property {number|Long|null} [UserID] CMD_MatchQuit UserID
         */

        /**
         * Constructs a new CMD_MatchQuit.
         * @memberof Auth
         * @classdesc Represents a CMD_MatchQuit.
         * @implements ICMD_MatchQuit
         * @constructor
         * @param {Auth.ICMD_MatchQuit=} [properties] Properties to set
         */
        function CMD_MatchQuit(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_MatchQuit MatchID.
         * @member {number|Long} MatchID
         * @memberof Auth.CMD_MatchQuit
         * @instance
         */
        CMD_MatchQuit.prototype.MatchID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CMD_MatchQuit StageID.
         * @member {number|Long} StageID
         * @memberof Auth.CMD_MatchQuit
         * @instance
         */
        CMD_MatchQuit.prototype.StageID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CMD_MatchQuit UserID.
         * @member {number|Long} UserID
         * @memberof Auth.CMD_MatchQuit
         * @instance
         */
        CMD_MatchQuit.prototype.UserID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new CMD_MatchQuit instance using the specified properties.
         * @function create
         * @memberof Auth.CMD_MatchQuit
         * @static
         * @param {Auth.ICMD_MatchQuit=} [properties] Properties to set
         * @returns {Auth.CMD_MatchQuit} CMD_MatchQuit instance
         */
        CMD_MatchQuit.create = function create(properties) {
            return new CMD_MatchQuit(properties);
        };

        /**
         * Encodes the specified CMD_MatchQuit message. Does not implicitly {@link Auth.CMD_MatchQuit.verify|verify} messages.
         * @function encode
         * @memberof Auth.CMD_MatchQuit
         * @static
         * @param {Auth.ICMD_MatchQuit} message CMD_MatchQuit message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_MatchQuit.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.MatchID);
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.StageID);
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.UserID);
            return writer;
        };

        /**
         * Encodes the specified CMD_MatchQuit message, length delimited. Does not implicitly {@link Auth.CMD_MatchQuit.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.CMD_MatchQuit
         * @static
         * @param {Auth.ICMD_MatchQuit} message CMD_MatchQuit message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_MatchQuit.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_MatchQuit message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.CMD_MatchQuit
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.CMD_MatchQuit} CMD_MatchQuit
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_MatchQuit.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.CMD_MatchQuit();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.MatchID = reader.uint64();
                    break;
                case 2:
                    message.StageID = reader.uint64();
                    break;
                case 3:
                    message.UserID = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_MatchQuit message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.CMD_MatchQuit
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.CMD_MatchQuit} CMD_MatchQuit
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_MatchQuit.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_MatchQuit message.
         * @function verify
         * @memberof Auth.CMD_MatchQuit
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_MatchQuit.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                if (!$util.isInteger(message.MatchID) && !(message.MatchID && $util.isInteger(message.MatchID.low) && $util.isInteger(message.MatchID.high)))
                    return "MatchID: integer|Long expected";
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                if (!$util.isInteger(message.StageID) && !(message.StageID && $util.isInteger(message.StageID.low) && $util.isInteger(message.StageID.high)))
                    return "StageID: integer|Long expected";
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (!$util.isInteger(message.UserID) && !(message.UserID && $util.isInteger(message.UserID.low) && $util.isInteger(message.UserID.high)))
                    return "UserID: integer|Long expected";
            return null;
        };

        /**
         * Creates a CMD_MatchQuit message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.CMD_MatchQuit
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.CMD_MatchQuit} CMD_MatchQuit
         */
        CMD_MatchQuit.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.CMD_MatchQuit)
                return object;
            var message = new $root.Auth.CMD_MatchQuit();
            if (object.MatchID != null)
                if ($util.Long)
                    (message.MatchID = $util.Long.fromValue(object.MatchID)).unsigned = true;
                else if (typeof object.MatchID === "string")
                    message.MatchID = parseInt(object.MatchID, 10);
                else if (typeof object.MatchID === "number")
                    message.MatchID = object.MatchID;
                else if (typeof object.MatchID === "object")
                    message.MatchID = new $util.LongBits(object.MatchID.low >>> 0, object.MatchID.high >>> 0).toNumber(true);
            if (object.StageID != null)
                if ($util.Long)
                    (message.StageID = $util.Long.fromValue(object.StageID)).unsigned = true;
                else if (typeof object.StageID === "string")
                    message.StageID = parseInt(object.StageID, 10);
                else if (typeof object.StageID === "number")
                    message.StageID = object.StageID;
                else if (typeof object.StageID === "object")
                    message.StageID = new $util.LongBits(object.StageID.low >>> 0, object.StageID.high >>> 0).toNumber(true);
            if (object.UserID != null)
                if ($util.Long)
                    (message.UserID = $util.Long.fromValue(object.UserID)).unsigned = true;
                else if (typeof object.UserID === "string")
                    message.UserID = parseInt(object.UserID, 10);
                else if (typeof object.UserID === "number")
                    message.UserID = object.UserID;
                else if (typeof object.UserID === "object")
                    message.UserID = new $util.LongBits(object.UserID.low >>> 0, object.UserID.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a CMD_MatchQuit message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.CMD_MatchQuit
         * @static
         * @param {Auth.CMD_MatchQuit} message CMD_MatchQuit
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_MatchQuit.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.MatchID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.MatchID = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.StageID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.StageID = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.UserID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.UserID = options.longs === String ? "0" : 0;
            }
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                if (typeof message.MatchID === "number")
                    object.MatchID = options.longs === String ? String(message.MatchID) : message.MatchID;
                else
                    object.MatchID = options.longs === String ? $util.Long.prototype.toString.call(message.MatchID) : options.longs === Number ? new $util.LongBits(message.MatchID.low >>> 0, message.MatchID.high >>> 0).toNumber(true) : message.MatchID;
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                if (typeof message.StageID === "number")
                    object.StageID = options.longs === String ? String(message.StageID) : message.StageID;
                else
                    object.StageID = options.longs === String ? $util.Long.prototype.toString.call(message.StageID) : options.longs === Number ? new $util.LongBits(message.StageID.low >>> 0, message.StageID.high >>> 0).toNumber(true) : message.StageID;
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (typeof message.UserID === "number")
                    object.UserID = options.longs === String ? String(message.UserID) : message.UserID;
                else
                    object.UserID = options.longs === String ? $util.Long.prototype.toString.call(message.UserID) : options.longs === Number ? new $util.LongBits(message.UserID.low >>> 0, message.UserID.high >>> 0).toNumber(true) : message.UserID;
            return object;
        };

        /**
         * Converts this CMD_MatchQuit to JSON.
         * @function toJSON
         * @memberof Auth.CMD_MatchQuit
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_MatchQuit.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CMD_MatchQuit;
    })();

    Auth.RSP_MatchQuit = (function() {

        /**
         * Properties of a RSP_MatchQuit.
         * @memberof Auth
         * @interface IRSP_MatchQuit
         * @property {number|Long|null} [MatchID] RSP_MatchQuit MatchID
         * @property {number|Long|null} [StageID] RSP_MatchQuit StageID
         * @property {number|Long|null} [UserID] RSP_MatchQuit UserID
         * @property {number|null} [ErrorCode] RSP_MatchQuit ErrorCode
         * @property {string|null} [ErrorInfo] RSP_MatchQuit ErrorInfo
         */

        /**
         * Constructs a new RSP_MatchQuit.
         * @memberof Auth
         * @classdesc Represents a RSP_MatchQuit.
         * @implements IRSP_MatchQuit
         * @constructor
         * @param {Auth.IRSP_MatchQuit=} [properties] Properties to set
         */
        function RSP_MatchQuit(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RSP_MatchQuit MatchID.
         * @member {number|Long} MatchID
         * @memberof Auth.RSP_MatchQuit
         * @instance
         */
        RSP_MatchQuit.prototype.MatchID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RSP_MatchQuit StageID.
         * @member {number|Long} StageID
         * @memberof Auth.RSP_MatchQuit
         * @instance
         */
        RSP_MatchQuit.prototype.StageID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RSP_MatchQuit UserID.
         * @member {number|Long} UserID
         * @memberof Auth.RSP_MatchQuit
         * @instance
         */
        RSP_MatchQuit.prototype.UserID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RSP_MatchQuit ErrorCode.
         * @member {number} ErrorCode
         * @memberof Auth.RSP_MatchQuit
         * @instance
         */
        RSP_MatchQuit.prototype.ErrorCode = 0;

        /**
         * RSP_MatchQuit ErrorInfo.
         * @member {string} ErrorInfo
         * @memberof Auth.RSP_MatchQuit
         * @instance
         */
        RSP_MatchQuit.prototype.ErrorInfo = "";

        /**
         * Creates a new RSP_MatchQuit instance using the specified properties.
         * @function create
         * @memberof Auth.RSP_MatchQuit
         * @static
         * @param {Auth.IRSP_MatchQuit=} [properties] Properties to set
         * @returns {Auth.RSP_MatchQuit} RSP_MatchQuit instance
         */
        RSP_MatchQuit.create = function create(properties) {
            return new RSP_MatchQuit(properties);
        };

        /**
         * Encodes the specified RSP_MatchQuit message. Does not implicitly {@link Auth.RSP_MatchQuit.verify|verify} messages.
         * @function encode
         * @memberof Auth.RSP_MatchQuit
         * @static
         * @param {Auth.IRSP_MatchQuit} message RSP_MatchQuit message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_MatchQuit.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.MatchID);
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.StageID);
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.UserID);
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.ErrorCode);
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.ErrorInfo);
            return writer;
        };

        /**
         * Encodes the specified RSP_MatchQuit message, length delimited. Does not implicitly {@link Auth.RSP_MatchQuit.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.RSP_MatchQuit
         * @static
         * @param {Auth.IRSP_MatchQuit} message RSP_MatchQuit message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_MatchQuit.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RSP_MatchQuit message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.RSP_MatchQuit
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.RSP_MatchQuit} RSP_MatchQuit
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_MatchQuit.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.RSP_MatchQuit();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.MatchID = reader.uint64();
                    break;
                case 2:
                    message.StageID = reader.uint64();
                    break;
                case 3:
                    message.UserID = reader.uint64();
                    break;
                case 4:
                    message.ErrorCode = reader.int32();
                    break;
                case 5:
                    message.ErrorInfo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RSP_MatchQuit message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.RSP_MatchQuit
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.RSP_MatchQuit} RSP_MatchQuit
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_MatchQuit.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RSP_MatchQuit message.
         * @function verify
         * @memberof Auth.RSP_MatchQuit
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RSP_MatchQuit.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                if (!$util.isInteger(message.MatchID) && !(message.MatchID && $util.isInteger(message.MatchID.low) && $util.isInteger(message.MatchID.high)))
                    return "MatchID: integer|Long expected";
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                if (!$util.isInteger(message.StageID) && !(message.StageID && $util.isInteger(message.StageID.low) && $util.isInteger(message.StageID.high)))
                    return "StageID: integer|Long expected";
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (!$util.isInteger(message.UserID) && !(message.UserID && $util.isInteger(message.UserID.low) && $util.isInteger(message.UserID.high)))
                    return "UserID: integer|Long expected";
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                if (!$util.isInteger(message.ErrorCode))
                    return "ErrorCode: integer expected";
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                if (!$util.isString(message.ErrorInfo))
                    return "ErrorInfo: string expected";
            return null;
        };

        /**
         * Creates a RSP_MatchQuit message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.RSP_MatchQuit
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.RSP_MatchQuit} RSP_MatchQuit
         */
        RSP_MatchQuit.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.RSP_MatchQuit)
                return object;
            var message = new $root.Auth.RSP_MatchQuit();
            if (object.MatchID != null)
                if ($util.Long)
                    (message.MatchID = $util.Long.fromValue(object.MatchID)).unsigned = true;
                else if (typeof object.MatchID === "string")
                    message.MatchID = parseInt(object.MatchID, 10);
                else if (typeof object.MatchID === "number")
                    message.MatchID = object.MatchID;
                else if (typeof object.MatchID === "object")
                    message.MatchID = new $util.LongBits(object.MatchID.low >>> 0, object.MatchID.high >>> 0).toNumber(true);
            if (object.StageID != null)
                if ($util.Long)
                    (message.StageID = $util.Long.fromValue(object.StageID)).unsigned = true;
                else if (typeof object.StageID === "string")
                    message.StageID = parseInt(object.StageID, 10);
                else if (typeof object.StageID === "number")
                    message.StageID = object.StageID;
                else if (typeof object.StageID === "object")
                    message.StageID = new $util.LongBits(object.StageID.low >>> 0, object.StageID.high >>> 0).toNumber(true);
            if (object.UserID != null)
                if ($util.Long)
                    (message.UserID = $util.Long.fromValue(object.UserID)).unsigned = true;
                else if (typeof object.UserID === "string")
                    message.UserID = parseInt(object.UserID, 10);
                else if (typeof object.UserID === "number")
                    message.UserID = object.UserID;
                else if (typeof object.UserID === "object")
                    message.UserID = new $util.LongBits(object.UserID.low >>> 0, object.UserID.high >>> 0).toNumber(true);
            if (object.ErrorCode != null)
                message.ErrorCode = object.ErrorCode | 0;
            if (object.ErrorInfo != null)
                message.ErrorInfo = String(object.ErrorInfo);
            return message;
        };

        /**
         * Creates a plain object from a RSP_MatchQuit message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.RSP_MatchQuit
         * @static
         * @param {Auth.RSP_MatchQuit} message RSP_MatchQuit
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RSP_MatchQuit.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.MatchID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.MatchID = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.StageID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.StageID = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.UserID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.UserID = options.longs === String ? "0" : 0;
                object.ErrorCode = 0;
                object.ErrorInfo = "";
            }
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                if (typeof message.MatchID === "number")
                    object.MatchID = options.longs === String ? String(message.MatchID) : message.MatchID;
                else
                    object.MatchID = options.longs === String ? $util.Long.prototype.toString.call(message.MatchID) : options.longs === Number ? new $util.LongBits(message.MatchID.low >>> 0, message.MatchID.high >>> 0).toNumber(true) : message.MatchID;
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                if (typeof message.StageID === "number")
                    object.StageID = options.longs === String ? String(message.StageID) : message.StageID;
                else
                    object.StageID = options.longs === String ? $util.Long.prototype.toString.call(message.StageID) : options.longs === Number ? new $util.LongBits(message.StageID.low >>> 0, message.StageID.high >>> 0).toNumber(true) : message.StageID;
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (typeof message.UserID === "number")
                    object.UserID = options.longs === String ? String(message.UserID) : message.UserID;
                else
                    object.UserID = options.longs === String ? $util.Long.prototype.toString.call(message.UserID) : options.longs === Number ? new $util.LongBits(message.UserID.low >>> 0, message.UserID.high >>> 0).toNumber(true) : message.UserID;
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                object.ErrorCode = message.ErrorCode;
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                object.ErrorInfo = message.ErrorInfo;
            return object;
        };

        /**
         * Converts this RSP_MatchQuit to JSON.
         * @function toJSON
         * @memberof Auth.RSP_MatchQuit
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RSP_MatchQuit.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RSP_MatchQuit;
    })();

    Auth.CMD_MatchReady = (function() {

        /**
         * Properties of a CMD_MatchReady.
         * @memberof Auth
         * @interface ICMD_MatchReady
         * @property {number|Long|null} [MatchID] CMD_MatchReady MatchID
         * @property {number|Long|null} [StageID] CMD_MatchReady StageID
         * @property {number|Long|null} [UserID] CMD_MatchReady UserID
         */

        /**
         * Constructs a new CMD_MatchReady.
         * @memberof Auth
         * @classdesc Represents a CMD_MatchReady.
         * @implements ICMD_MatchReady
         * @constructor
         * @param {Auth.ICMD_MatchReady=} [properties] Properties to set
         */
        function CMD_MatchReady(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CMD_MatchReady MatchID.
         * @member {number|Long} MatchID
         * @memberof Auth.CMD_MatchReady
         * @instance
         */
        CMD_MatchReady.prototype.MatchID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CMD_MatchReady StageID.
         * @member {number|Long} StageID
         * @memberof Auth.CMD_MatchReady
         * @instance
         */
        CMD_MatchReady.prototype.StageID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CMD_MatchReady UserID.
         * @member {number|Long} UserID
         * @memberof Auth.CMD_MatchReady
         * @instance
         */
        CMD_MatchReady.prototype.UserID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new CMD_MatchReady instance using the specified properties.
         * @function create
         * @memberof Auth.CMD_MatchReady
         * @static
         * @param {Auth.ICMD_MatchReady=} [properties] Properties to set
         * @returns {Auth.CMD_MatchReady} CMD_MatchReady instance
         */
        CMD_MatchReady.create = function create(properties) {
            return new CMD_MatchReady(properties);
        };

        /**
         * Encodes the specified CMD_MatchReady message. Does not implicitly {@link Auth.CMD_MatchReady.verify|verify} messages.
         * @function encode
         * @memberof Auth.CMD_MatchReady
         * @static
         * @param {Auth.ICMD_MatchReady} message CMD_MatchReady message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_MatchReady.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.MatchID);
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.StageID);
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.UserID);
            return writer;
        };

        /**
         * Encodes the specified CMD_MatchReady message, length delimited. Does not implicitly {@link Auth.CMD_MatchReady.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.CMD_MatchReady
         * @static
         * @param {Auth.ICMD_MatchReady} message CMD_MatchReady message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CMD_MatchReady.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CMD_MatchReady message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.CMD_MatchReady
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.CMD_MatchReady} CMD_MatchReady
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_MatchReady.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.CMD_MatchReady();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.MatchID = reader.uint64();
                    break;
                case 2:
                    message.StageID = reader.uint64();
                    break;
                case 3:
                    message.UserID = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CMD_MatchReady message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.CMD_MatchReady
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.CMD_MatchReady} CMD_MatchReady
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CMD_MatchReady.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CMD_MatchReady message.
         * @function verify
         * @memberof Auth.CMD_MatchReady
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CMD_MatchReady.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                if (!$util.isInteger(message.MatchID) && !(message.MatchID && $util.isInteger(message.MatchID.low) && $util.isInteger(message.MatchID.high)))
                    return "MatchID: integer|Long expected";
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                if (!$util.isInteger(message.StageID) && !(message.StageID && $util.isInteger(message.StageID.low) && $util.isInteger(message.StageID.high)))
                    return "StageID: integer|Long expected";
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (!$util.isInteger(message.UserID) && !(message.UserID && $util.isInteger(message.UserID.low) && $util.isInteger(message.UserID.high)))
                    return "UserID: integer|Long expected";
            return null;
        };

        /**
         * Creates a CMD_MatchReady message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.CMD_MatchReady
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.CMD_MatchReady} CMD_MatchReady
         */
        CMD_MatchReady.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.CMD_MatchReady)
                return object;
            var message = new $root.Auth.CMD_MatchReady();
            if (object.MatchID != null)
                if ($util.Long)
                    (message.MatchID = $util.Long.fromValue(object.MatchID)).unsigned = true;
                else if (typeof object.MatchID === "string")
                    message.MatchID = parseInt(object.MatchID, 10);
                else if (typeof object.MatchID === "number")
                    message.MatchID = object.MatchID;
                else if (typeof object.MatchID === "object")
                    message.MatchID = new $util.LongBits(object.MatchID.low >>> 0, object.MatchID.high >>> 0).toNumber(true);
            if (object.StageID != null)
                if ($util.Long)
                    (message.StageID = $util.Long.fromValue(object.StageID)).unsigned = true;
                else if (typeof object.StageID === "string")
                    message.StageID = parseInt(object.StageID, 10);
                else if (typeof object.StageID === "number")
                    message.StageID = object.StageID;
                else if (typeof object.StageID === "object")
                    message.StageID = new $util.LongBits(object.StageID.low >>> 0, object.StageID.high >>> 0).toNumber(true);
            if (object.UserID != null)
                if ($util.Long)
                    (message.UserID = $util.Long.fromValue(object.UserID)).unsigned = true;
                else if (typeof object.UserID === "string")
                    message.UserID = parseInt(object.UserID, 10);
                else if (typeof object.UserID === "number")
                    message.UserID = object.UserID;
                else if (typeof object.UserID === "object")
                    message.UserID = new $util.LongBits(object.UserID.low >>> 0, object.UserID.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a CMD_MatchReady message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.CMD_MatchReady
         * @static
         * @param {Auth.CMD_MatchReady} message CMD_MatchReady
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CMD_MatchReady.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.MatchID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.MatchID = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.StageID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.StageID = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.UserID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.UserID = options.longs === String ? "0" : 0;
            }
            if (message.MatchID != null && message.hasOwnProperty("MatchID"))
                if (typeof message.MatchID === "number")
                    object.MatchID = options.longs === String ? String(message.MatchID) : message.MatchID;
                else
                    object.MatchID = options.longs === String ? $util.Long.prototype.toString.call(message.MatchID) : options.longs === Number ? new $util.LongBits(message.MatchID.low >>> 0, message.MatchID.high >>> 0).toNumber(true) : message.MatchID;
            if (message.StageID != null && message.hasOwnProperty("StageID"))
                if (typeof message.StageID === "number")
                    object.StageID = options.longs === String ? String(message.StageID) : message.StageID;
                else
                    object.StageID = options.longs === String ? $util.Long.prototype.toString.call(message.StageID) : options.longs === Number ? new $util.LongBits(message.StageID.low >>> 0, message.StageID.high >>> 0).toNumber(true) : message.StageID;
            if (message.UserID != null && message.hasOwnProperty("UserID"))
                if (typeof message.UserID === "number")
                    object.UserID = options.longs === String ? String(message.UserID) : message.UserID;
                else
                    object.UserID = options.longs === String ? $util.Long.prototype.toString.call(message.UserID) : options.longs === Number ? new $util.LongBits(message.UserID.low >>> 0, message.UserID.high >>> 0).toNumber(true) : message.UserID;
            return object;
        };

        /**
         * Converts this CMD_MatchReady to JSON.
         * @function toJSON
         * @memberof Auth.CMD_MatchReady
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CMD_MatchReady.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CMD_MatchReady;
    })();

    Auth.RSP_MatchReady = (function() {

        /**
         * Properties of a RSP_MatchReady.
         * @memberof Auth
         * @interface IRSP_MatchReady
         * @property {number} ErrorCode RSP_MatchReady ErrorCode
         * @property {string|null} [ErrorInfo] RSP_MatchReady ErrorInfo
         */

        /**
         * Constructs a new RSP_MatchReady.
         * @memberof Auth
         * @classdesc Represents a RSP_MatchReady.
         * @implements IRSP_MatchReady
         * @constructor
         * @param {Auth.IRSP_MatchReady=} [properties] Properties to set
         */
        function RSP_MatchReady(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RSP_MatchReady ErrorCode.
         * @member {number} ErrorCode
         * @memberof Auth.RSP_MatchReady
         * @instance
         */
        RSP_MatchReady.prototype.ErrorCode = 0;

        /**
         * RSP_MatchReady ErrorInfo.
         * @member {string} ErrorInfo
         * @memberof Auth.RSP_MatchReady
         * @instance
         */
        RSP_MatchReady.prototype.ErrorInfo = "";

        /**
         * Creates a new RSP_MatchReady instance using the specified properties.
         * @function create
         * @memberof Auth.RSP_MatchReady
         * @static
         * @param {Auth.IRSP_MatchReady=} [properties] Properties to set
         * @returns {Auth.RSP_MatchReady} RSP_MatchReady instance
         */
        RSP_MatchReady.create = function create(properties) {
            return new RSP_MatchReady(properties);
        };

        /**
         * Encodes the specified RSP_MatchReady message. Does not implicitly {@link Auth.RSP_MatchReady.verify|verify} messages.
         * @function encode
         * @memberof Auth.RSP_MatchReady
         * @static
         * @param {Auth.IRSP_MatchReady} message RSP_MatchReady message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_MatchReady.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ErrorCode);
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.ErrorInfo);
            return writer;
        };

        /**
         * Encodes the specified RSP_MatchReady message, length delimited. Does not implicitly {@link Auth.RSP_MatchReady.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.RSP_MatchReady
         * @static
         * @param {Auth.IRSP_MatchReady} message RSP_MatchReady message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RSP_MatchReady.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RSP_MatchReady message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.RSP_MatchReady
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.RSP_MatchReady} RSP_MatchReady
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_MatchReady.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.RSP_MatchReady();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ErrorCode = reader.int32();
                    break;
                case 2:
                    message.ErrorInfo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("ErrorCode"))
                throw $util.ProtocolError("missing required 'ErrorCode'", { instance: message });
            return message;
        };

        /**
         * Decodes a RSP_MatchReady message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.RSP_MatchReady
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.RSP_MatchReady} RSP_MatchReady
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RSP_MatchReady.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RSP_MatchReady message.
         * @function verify
         * @memberof Auth.RSP_MatchReady
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RSP_MatchReady.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.ErrorCode))
                return "ErrorCode: integer expected";
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                if (!$util.isString(message.ErrorInfo))
                    return "ErrorInfo: string expected";
            return null;
        };

        /**
         * Creates a RSP_MatchReady message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.RSP_MatchReady
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.RSP_MatchReady} RSP_MatchReady
         */
        RSP_MatchReady.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.RSP_MatchReady)
                return object;
            var message = new $root.Auth.RSP_MatchReady();
            if (object.ErrorCode != null)
                message.ErrorCode = object.ErrorCode | 0;
            if (object.ErrorInfo != null)
                message.ErrorInfo = String(object.ErrorInfo);
            return message;
        };

        /**
         * Creates a plain object from a RSP_MatchReady message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.RSP_MatchReady
         * @static
         * @param {Auth.RSP_MatchReady} message RSP_MatchReady
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RSP_MatchReady.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.ErrorCode = 0;
                object.ErrorInfo = "";
            }
            if (message.ErrorCode != null && message.hasOwnProperty("ErrorCode"))
                object.ErrorCode = message.ErrorCode;
            if (message.ErrorInfo != null && message.hasOwnProperty("ErrorInfo"))
                object.ErrorInfo = message.ErrorInfo;
            return object;
        };

        /**
         * Converts this RSP_MatchReady to JSON.
         * @function toJSON
         * @memberof Auth.RSP_MatchReady
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RSP_MatchReady.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RSP_MatchReady;
    })();

    Auth.GameMsg = (function() {

        /**
         * Properties of a GameMsg.
         * @memberof Auth
         * @interface IGameMsg
         * @property {Uint8Array|null} [body] GameMsg body
         */

        /**
         * Constructs a new GameMsg.
         * @memberof Auth
         * @classdesc Represents a GameMsg.
         * @implements IGameMsg
         * @constructor
         * @param {Auth.IGameMsg=} [properties] Properties to set
         */
        function GameMsg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GameMsg body.
         * @member {Uint8Array} body
         * @memberof Auth.GameMsg
         * @instance
         */
        GameMsg.prototype.body = $util.newBuffer([]);

        /**
         * Creates a new GameMsg instance using the specified properties.
         * @function create
         * @memberof Auth.GameMsg
         * @static
         * @param {Auth.IGameMsg=} [properties] Properties to set
         * @returns {Auth.GameMsg} GameMsg instance
         */
        GameMsg.create = function create(properties) {
            return new GameMsg(properties);
        };

        /**
         * Encodes the specified GameMsg message. Does not implicitly {@link Auth.GameMsg.verify|verify} messages.
         * @function encode
         * @memberof Auth.GameMsg
         * @static
         * @param {Auth.IGameMsg} message GameMsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameMsg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.body != null && message.hasOwnProperty("body"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.body);
            return writer;
        };

        /**
         * Encodes the specified GameMsg message, length delimited. Does not implicitly {@link Auth.GameMsg.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Auth.GameMsg
         * @static
         * @param {Auth.IGameMsg} message GameMsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameMsg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GameMsg message from the specified reader or buffer.
         * @function decode
         * @memberof Auth.GameMsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Auth.GameMsg} GameMsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameMsg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth.GameMsg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.body = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GameMsg message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Auth.GameMsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Auth.GameMsg} GameMsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameMsg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GameMsg message.
         * @function verify
         * @memberof Auth.GameMsg
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GameMsg.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.body != null && message.hasOwnProperty("body"))
                if (!(message.body && typeof message.body.length === "number" || $util.isString(message.body)))
                    return "body: buffer expected";
            return null;
        };

        /**
         * Creates a GameMsg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Auth.GameMsg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Auth.GameMsg} GameMsg
         */
        GameMsg.fromObject = function fromObject(object) {
            if (object instanceof $root.Auth.GameMsg)
                return object;
            var message = new $root.Auth.GameMsg();
            if (object.body != null)
                if (typeof object.body === "string")
                    $util.base64.decode(object.body, message.body = $util.newBuffer($util.base64.length(object.body)), 0);
                else if (object.body.length)
                    message.body = object.body;
            return message;
        };

        /**
         * Creates a plain object from a GameMsg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Auth.GameMsg
         * @static
         * @param {Auth.GameMsg} message GameMsg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GameMsg.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.body = "";
                else {
                    object.body = [];
                    if (options.bytes !== Array)
                        object.body = $util.newBuffer(object.body);
                }
            if (message.body != null && message.hasOwnProperty("body"))
                object.body = options.bytes === String ? $util.base64.encode(message.body, 0, message.body.length) : options.bytes === Array ? Array.prototype.slice.call(message.body) : message.body;
            return object;
        };

        /**
         * Converts this GameMsg to JSON.
         * @function toJSON
         * @memberof Auth.GameMsg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GameMsg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GameMsg;
    })();

    return Auth;
})();

module.exports = $root;
